
import React, { Component } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { get, post, getFreshToken, put, del } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import '../adminDash.css';
import './ShowDevices.css';
import globalVariables from "../../custom_libraries/globalVariables";
import withNavigate from "../../Global_files/WithNavigate";

import Navigationbar from '../Navigationbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
//import mui components to inhance the look
import { Button, Snackbar, Alert } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
// import BusinessIcon from '@mui/icons-material/Business';
// import MapIcon from '@mui/icons-material/Map';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Select from 'react-select';
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,

  TextField,
  IconButton,
  Typography,
  Box, Menu, MenuItem
} from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import LiveTvIcon from '@mui/icons-material/LiveTv';
import CancelIcon from '@mui/icons-material/Cancel';
// import StorageIcon from '@mui/icons-material/Storage';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import FolderIcon from '@mui/icons-material/Folder';
// import VideocamIcon from '@mui/icons-material/Videocam';
// import DvrIcon from '@mui/icons-material/Dvr';
// import DnsIcon from '@mui/icons-material/Dns';
import DeviceIcon from '../../assets/icons8-bullet-camera-gray-24 .png'
// import SyncIcon from '../../assets/icons8-synchronize-48.png';
import SyncIcon from '../../assets/icons8-synchronize-96.png';
// import { Link } from 'react-router-dom';
import DialogBox from '../DialogBox';
import { DateTime } from "luxon";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import passwordEye from '../../assets/icons8-eye-64.png';
import LinearProgress from '@mui/material/LinearProgress';
import FolderSpecialRoundedIcon from '@mui/icons-material/FolderSpecialRounded';
import { KeyboardArrowDown, KeyboardArrowUp, ThreeSixty } from '@mui/icons-material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Switch } from '@mui/material';
import InternetConnectionDetector from "../../Global_files/InternetConnectionDetector";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import BlockRoundedIcon from '../../assets/icons8-block-64.png';
import VpnLockRoundedIcon from '@mui/icons-material/VpnLockRounded';
import LinkIcon from '../../assets/icons8-worldwide-location-50.png';
import UpdateIcon from '@mui/icons-material/Update';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ClearIcon from '@mui/icons-material/Clear';
import DeletepagingDeviceIcon from '../../assets/delete_paging_device_speaker_icon.png';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

{/* <DoNotDisturbOnIcon color="warning" /> */}

class ShowDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSite: null,
      selectedSiteInfo: null,
      cameras: [],
      devices: [],
      searchInput: "",
      deviceSearchInput: "",
      currentPage: 1,
      rowsPerPage: 5,
      device_details: [],

      expandedRow: null, // Track which row is expanded
      nestedExpandedRow: null,
      ref_img_created_time: null,
      ref_img_next_inspection: "",
      latest_img_taken_at: null,
      capturedImageBlob: null,
      capturedLatestImageBlob: null,
      currentTime_of_device: null,
      selectedCamera: null,
      isPopupVisible: false,
      activeSection: 'reference',	// State to track the active collapsible section

      deviceId: '',
      snackbar_msg: '',
      open_snackbar: false,

      confirmDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      // open_MuteUnmute_Dialogue: false,
      mute: false,
      selectedCameraId: null,
      // muteResponseMessage: '',
      error2: false,
      success2: false,
      success: false,

      image1: '',
      ref_img_id: null,
      image2: '',

      site_list: [],
      filteredDevices: [], // Devices to display based on filter

      refreshSystemOverviewstatuscard: false,

      //add site----
      toggleAddSite: false,
      sitename: '',
      address: '',
      city:'',
      street:'',
      zip:'',
      country:'',
      state:'',
      organisationName: '',
      warning_site: false,
      success_site: false,
      error_site: false,
      open_progress_bar: false,
      open_progress_bar1:false,
      user_name:'',
      user_type:'',
      client_list:[],
      selected_Customers:[],
      cust_contact_no: null,
      police_dept_contact_no: null,
      fire_dept_contact_no: null,
      //--edit site--------
      editToggle: false,
      siteid: '',
      organisation_name: '',
      edit_sitename: '',
      edit_address: '',
      edit_city : "",
      edit_zip : "",
      edit_state : "",
      edit_country : "",
      edit_map_link : "",
      edit_organisation_name: '',
      edit_selected_Customers_list:[],
      toggleAddDevice : false,
      edit_gas_paging_devices: [
        {
          mac_address: "",
          device_type: "",
          description: ""
        }
      ],
      map_link: "",
      map_link_error: "",

      //-----Add Device
      deviceName :'',
      deviceType : '',
      client :'',
      ipAddress : null,
      protocol : '',
      portNumber : null,
      rtsp_port : null,
      deviceUsername : '',
      devicePassword : '',
      warning_device : false,
      warning1_device : false,
      error_device : false,
      error1_device : false,
      success_device : false,
      //site_list,
      device_type_list  : [],
      showModal : false,
      showTestModal : false,
      responseMessage : "",
      response_data  : {},
      anchorEl: null,
      anchorE2:null,

      //--edit device
      editDeviceToggle:false,
      Selected_Device_Id : '',
      EditDeviceName: "",
      EditDeviceType: "", // default null to select from list of valid options only
      EditIpAddress: "",
      EditProtocol: "",
      EditPortNumber: "",
      EditRTSPAddress:"",
      EditDeviceUsername: "",
      EditDevicePassword: "",
      success_device_edit: false,
      error_device_edit : false,
      error: false,
      passwordShown:false,
      selectedDevice: null,  // Store the selected device
      selectedDeviceID:null,

      //--Add group---
      anchorE3:null,
      AddGroupToggle:false,
      group_name: '',
      parent_group: [],

      //-- add device polling
      ws: null,
      taskQueue: [],
      currentTaskIndex: 0,
      taskStatus: [],
      taskResults: {},
      taskIds:{},
      notFoundCount:0,
      channelList:[],
      final_channel_list:[],
      loading: true,

      groups_list : [],
      group_id:'',
      selectedgroup:null,
      selectedGroupInfo:null,
      site_list_by_group:[],
      subgroup_list_by_group:[],
      selectedGroupForMenu: null, //selected group name to edit of delete it.

      EditGroupToggle: false,
      EditGroupName: '',
      EditParentGroup: [],
      initialParentGroup: [],
      editGroupSites: [],
      groupIdToEditInfo: null,
      selectedSubgroup:null,
      groupHierarchy: {}, // New object to hold nested group/subgroup data
      editGroupRespMessage:"",
      expandedGroupId:[],
      expandedSiteId:[],
      expandedGroups: {},

      selectedGroupId: '', // default is empty
      error_group: false,
      success_group: false,
      showDiskDetails: false,

      stopRetry: false,
      showDeviceUserList:false,
      selectedDeviceForUserList:null,
      expandedSite: null,
      searchDevices:[],
      search_devices_list:[],
      // siteStatusMap: true,      // { [siteId]: true | false }
      errors: {},

      toggleAddSingleCamera: false,
      camera_protocol: '',
      camera_ipAddress: '',
      camera_rtsp_port: '',
      cameraUsername: '',
      cameraPassword: '',
      CameraDeviceName: '',
      CameraName: '',
      cameraPortNumber:'',
      rtspStreamParameter: '',
      success_camera: false,
      success_camera_existing_site: false,
      error_camera: false,
      warning_camera: false,
      warning1_camera: false,
      rtsp_cameras_devices: [],
      global_alarm_status: false,
      rtsp_responseMessage:'',

      cameraOption: "", // radio button values: 'newSite' or 'existingSite'
      existingSite: "",
      selectedDeviceName: "",
      response_message:"",
      anchorE4 : null,
      rtsp_test_response_data:{},
      storedLogo: localStorage.getItem("USER_LOGO") || null,
      group_message:"",
      filteredGroups: [],    // filtered result for UI
      searchText: "",
      cust_contact_no_1: "",
      edit_cust_contact_no_1: "",
      gas_paging_devices: [
      {
        mac_address: "",
        device_type: "",
        description: ""
      }
    ],
    isPaging: false,
    openPagingModal: false,
    paging_audio_files:[],
    selectedAudioFile:"",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.connectWebSocket();
    this.getGroupsList(); //uncomment for grouping feature
    this.getSitesList();
    //Add site---------
    this.setState({ user_name : localStorage.getItem(globalVariables.USER_NAME)});
            //  const timezones = moment.tz.names();
            // this.setState({ timezones });
            const user_type = localStorage.getItem(globalVariables.USER_TYPE);
            this.setState({ user_type }, () => {
            this.getCustomerList(); // Ensure this runs after state is updated
    });
    //----------Add device---------
    this.fetchDeviceTypes();

    // Add event listener for keydown
    document.addEventListener("keydown", this.handleKeyDown);
  }

  validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);

          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
        }

componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning_device !== prevState.warning_device ||
        this.state.error_device !== prevState.error_device ||
        this.state.error1_device !== prevState.error1_device ||
        this.state.warning1_device !== prevState.warning1_device ||
        this.state.success_device !== prevState.success_device ||
        this.state.success !== prevState.success ||
        this.state.error !== prevState.error ||
        this.state.error_group !== prevState.error_group ||
        this.state.success_group !== prevState.success_group ||
        this.state.error_device_edit !== prevState.error_device_edit ||
        this.state.success_device_edit !== prevState.success_device_edit ||
        this.state.warning_site !== prevState.warning_site ||
        this.state.success_camera !== prevState.success_camera ||
        this.state.success_camera_existing_site !== prevState.success_camera_existing_site ||
        this.state.error_camera !== prevState.error_camera ||
        this.state.warning_camera !== prevState.warning_camera ||
        this.state.warning1_camera  !== prevState.warning1_camera ||
        this.state.error_site !== prevState.error_site

    ) {
        if (
            this.state.warning_device ||
            this.state.error_device ||
            this.state.error1_device ||
            this.state.warning1_device ||
            this.state.success_device ||
            this.state.success ||
            this.state.error ||
            this.state.error_group ||
            this.state.success_group ||
            this.state.error_device_edit ||
            this.state.warning_site ||
            this.state.success_camera ||
            this.state.success_camera_existing_site ||
            this.state.error_camera ||
            this.state.warning_camera ||
            this.state.warning1_camera  ||
            this.state.success_device_edit ||
            this.state.error_site
        ) {
            setTimeout(() => {
                this.setState({
                    warning_device: false,
                    error_device: false,
                    error1_device: false,
                    warning1_device: false,
                    success_device: false,
                    success: false,
                    error : false,
                    error_group: false,
                    success_group: false,
                    error_device_edit: false,
                    warning_site: false,
                    success_camera: false,
                    success_camera_existing_site: false,
                    error_camera: false,
                    warning_camera: false,
                    warning1_camera: false,
                    success_device_edit: false,
                    error_site : false
                });
            }, 4000); // 4 second
        }
    }
}


  componentWillUnmount() {
    // Remove event listener for keydown
    document.removeEventListener("keydown", this.handleKeyDown);
    //polling
    if (this.state.ws) {
      this.state.ws.close();
    }
  }



fetchSiteStatuses = async (siteId) => {
  // const {siteStatusMap} = this.state;
  const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    Authorization: `Bearer ${token}`,
  };

 let siteStatusMaps;
    try {
      const url = `${urls.SITE_STATUS}?site_id=${siteId}`;
      console.log("url for site Status: ",url);
      const res = await get(url, headers);
     console.log("Response for site Status: ",res);
      siteStatusMaps = res.status === true || res.status === "True";
    } catch (error) {
      console.error("Error fetching site status for site_id:", siteId, error);
      siteStatusMaps = true; // fallback: consider site active
    }

  this.setState({ siteStatusMap : siteStatusMaps });
};

handleToggleSiteStatus = async (siteId, newStatus) => {
  const token   = localStorage.getItem(globalVariables.AUTH_TOKEN);
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
  const body = JSON.stringify({ site_id: siteId, status: newStatus });

  try {
    const res = await post(urls.SITE_STATUS, body, headers);

    // Update local map first so UI reacts immediately
    this.setState(
      (prev) => ({
        siteStatusMap: newStatus ,
        devices:
          newStatus === false ? [] : prev.devices, // clear list if de‑activating
      }),
      () => {
        if (newStatus) {
          // user just re‑enabled -> fetch fresh device list
          this.getDevicesListById(siteId);
        }
      }
    );

    this.openSnackbar(
      `Site is now ${newStatus ? 'Active' : 'Inactive'}.`,
      'success'
    );
  } catch (err) {
    console.error('Toggle failed', err);
    this.openSnackbar('Failed to update site status.', 'error');
  }
};


  //on ecs keyboard key press, close the dialogue box
  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // Close modal when Esc key is pressed
      this.handleCloseModal();
    }
  };

  /**
   * getCamerasList() function fetches the camera list w.r.t selected device (row from device list table). this function gets invoked from when clicked on the row of device list table.
  **/
  getCamerasList = async (deviceId) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await get(url, headers); // Perform the API call using the constructed URL
      if (Array.isArray(response) && response.length > 0) {
        console.log(`API Response for device ${deviceId}:`, response);
        this.setState({ cameras: response });

      } else {
        console.error("No valid data returned from the get-camera API");
        this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      this.setState({ cameras: [] }); // Clear the cameras list in case of error
    }
  };

//  handleSiteSelection = (siteId, siteInfo) => {
//   this.setState((prevState) => {
//     // ✅ IF SAME SITE CLICKED → COLLAPSE
//     if (prevState.expandedSiteId === siteId) {
//       return {
//         expandedSiteId: null,
//         selectedSite: null,
//         selectedSiteInfo: null,
//         devices: [],
//         cameras: [],
//       };
//     }

//     // ✅ ELSE → EXPAND NEW SITE
//     return {
//       expandedSiteId: siteId,
//       selectedSite: siteId,
//       selectedSiteInfo: siteInfo,
//       devices: [],
//       cameras: [],
//     };
//   }, () => {
//     // ✅ fetch ONLY when expanding
//     if (this.state.expandedSiteId === siteId) {
//       this.getDevicesListById(siteId);
//       this.fetchSiteStatuses(siteId);
//       this.getRtspCamerasDevicesListBySiteId(siteId);
//     }
//   });
// };

  handleSiteSelection = (siteId, siteInfo) => {
    this.closePagingModal(); // Ensure paging modal is closed when a site is selected
  this.setState(prevState => {
    const isExpanded = prevState.expandedSiteId.includes(siteId);

    return {
      expandedSiteId: isExpanded
        ? prevState.expandedSiteId.filter(id => id !== siteId)
        : [...prevState.expandedSiteId, siteId],

      selectedSite: isExpanded ? null : siteId,
      selectedSiteInfo: isExpanded ? null : siteInfo,
      devices: [],
      cameras: [],
    };
  }, () => {
    // ✅ fetch ONLY when expanding
    if (this.state.expandedSiteId.includes(siteId)) {
      this.fetchSiteStatuses(siteId);
      this.getRtspCamerasDevicesListBySiteId(siteId);
      this.getDevicesListById(siteId);
    }
  });
};


  deviceSync = () => {
    const{selectedSite}=this.state
    console.log("-----deviceSync----selectedSite", selectedSite);
    this.startLoading();
    // Delay for alert visibility before reload
    setTimeout(() => {
    Promise.all([
      this.getDevicesListById(selectedSite),
      this.getRtspCamerasDevicesListBySiteId(selectedSite)
    ])
    .then(() => {
          this.stopLoading(); // Stop loading after devices are fetched
      });
  }, 500); // Ensures progress bar is visible before stopping
  // this.TestConnection()
  }


  getDevicesListById = async (site_id) => {
    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      const response = await get(urls.GET_DEVICES_BY_SITE(site_id), headers); //  API call to get the devices list w.r.t selected client
      this.stopLoading();
      console.log("API Response:---getDevicesListById---------------------------------------->>>", response.data)

      if(response.error[0] === "device not found")
      {
        this.setState({
          devices: [], loading: false });
        return
      }
      if (response) {
        console.log("res", response)
        this.setState({loading: false, devices: response.data});
        // this.setState({ devices:deviceData });
        // this.setState({ deviceId:deviceData.id });
      } else {
        console.error("No data returned from the API");
        this.setState({ devices: []});
      }
    } catch (error) {
      console.error("Error fetching devices from API:", error);
    }
  };

  getGroupsList = async () => {
    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("Fetching data from:", urls.GET_GROUPS_INCLUDING_SITES_DEVICES); // Update URL for fetching sites
      const response = await get(urls.GET_GROUPS_INCLUDING_SITES_DEVICES, headers);
      console.log("response getGroupsList ===> ", response);
      this.stopLoading();
      if (!response) {
        console.error("Failed to fetch getGroupsList.");
        this.setState({ groups_list: [] });
        return;
      }

      this.setState({ groups_list: response.data || [], filteredGroups: response.data || [] }); // Update state with site list and users
      // this.setState({ groups_list: response}); for production, as response refractor is remaining on production.
    } catch (error) {
      console.error("Error in getGroupsList:", error);
      this.setState({ groups_list: [] });
    }
  };

  getSitesList = async () => {
    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
      const response = await get(urls.GET_SITES_BY_USER, headers);
      console.log("response sites array ===> ", response.data);
      this.stopLoading();
      if (!response) {
        console.error("Failed to fetch site list.");
        this.setState({ site_list: [] });
        return;
      }
      //added this section as the new response includes devices array for the search functionality.(common search bar for both sites and devices)
      const sites = response.data || [];

      const allDevices = sites.flatMap((site) =>
        (site.devices || []).map((device) => ({
          ...device,
          sitename: site.sitename,
          site_id: site.id // optional: keep track of which site the device belongs to
        }))
      );

      this.setState({ site_list: response.data[0] || [], edit_selected_Customers_list: response.data[0].users || [], search_devices_list: allDevices }); // Update state with site list and users
      // this.setState({site_list: response, edit_selected_Customers_list: response.users || [],}) // for production, as the response refractor is remaining on production.
    } catch (error) {
      console.error("Error in getSitesList:", error);
      this.setState({ site_list: [] });
    }
  };

  handleChangePage = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  // handleSearchInputChange = (e) => {
  //   this.setState({ searchInput: e.target.value });
  // };



  // Handler to toggle dropdown table for a device row
  handleRowClick = async (deviceId) => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    let device_details = await get(urls.DEVICE_DETAILS(deviceId), headers)

    console.log("device_Details", device_details)

    this.setState({
      device_details: device_details
    })


    this.setState(
      (prevState) => ({
        expandedRow: prevState.expandedRow === deviceId ? null : deviceId, // Toggle the row
      }),
      () => {
        if (this.state.expandedRow) {
          this.getCamerasList(deviceId); // Fetch data only when the row is expanded
        }
      }
    );
  };



  // closePopup = () => {
  //   this.setState((prevState) => {
  //     console.log("Toggling refreshSystemOverviewstatuscard:", !prevState.refreshSystemOverviewstatuscard);
  //     return {
  //       isPopupVisible: false,
  //       selectedCamera: null,
  //       refreshSystemOverviewstatuscard: !prevState.refreshSystemOverviewstatuscard,
  //     };
  //   });
  // };

  // Toggle collapsible function
  handleToggle = (section) => {
    this.setState((prevState) => ({
      activeSection: prevState.activeSection === section ? null : section,
    }));
  };



  handleCameraSchedule = (deviceId) => {
    console.log("handleCameraSchedule---cameraId---", deviceId)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    //navigate to system-manager/scheduler by navigation
    this.props.navigate("/system-overview/scheduler");
  }

  handleAboutDeviceNavigation = (deviceId, SiteName, DeviceName, siteId, IsRtspDevice, UnmuteCount) => {
    console.log("handleAboutDeviceNavigation---deviceId--IsRtspDevice-SiteName", deviceId, IsRtspDevice, SiteName)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    localStorage.setItem(globalVariables.SITE_NAME, SiteName);
    localStorage.setItem(globalVariables.DEVICE_NAME, DeviceName);
    localStorage.setItem(globalVariables.SITE_ID, siteId);
    localStorage.setItem(globalVariables.IS_RTSP_DEVICE, IsRtspDevice);
    localStorage.setItem(globalVariables.UNMUTE_CAMERA_COUNT, UnmuteCount);

    this.props.navigate("/aboutDevice");
  }

  handleSiteFilterChange = (event) => {
    const selectedSite = event.target.value;
    this.setState({ selectedSite });

    console.log("----selected site to filter devices ----", selectedSite);

    if (selectedSite === "Show all/remove filter") {
      this.setState({ filteredDevices: this.state.devices });
      console.log("----filteredDevices ----", this.state.filteredDevices);
    } else {
      const filteredDevices = this.state.devices.filter((device) => {
        console.log("Comparing:", device.site_name, "with", selectedSite);
        return device.site_name === selectedSite;
      });

      this.setState({ filteredDevices });
      console.log("----filteredDevices ----", this.state.filteredDevices);
    }
  };


  // ---------------------------Add Site Functions---------------------------------------------------------

    getCurrentTimeInDeviceTimezone = (timezone ) => {
      try {
          // Get the current time in the specified timezone
          const localTime = new Intl.DateTimeFormat("en-US", {
              timeZone: timezone,
              // year: "numeric",
              // month: "2-digit",
              // day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true, // Use 12-hour format
          }).format(new Date());


          return localTime;
      } catch (error) {
          console.error("Error calculating device time:", error);
          return "Error calculating time";
      }
  };

  formatToUSDateTime = (datetimeStr) => {
    if (!datetimeStr || typeof datetimeStr !== "string" || !datetimeStr.includes(",")) {
      console.log("Invalid Date",datetimeStr);
      return " ";
    }
      // input: "11/04/2025,07:22" (DD/MM/YYYY, 24hr format)
      const [datePart, timePart] = datetimeStr.split(",");
      const [day, month, year] = datePart.split("/");

      const [hour, minute] = timePart.split(":");
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}`);

      return new Intl.DateTimeFormat("en-US", {
        // month: "2-digit",
        // day: "2-digit",
        // year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }).format(date); // returns: "04/11/2025, 7:22 AM"
  }

  //   getCurrentTimeInPosixTz = (posixTz) => {
  //   try {
  //       if (!posixTz) return "-";

  //       // Convert POSIX to IANA timezone (e.g., EST5EDT -> America/Detroit)
  //       const ianaTimezone = "America/Detroit"; // Manually mapping for accuracy

  //       // Get the current time in that timezone
  //       const dt = DateTime.now().setZone(ianaTimezone);

  //       // Format: "7/2/2025 at 08:30 AM"
  //       const formattedTime = dt.toFormat("MM/dd/yyyy',' hh:mm a");

  //       return formattedTime;
  //   } catch (error) {
  //       console.error("Error calculating time:", error);
  //       return "Error calculating time";
  //     }
  // };

    NavigateToAddSIte = () => {
        this.setState({toggleAddSite: true})
  }

      closePopup = () => {
        this.setState({ toggleAddSite: false, toggleAddDevice: false, editDeviceToggle:false, AddGroupToggle:false, EditGroupToggle:false, toggleAddSingleCamera: false  });
      };

      handleInputChange = (e) => {
          const { name, value } = e.target;
          this.setState({ [name]: value }, () => {
            this.validateField(name, value);
          });
      };



//   validateField = (name, value) => {
//     let errors = { ...this.state.errors };

//     // Apply "no spaces" check only for IP and RTSP port
//     if ((name === "ipAddress" || name === "rtsp_port" || name === "portNumber" || name === "EditIpAddress" || name === "EditRTSPAddress" || name === "EditPortNumber") && /\s/.test(value)) {
//     errors[name] = "No spaces are allowed.";
//     this.setState({ errors });
//     return;
//   }


//     // ✅ Validate IP Address: Valid IPv4:- 192.168.1.10 or Valid IPv6:- 2001:0db8:85a3:0000:0000:8a2e:0370:7334 or Valid compressed IPv6:- 2001:db8::1 or IPv6 with embedded IPv4 ::ffff:192.168.1.1
//     if (name === "ipAddress" || name === "EditIpAddress") {
//       if (!value) {
//         errors.ipAddress = "IP Address is required.";
//       } else {
//         // IPv4 regex
//         const ipv4Regex =
//           /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

//         // IPv6 regex (standard + compressed)
//         const ipv6Regex =
//           /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:)((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

//         // Hostname/DDNS regex
//         const hostnameRegex =
//           /^(?!:\/\/)(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

//         if (!(ipv4Regex.test(value) || ipv6Regex.test(value) || hostnameRegex.test(value))) {
//           errors.ipAddress =
//             // "Enter a valid IPv4 (e.g., 192.168.1.10) or IPv6 (e.g., 2001:db8::1) address.";
//             "Enter a valid IPv4 or IPv6 address or DDNS.";
//         } else {
//           delete errors.ipAddress;
//         }
//       }
//     }

//     // ✅ Validate RTSP Port -"Port must be a number between 1 and 65535."
//     if (name === "rtsp_port" || name === "EditRTSPAddress") {
//       if (!value) {
//         errors.rtsp_port = "RTSP Port is required.";
//       } else {
//         const port = Number(value);
//         if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
//           errors.rtsp_port = "Enter a valid port number (1–65535).";
//         } else {
//           delete errors.rtsp_port;
//         }
//       }
//     }

//     // ✅ Validate Server Port Number
//     if (name === "portNumber" || name === "EditPortNumber") {
//       if (!value) {
//         errors.portNumber = "Server Port Number is required.";
//       } else if (/\s/.test(value)) {
//         errors.portNumber = "No spaces are allowed.";
//       } else {
//         const port = Number(value);
//         if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
//           errors.portNumber = "Enter a valid port number (1–65535).";
//         } else {
//           delete errors.portNumber;
//         }
//       }
// }


//     // For all other fields: just remove any previous error (no strict rule)
//     if (name !== "ipAddress" && name !== "rtsp_port" && name !== "portNumber" && name !== "EditIpAddress" && name !== "EditRTSPAddress" && name !== "EditPortNumber") {
//       delete errors[name];
//     }

//     this.setState({ errors });
//   };

    validateField = (name, value) => {
      let errors = { ...this.state.errors };

      const noSpaceFields = [
        "ipAddress", "rtsp_port", "portNumber",
        "EditIpAddress", "EditRTSPAddress", "EditPortNumber", "rtspStreamParameter", "EditRtspStreamParameter", "devicePassword", "EditDevicePassword"
      ];

      const ipFields = ["ipAddress", "EditIpAddress"];
      const rtspFields = ["rtsp_port", "EditRTSPAddress"];
      const portFields = ["portNumber", "EditPortNumber"];
      const streamParamFields = ["rtspStreamParameter", "EditRtspStreamParameter"];

      // ❌ No spaces allowed for certain fields
      if (noSpaceFields.includes(name) && /\s/.test(value)) {
        errors[name] = "No spaces are allowed.";
        this.setState({ errors });
        return;
      }

      // ✅ Validate IP / DDNS
      if (ipFields.includes(name)) {
        if (!value) {
          errors[name] = "IP Address is required.";
        } else {
          const ipv4Regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:)((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
          const hostnameRegex = /^(?!:\/\/)(?=.{1,253}$)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

          if (!(ipv4Regex.test(value) || ipv6Regex.test(value) || hostnameRegex.test(value))) {
            errors[name] = "Enter a valid IPv4, IPv6, or DDNS address.";
          } else {
            delete errors[name];
          }
        }
      }

      // ✅ Validate RTSP Port
      if (rtspFields.includes(name)) {
        if (!value) {
          errors[name] = "RTSP Port is required.";
        } else {
          const port = Number(value);
          if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
            errors[name] = "Enter a valid port number (1–65535).";
          } else {
            delete errors[name];
          }
        }
      }

      // ✅ Validate Server Port
      if (portFields.includes(name)) {
        if (!value) {
          errors[name] = "HTTP Port Number is required.";
        } else {
          const port = Number(value);
          if (!/^[0-9]{1,5}$/.test(value) || port < 1 || port > 65535) {
            errors[name] = "Enter a valid port number (1–65535).";
          } else {
            delete errors[name];
          }
        }
      }

      // ✅ Validate Stream Parameter
      // if (streamParamFields.includes(name)) {
      //   if (!value) {
      //     errors[name] = "Stream parameter is required.";
      //   } else {
      //     const streamParamRegex = /^\/[a-zA-Z0-9_\-/.]+$/;
      //     if (!streamParamRegex.test(value)) {
      //       errors[name] = "Invalid format. Must start with '/' and contain only letters, numbers, '_', '-', '/', or '.'";
      //     } else {
      //       delete errors[name];
      //     }
      //   }
      // }

      // For other fields → clear old errors
      if (![...noSpaceFields].includes(name)) {
        delete errors[name];
      }

      this.setState({ errors });
    };


      getCustomerList = async () => {
          console.log("Fetching data from:", urls.GET_USERS);
          const {user_type} = this.state
          console.log("----user_type----", user_type);
          try {
              let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);



              let headers = {
                  "content-type": "application/json",
                  Authorization: `Bearer ${access_token}`
              };
              if (user_type === "DealerUser"){
                  let dealer_id = localStorage.getItem(globalVariables.USER_ID);
                  let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
                  console.log("--------url---------", url);
                  const response = await get(url, headers); // API call
                  console.log("--------response---------", response);

                  // Validate the response and extract results
                  if (!response || !response.data || !Array.isArray(response.data)) {
                      console.error("Invalid response or results:", response);
                      this.setState({ client_list: [] });
                      return;
                  }
                  this.setState({ client_list: response.data });
                  console.log("user_list---------", this.state.client_list);
              }
              if (user_type === "TechnicianUser"){
                  let dealer_uuid = localStorage.getItem(globalVariables.DEALER_UUID);
                  let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_uuid);
                  console.log("--------url---------", url);
                  const response = await get(url, headers); // API call
                  console.log("--------response---------", response);

                  // Validate the response and extract results
                  if (!response || !response.data || !Array.isArray(response.data)) {
                      console.error("Invalid response or results:", response);
                      this.setState({ client_list: [] });
                      return;
                  }
                  this.setState({ client_list: response.data });
                  console.log("user_list---------", this.state.client_list);
              }
          } catch (error) {
              console.error("Error in getCustomerList:", error);
              this.setState({ client_list: [] });
          }
      };

      handleSelectionChange = (event) => {
        const { name, value } = event.target;
          const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
          // Find the selected customers from the client_list based on the selected user IDs
        const selectedUsers = this.state.client_list.filter(user => selectedOptions.includes(user.user_id));
        console.log("selected users",selectedUsers)
        // Update the selected_Customers state
        this.setState({ edit_selected_Customers_list: selectedUsers });
        if (name === "group_id") {
          // Update group_id when selecting a parent group
          this.setState({ group_id: value });
      }
      };

      handleSiteSave = async () => {
          const { sitename, city, street, zip, organisationName, country, state, selected_Customers, group_id, fire_dept_contact_no, police_dept_contact_no, cust_contact_no, cust_contact_no_1, map_link, gas_paging_devices} = this.state;
          // const address = `${street}, ${city}, ${zip}, ${state}, ${country}`;

          // Ensure blank values are preserved in the output
          const address = [street || "", zip || "", city || "", state || "", country || ""].join(", ");

          // Validation for required fields ----uncomment below if(), for grouping feature.
          let requiredSiteData = [
            sitename, city, street, zip, organisationName, country, state, fire_dept_contact_no,group_id, police_dept_contact_no, (cust_contact_no || cust_contact_no_1), map_link
          ];
          if (requiredSiteData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
            this.setState({ warning_site: true });
            this.stopLoading();
            return;
          }

          // let updatedSelectedCustomers = [...selected_Customers];
          // updatedSelectedCustomers = [localStorage.getItem(globalVariables.USER_ID), ...updatedSelectedCustomers];  // Prepend logged-in user

          let updatedSelectedCustomers = (selected_Customers || []).map(user => user.user_id);
          updatedSelectedCustomers = [localStorage.getItem(globalVariables.USER_ID), ...updatedSelectedCustomers];

         const mac = gas_paging_devices?.[0]?.mac_address?.trim();

              // ✅ Only validate if full MAC entered
              if (mac && mac.length === 17) {
                const macRegex = /^([0-9a-f]{2}(-)){5}[0-9a-f]{2}$/;

                if (!macRegex.test(mac)) {
                  this.setState({
                    errors: {
                      mac_address: "Invalid MAC format. Use: 8c-1f-64-82-24-e1"
                    }
                  });
                  this.stopLoading();
                  return;
                }
              }

          const data = JSON.stringify({
              sitename,
              // address,
              street,
              zip,
              city,
              state,
              country,
              organisation_name: organisationName,
              users: updatedSelectedCustomers,
              group_id: group_id,
              customer_contact: cust_contact_no,
              customer_contact_2: cust_contact_no_1,
              police_department_contact: police_dept_contact_no,
              fire_department_contact: fire_dept_contact_no,
              map_link: map_link,
              gas_paging_devices: gas_paging_devices

          });
          this.setState({ errors: {} });
          console.log("Data to be saved for site:", data);
          this.startLoading()
          try{
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

              let headers = {
                  // 'content-type': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8',
                  'Authorization': `Bearer ${access_tocken}`
              }
              const response = await post(urls.SITE_MANAGE, data, headers);

              console.log("reposne of site save ===> ", response);
              if (response.sitename ) {
                    this.setState({
                    error_site: true,
                    responseMessage: response.sitename,
                    errors: {
                      ...this.state.errors,
                      sitename: response.sitename
                    }
                  });
                this.stopLoading();
                return;
              }
              // ✅ MAP
                      if (response.map_link) {
                        this.setState({
                              error_site: true,
                              responseMessage: "Invalid Google Maps URL. Please enter a valid link (e.g., https://maps.google.com/...).",
                              errors: {
                                ...this.state.errors,
                                map_link: "Invalid Google Maps URL. Please enter a valid link (e.g., https://maps.google.com/...)."
                              }
                            });
                        this.stopLoading();
                        return;
                      }

                      // ✅ MAC
                      if (response.mac_address) {
                        let macError = Array.isArray(response.mac_address)
                          ? response.mac_address[0]
                          : response.mac_address;

                       this.setState({
                        error_site: true,
                        responseMessage: macError,
                        errors: {
                          ...this.state.errors,
                          mac_address: macError
                        }
                      });

                        this.stopLoading();
                        return;
                      }
              else if(response.data) {
                    this.setState({ success_site: true });
                      //Delay for alert visibility before reload
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
              }
              else{
                  console.error('Error:');
                  this.setState({ error_site: true, responseMessage: "New site was not added." });
              }
          }
          catch (error) {
              console.error('Error:', error);
              this.setState({ error_site: true, responseMessage: "Server error! New site was not added."});
          }
          this.stopLoading()
      };

      startLoading = () => {
          console.log("startloading")

          this.setState({ open_progress_bar: true });
      }

      stopLoading = () => {
          this.setState({ open_progress_bar: false });
      }

      startLinearLoading = () => {
        console.log("startloading")

        this.setState({ open_progress_bar1: true });
      }

      stopLinearLoading = () => {
          this.setState({ open_progress_bar1: false })
      }

  //-------------------------------------------------------------------------------------------------------

  //------------------------------Edit site Info ----------------------------------------------------------
  handleEdit = async () => {
        this.setState({ anchorEl: null, editToggle: true });
        const {selectedSite} = this.state
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.SITE_MANAGE_ID(selectedSite);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL

            console.log(`API Response for LoadSelectedDeviceInfo ${selectedSite}:`, response);

            if (response && Object.keys(response).length > 0) {
                console.log(`API Response for LoadSelectedSiteInfo ${selectedSite}:`, response);

                //Extract address fields by splitting
                // let addressParts = response.address ? response.address.split(",") : [];

                // Extracting address components
                // let street = addressParts.slice(0, -4).join(",").trim() || ""; // Everything before last 4 elements is street
                // let city = addressParts.at(-3)?.trim() || ""; // Fourth last element is city
                // let zip = addressParts.at(-4)?.trim() || ""; // Third last element is zip
                // let state = addressParts.at(-2)?.trim() || ""; // Second last element is state
                // let country = addressParts.at(-1)?.trim() || ""; // Last element is country
                const pagingDevices =
                  response.gas_paging_devices?.filter(d => d.mac_address) || [
                    {
                      mac_address: "",
                      device_type: "",
                      description: ""
                    }
                  ];
                this.setState({
                  edit_sitename: response.sitename || "",
                  edit_organisation_name: response.organisation_name || "",
                  // edit_address: response.address || "", , ,
                  edit_selected_Customers_list: response.users || [],  // Populate selected_Customers with the users list from the response
                  edit_address: response.street || "",
                  edit_city : response.city || "",
                  edit_zip : response.zip || "",
                  edit_state : response.state || "",
                  edit_country : response.country || "",
                  edit_map_link : response.map_link || "",
                  edit_cust_contact_no : response.customer_contact || "",
                  edit_cust_contact_no_1 : response.customer_contact_2 || "",
                  edit_police_dept_contact_no: response.police_department_contact || "",
                  edit_fire_dept_contact_no : response.fire_department_contact || "",
                  edit_gas_paging_devices: pagingDevices
                  });

            } else {
                console.error("No valid data returned from the get-camera API");
                // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    };

  handleEditSave = async () => {
        console.log("handle edit save");
        const {selectedSite} = this.state
        const { edit_sitename, edit_organisation_name, edit_address, edit_selected_Customers_list,
           edit_city, edit_zip, edit_country, edit_state, edit_cust_contact_no, edit_cust_contact_no_1,
           edit_map_link, edit_police_dept_contact_no, edit_fire_dept_contact_no, edit_gas_paging_devices } = this.state;

        // Ensure blank values are preserved in the output
          const address = [edit_address || "", edit_zip || "", edit_city || "",  edit_state || "", edit_country || ""].join(", ");

        let requiredSiteData = [
          edit_sitename, edit_organisation_name, edit_address, edit_city, edit_zip, edit_country, edit_state, (edit_cust_contact_no || edit_cust_contact_no_1), edit_police_dept_contact_no, edit_fire_dept_contact_no ];
          if (requiredSiteData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
            this.setState({ warning_site: true });
            this.stopLoading();
            return;
          }

        const loggedInUserId = localStorage.getItem(globalVariables.USER_ID);
        const userIds = edit_selected_Customers_list.map(customer => customer.user_id);

        if (loggedInUserId) {
            userIds.push(loggedInUserId);
        }
        // if(this.state.user_type === "TechnicianUser" && edit_gas_paging_devices[0].mac_address.trim() === ""){
        //   this.openSnackbar("You don't have access to remove the paging device, you can only update it's info", "error");
        //   return;
        // }
       const pagingDevices =
  edit_gas_paging_devices?.[0]?.mac_address &&
  edit_gas_paging_devices[0].mac_address.trim() !== ""
    ? edit_gas_paging_devices
    : [];
        const data = JSON.stringify({
          sitename: edit_sitename,
          // address: address,
          street: edit_address,
          city: edit_city,
          zip: edit_zip,
          state: edit_state,
          country: edit_country,
          map_link: edit_map_link,
          organisation_name: edit_organisation_name,
          users: userIds,
          customer_contact: edit_cust_contact_no,
          customer_contact_2: edit_cust_contact_no_1,
          police_department_contact: edit_police_dept_contact_no,
          fire_department_contact: edit_fire_dept_contact_no,
          gas_paging_devices: pagingDevices

        });

        console.log("Data to be saved for site:", data);

        try {
            const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            const headers = {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_token}`,
            };

            console.log("API URL:", urls.SITE_UPDATE_CUSTOM(selectedSite));

            const response = await fetch(urls.SITE_UPDATE_CUSTOM(selectedSite), {
                method: 'POST',
                headers,
                body: data,
            });
            console.log("edit site info response---", response);
            let res = await response.json();
            if (res.sitename === "This user already has a site with this name.") {
                    this.setState({ error: true, responseMessage: "This user already has a site with this name." });
                      this.stopLoading();
                      return;
              }
              // ✅ ADD MAC HERE (AFTER SITENAME)
                if (res.mac_address) {
                  let macError = Array.isArray(res.mac_address)
                    ? res.mac_address[0]
                    : res.mac_address;

                  this.setState({
                    error: true,
                    responseMessage: macError,
                    errors: {
                      ...this.state.errors,
                      mac_address: macError
                    }
                  });

                  this.stopLoading();
                  return;
                }
              else if(res.data) {
                    this.setState({ success: true });
                      //Delay for alert visibility before reload
                    setTimeout(() => {
                        this.setState({editToggle:false});
                        window.location.reload();
                    }, 2000);
              }
              else {
                this.setState({ error: true, responseMessage: "Site info was not updated." });
              }

            // if (!response.ok) {
            //     const errorResponse = await response.json();
            //     console.error("API Error Response:", errorResponse);
            //     throw new Error(`API Error: ${response.status} ${response.statusText}`);
            // }

            // const result = await response.json();
            // console.log("Response from backend:", result);


        } catch (error) {
            console.error("Error:", error);
            this.setState({ error: true, responseMessage: "Server error! Site info was not updated."  });
        }
    };

  closeEditPopup = () => {
      this.setState({ editToggle: false });
  };

  handleEditSelectionChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);

    // Find the selected customers from the client_list based on the selected user IDs
    const selectedUsers = this.state.client_list.filter(user => selectedOptions.includes(user.user_id));
    console.log("selected users",selectedUsers)
    // Update the selected_Customers state
    this.setState({ edit_selected_Customers_list: selectedUsers });
  };
  //-------------------------------------------------------------------------------------------------------

  //-----------------------------Add Device functions ----------------------------------------------------

  NavigateToAddDevice = () => {
    this.setState({toggleAddDevice: true})
  }

  fetchDeviceTypes = async () => {
          try {
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

              let headers = {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${access_tocken}`
              }
              console.log("Fetching data from:", urls.DEVICE_TYPE_LIST);
              const response = await get(urls.DEVICE_TYPE_LIST, headers);
              console.log("Device types list Response in Adddevice-----:", response);

              if (!response || !Array.isArray(response)) {
                  console.error("Invalid response format or empty list.");
                  this.setState({ device_type_list: [] });
                  return;
              }

              this.setState({ device_type_list: response }); // Directly use the array from your response
              console.log("Updated state with device types list:", this.state.device_type_list);
          } catch (error) {
              console.error("Error in fetchDeviceTypes:", error);
              this.setState({ device_type_list: [] });
          }
  }


   // Handle device add form submission -----------------------------------------
   connectWebSocket = () => {
    const ws = new WebSocket(urls.WEBSOCKET_CONNECTION);
    // const ws = new WebSocket("wss://eyeon8i.com:8080"); //uncomment this for production (replaced the IP with UI servers domain name)
    // const ws = new WebSocket("ws://15.206.151.11:8080"); //uncomment this for AWS dev server build, keep the port as it is for socket connection
    // const ws = new WebSocket("wss://eyeon8i.neudeep.com:8080"); //uncomment this for production (replaced the IP with UI servers domain name)
   ws.onopen = () => {
        console.log("✅ WebSocket connected");
        this.setState({ ws});
    };


    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("🔍 WebSocket message received:", message);

      const { currentTaskIndex, taskQueue, taskStatus, stopRetry } = this.state;

      if (currentTaskIndex >= taskQueue.length) {
          console.error("⚠️ No task at index:", currentTaskIndex);
          return;
      }

      if (stopRetry) {
          console.log("🚨 Processing stopped due to timeout. No further fetch requests.");
          return;
      }

      const taskId = taskQueue[currentTaskIndex];

      if (message.action === "task_result") {
          const task = message.task.data;

          if (!task) {
              console.error("❌ Invalid WebSocket response format: missing task object.");
              return;
          }

          // ✅ PENDING TASK CONDITION
          if (task.status === "PENDING") {
              console.log(`⏳ Task ${taskId} is still pending... retrying in 2s`);

              this.setState(prevState => ({
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? `⏳ Task is still in progress... retrying in 2s` : status
                  ),
                  open_progress_bar1: true
              }));

              setTimeout(() => {
                  this.fetchTask(taskId);
              }, 2000);
          }

          // ❌ FAILURE CONDITION
          else if (task.status === "FAILURE") {
              console.log(`❌ Task ${taskId} failed. Device might be unreachable.`);

              this.setState(prevState => ({
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? `❌ Failed to fetch info. Device might not be reachable.` : status
                  ),
                  open_progress_bar1: false,
                  taskResults: {} // Clear results to prevent rendering old data
              }));
              return; // Stop further processing
          }

          // ✅ SUCCESS CONDITION
          else if (task.status === "SUCCESS") {
              console.log(`✅ Task ${taskId} completed successfully.`);

              this.setState(prevState => ({
                  taskResults: { ...prevState.taskResults, [task.task_id]: task.result },
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? "✅ Task completed!" : status
                  ),
                  showModal: true, // Ensure modal is displayed when data arrives
                  currentTaskIndex: currentTaskIndex + 1,
                  open_progress_bar1: false
              }), () => this.processNextTask());
          }
      }

      else if (message.action === "timeout_notification") { // ✅ Check this first
        console.log(`❌ Could not fetch further information, please try again.`);
        this.setState(prevState => ({
          taskStatus: prevState.taskStatus.map((status, index) =>
            index === prevState.currentTaskIndex ? "❌ Could not fetch further information, please try again." : status
          ),
          open_progress_bar1: false,
          stopRetry: true // Prevent further task fetch attempts
          }), () => {
            console.log("✅ State updated:", this.state);
        });
        // Remove the task from active processing so it doesn't retry
        return; // Stop further processing
      }

      // 🔍 TASK NOT FOUND CONDITION
      else if (message.action === "task_not_found") {
          if (this.state.stopRetry) {
            console.log("🚫 Ignoring 'task_not_found' due to previous timeout.");
            return; // Prevent further retries
        }
          console.log(`⏳ Task ${taskId} not found. Retrying...`);

          this.setState(prevState => ({
              taskStatus: prevState.taskStatus.map((status, index) =>
                  index === prevState.currentTaskIndex ? `Connection test has begun. \n Test is running! \n🔍 Retrying to fetch further information...` : status
              ),
              open_progress_bar1: true
          }));
          setTimeout(() => {
            this.fetchTask(taskId);
        }, 3000);
      }

    };

    ws.onerror = (error) => console.error("❌ WebSocket error:", error);
    ws.onclose = () => {
        console.log("🔌 WebSocket disconnected, retrying in 3s...");
        setTimeout(() => this.connectWebSocket(), 3000);
    };

    this.setState({ ws });
    //websocket is closed in componentWillMount.
    };

  sendMessage = (data) => {
      const { ws } = this.state;
      if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
      } else {
          console.error("❌ WebSocket is not open");
      }
  };

  fetchTask = (taskId) => {
    if (this.state.stopRetry) {
      console.log("🚫 Ignoring 'task_not_found' due to previous timeout.");
      return; // Prevent further retries
  }
    const { taskStatus, currentTaskIndex } = this.state;
    taskStatus[currentTaskIndex] = `Connection test has begun \n Test is running! \n🔍 Fetching the Information...`;
    this.setState({ taskStatus, open_progress_bar1: true });

  //-----------------------------------------------
    if (taskId.trim()) {
        this.sendMessage({ action: "fetch_task", taskId });
    } else {
        console.log("Please enter a Task ID");
    }
};


  // Handle device add form submission2-------------------
  handleSubmit = async (e) => {
      e.preventDefault();
      this.startLoading();
      console.log("----handleSubmit-----------");
      const {
          deviceName,
          deviceType,
          // client,
          selectedSite,
          ipAddress,
          protocol,
          portNumber,
          deviceUsername,
          devicePassword,
          rtsp_port,
          errors
        } = this.state;

      // // Validation
      // if (!deviceName || !selectedSite || !ipAddress || !deviceType) {
      //     this.setState({ warning_device: true});
      //     this.stopLoading()
      //     return;
      // }

      // Prepare payload
      let deviceData = {
          device_name: deviceName,
          device_type: deviceType,
          sitedb: selectedSite,
          ip_address: ipAddress,
          protocol: protocol, // Convert to lowercase and remove '://'
          port_number: portNumber,
          device_username: deviceUsername,
          device_password: devicePassword,
          rtsp_port: rtsp_port,
          policy_template_id : "1",
      };
      const data = JSON.stringify(deviceData);
      console.log("data---",data);

      let requiredDeviceData = [
          deviceName,
          deviceType,
          ipAddress,
          protocol,
          portNumber,
          deviceUsername,
          devicePassword,
          rtsp_port,
      ];
      if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
        this.setState({ warning_device: true });
        this.stopLoading();
        return;
      }

      // BLOCK SAVE if validation errors exist
        if (errors && Object.keys(errors).length > 0) {
          this.setState({ warning_device: true });
          this.stopLoading();
          return;
        }

      try{
          const{selectedSite}= this.state
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          //
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }

          let response = await post(urls.ADD_DEVICE, data, headers)

          console.log("url",urls.ADD_DEVICE);
          console.log("data res",response);



          // const response_data = await response.json();
          // console.log("response data",response.data[0].taskIds);

          if (response.data?.length > 0 && Array.isArray(response.data[0].taskIds) && response.data[0].taskIds.length > 0) {
              this.setState({
                          success: true,
                          showModal: true,
                          taskIds : response.data[0].taskIds
                          //responseMessage: response.responseMessage,
                          //response_data: response.response_data,
                      });
              // const taskIds = Object.values(response.data[0].taskIds);
              const taskIds = response.data[0].taskIds;  // No need for Object.values since it's already an array
              const taskStatus = taskIds.map(() => "🔄 Waiting for task...");
              this.setState({ taskQueue: taskIds, currentTaskIndex: 0, taskStatus }, () => {
              this.processNextTask();
              });
          }

          else if (response.error?.length > 0){
            if(response.error[0].includes("Device with IP") && response.error[0].includes("already exists")){
                this.setState({ error1_device: true, responseMessage: response.error[0] }, this.stopLoading);
                console.log("already exist");
                return;
            }
            else if(response.responseMessage === "Enter a valid IPv4 or IPv6 address."){
                this.setState({ error1_device: true, responseMessage: response.error[0] }, this.stopLoading);
                return;
            }
            else{
               this.setState({ error1_device: true, responseMessage: response.error[0] }, this.stopLoading);
               return;
            }
          }
          else if (response.success === false){
              this.setState({ error1_device: true, responseMessage: response.error[0] });
          }
          else{
              this.setState({ error1_device: true, responseMessage: "Device was not added." });
          }
      }catch (error) {
          console.error('Error:', error);
          this.setState({ error1_device: true, responseMessage:"Server error! Device was not added" });
      } finally {
          this.stopLoading();
      }
  };

  handleCameraInfoSubmission = async (e) => {
    // e.preventDefault();
    this.startLoading();
    console.log("----handleCameraInfoSubmission-----------");
    // const { CameraDeviceName, CameraName, deviceType, selectedSite, camera_ipAddress, camera_rtsp_port, camera_protocol, cameraUsername, cameraPassword, rtspStreamParameter, cameraPortNumber } = this.state;
    const {
          deviceName,
          CameraName,
          // deviceType,
          selectedSite,
          ipAddress,
          rtsp_port,
          protocol,
          deviceUsername,
          devicePassword,
          rtspStreamParameter,
          portNumber,
          errors,

        } = this.state;   // now using same add site form for both rtsp and other site type hence using same variable names. only calling the function conditionally.


      // Prepare payload
      let deviceData = {
          device_name: deviceName,
          camera_name: CameraName,
          // device_type: deviceType,
          sitedb: selectedSite,
          ip_address: ipAddress,
          protocol: protocol, // Convert to lowercase and remove '://'
          port_number: portNumber,
          device_username: deviceUsername,
          device_password: devicePassword,
          rtsp_port: rtsp_port,
          devce_rtsp_url: rtspStreamParameter, // Example RTSP URL format
          Global_Alarm: true,

          // policy_template_id : "1",
      };
      const data = JSON.stringify(deviceData);
      console.log("data---, device_name",data, deviceName);

      // if (!deviceName || !selectedSite || !ipAddress || !rtspStreamParameter || !CameraName) {
      //     this.setState({ warning_camera: true});
      //     this.stopLoading()
      //     return;
      // }

      let requiredDeviceData = [
          deviceName,
          CameraName,
          selectedSite,
          ipAddress,
          protocol,
          portNumber,
          deviceUsername,
          devicePassword,
          rtsp_port,
          rtspStreamParameter, // Example RTSP URL format
      ];
      if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
        this.setState({ warning_camera: true });
        this.stopLoading();
        return;
      }

      // BLOCK SAVE if validation errors exist
      if (errors && Object.keys(errors).length > 0) {
        this.setState({ warning_device: true });
        this.stopLoading();
        return;
      }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
          //
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }

          let response = await post(urls.ADD_CAMERA_WITH_NEW_SITE, data, headers);
          this.stopLoading();
          // console.log("url",urls.ADD_CAMERA);
          console.log("data res",response);
          if(response.data?.message === "Device created successfully and snapshot triggered.") {
            this.setState({ success_camera: true });
            setTimeout(() => {
              this.setState({ toggleAddDevice: false });
              this.getRtspCamerasDevicesListBySiteId(selectedSite);
            }, 3000);
          }
          else if(response.error && response.error[0].includes("already exists.")){
            this.setState({ warning1_camera: true, responseMessage : "Device with this IP already exists. Instead add a camera to the existing device."});
          }
          //Device name already exists for this user.
          else if(response.error && response.error[0] === "Device name already exists for this user."){
            this.setState({ warning1_camera: true, responseMessage : "Device name already exists for this user." });
          }
          else{
            this.setState({ error_camera: true, responseMessage: response.error[0] });
          }
    } catch (error) {
      // this.setState({ error_camera: true });
      this.stopLoading();
    }
  }

  processNextTask = () => {
    const { taskQueue, currentTaskIndex, stopRetry } = this.state;
    // Stop further execution if the first task failed
    if (stopRetry) {
        console.log("⚠️ Stopping further task execution.");
        return;
    }
    if (currentTaskIndex < taskQueue.length) {
        this.fetchTask(taskQueue[currentTaskIndex]);
    } else {
        this.setState(prevState => ({
          taskStatus: [...prevState.taskStatus, "🎉 All tasks processed!"],
          open_progress_bar1: false
      }), () => {
          console.log("✅ Progress bar hidden:", this.state.open_progress_bar1);
          // let channel_list_final = this.state.channelList
          // this.setState({final_channel_list: channel_list_final})
      });
    }
};

  // Method to handle modal close
  handleCloseModal = () => {
    const{selectedSite}= this.state
      this.setState({ showModal: false, showTestModal:false, toggleAddDevice:false, responseMessage: "", response_data: {}, taskResults:{}, taskQueue:[], currentTaskIndex:0, taskStatus:[], stopRetry: false, toggleAddSingleCamera:false }, () => {
          // Reload the page after modal is closed taskResults, taskQueue, currentTaskIndex, taskStatus
          // window.location.reload();
          setTimeout(() => {  //TODO------------------------------verify if needed after testing
            this.getDevicesListById(selectedSite);
            this.getRtspCamerasDevicesListBySiteId(selectedSite);
            }, 1000);
      });
  };
  //-----------------------------------------------------------------------------------------------------

  // Handle opening the menu
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleDeviceKebabClick = (event, device) => {
    this.setState({ anchorE2: event.currentTarget, selectedDevice: device, selectedDeviceID: device.id,
      global_alarm_status: device.global_alarm,
      selectedDeviceName: device.device_name  });
  };

  handleRtspDeviceKebabClick = (event, device) => {
    this.setState({ anchorE4: event.currentTarget, selectedDevice: device, selectedDeviceID: device.id,
      global_alarm_status: device.global_alarm === "True" ? true : false, selectedDeviceName: device.device_name  });
  };

  handleGroupKebabClick = (event, group) => {
    this.setState({ anchorE3: event.currentTarget, open2: true, selectedGroupForMenu: group });
  };

  // Handle closing the menu
  handleClose = () => {
    this.setState({ anchorEl: null, anchorE2: null, anchorE3:null, open2: false, selectedGroupForMenu: null, anchorE4: null,  });
  };

  openDialog = (onConfirm) => {
    // const {selectedSite} = this.state
    this.setState({ anchorEl: null, anchorE2: null, anchorE3:null, anchorE4: null})
    console.log("---openDialog-------");
    this.setState({
      confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to delete the selected record?",
        onConfirm
      },
    });
  };

  closeDialog = () => {
    this.setState({
      confirmDialog: {
        ...this.state.confirmDialog,
        isOpen: false,
      },
    });
  };

  handleDelete = async (siteId) => {
      // const userConfirmed = window.confirm('Are you sure you want to delete this site?');
      // if (!userConfirmed) return;
      const {selectedSite} = this.state
      console.log("--------selectedSite---------", siteId);
      try {
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

          console.log("--------selectedSite---------", siteId);

          const response = await fetch(urls.SITE_MANAGE_ID(selectedSite),
          { method: 'DELETE',
          headers : {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          });
          this.stopLoading();

          if (!response.ok) {
              // throw new Error(`Error: ${response.status}`);
              this.openSnackbar("Site is not deleted!", "error");
              return;
          }

          this.openSnackbar("Site deleted successfully!", "success");
          setTimeout(() => {
              // this.getSitesList()
              window.location.reload()
          }, 2000); // 2 seconds delay
      } catch (error) {
          console.error('Error deleting site:', error);
          alert('Failed to delete site. Please try again.');
      }
  };

  handleDeletePagingDevice = async(site_id) => {
    const {selectedSite} = this.state
      try {
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          //

          const response = await fetch(urls.DELETE_PAGING_DEVICE_OF_SITE(selectedSite),
          { method: 'DELETE',
          headers : {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          });
          this.stopLoading();

          if (!response.ok) {
              // throw new Error(`Error: ${response.status}`);
              let result = await response.json();
              this.openSnackbar(result.message || "Failed to delete paging device.", "error");
              return;
          }

          this.openSnackbar("Paging device deleted successfully!", "success");
      } catch (error) {
          console.error('Error deleting paging device:', error);
          this.openSnackbar("Server error! Failed to delete paging device.", "error");
          // alert('Failed to delete site. Please try again.');
      }
  }

  openSnackbar = (msg, alert_type = 'warning' || 'success' || 'error' || 'info') => {
    this.setState({
      open_snackbar: true,
      snackbar_msg: msg,
      alert_type: alert_type,
    })
  }

  // ------------------Test device connection--------------------------
  TestConnection = async ( device) => {
    console.log("---TestConnection---id-- device.global_alarm",device.id, device.global_alarm);
    this.setState({ anchorE2: null, responseMessage: "", taskIds:{}, response_data: {}, taskResults:{}, taskQueue:[], currentTaskIndex:0, taskStatus:[], rtsp_responseMessage:'', anchorE4: null });
      // e.preventDefault();
      this.startLoading()
      // Prepare payload
      let deviceData = {
        // device_name: device.device_name,
        // device_type: device.device_type,
        // sitedb: device.sitedb,
        // ip_address: device.ip_address,
        // protocol: device.protocol, // Convert to lowercase and remove '://'
        // port_number: device.port_number,
        // device_username: device.device_username,
        // device_password: device.device_password,
        // rtsp_port: device.rtsp_port,
        // policy_template_id: device.recording_policy
          device_id: device.id,
          vendor: device.device_type,
          protocol: device.protocol,
          ip_address: device.ip_address,
          port_number: device.port_number,
          device_username: device.device_username,
          device_password: device.device_password
        };
        const data = JSON.stringify(deviceData)
        console.log("---TestConnection---data--",data);


        try{
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          //
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          // Call custom post method
          if (device.global_alarm === "True"){
            // this.setState({ global_alarm_status: "True" })
            let response = await post(urls.TEST_CONNECTION_FOR_RTSP_DEVICE(device.id), headers);
            console.log("---TestConnection--RTSP_DEVICE---data--",response);
            this.stopLoading();
            if (response.data?.message === "Camera test completed.") {
                  this.setState({
                              showTestModal: true,
                              // rtsp_responseMessage: response.data.message, //commented this to show fixed message instead of msg received from backend response.
                              rtsp_responseMessage: "Camera connection test completed. Please review the results below.",
                              rtsp_test_response_data: response.data.results || [],

                          });
                  // const taskIds = Object.values(response.data[0].taskIds);
                  // const taskStatus = taskIds.map(() => "🔄 Waiting for task...");
                  // this.setState({ taskQueue: taskIds, currentTaskIndex: 0, taskStatus }, () => {
                  // this.processNextTask();
                  // });
              }
              else if (response.error && response.error.length > 0){
                console.log("inside else error block for rtsp test connection");
                this.setState({
                              showTestModal: true,
                              rtsp_responseMessage: response.error[0]});
              }
              // else if (response === false){
              //   console.log("inside else block for rtsp test connection");
              //   this.setState({
              //                 showTestModal: true,
              //                 rtsp_responseMessage:"Failed to complete the test connection."});
              // }
              else {
                this.setState({
                              showTestModal: true,
                              rtsp_responseMessage: "Failed to complete the test connection."});
              }


            }
            else {
              let response = await post(urls.SERVER_TEST_CONNECTION, data, headers); //replaced with this new api bz , test connection feature is now shifted to diff server.
              // let response = await post(urls.TEST_CONNECTION, data, headers);
              // console.log("url",urls.SERVER_TEST_CONNECTION)
              console.log("data res TestConnection--",response)
              this.stopLoading();
              if(response.success === true)
                  {
                    if (response.taskIds && Array.isArray(response.taskIds)) {
                      this.setState({
                                  showTestModal: true,
                                  taskIds : response.taskIds
                                  //responseMessage: response.responseMessage,
                                  //response_data: response.response_data,
                              });
                      const taskIds = Object.values(response.taskIds);
                      const taskStatus = taskIds.map(() => "🔄 Waiting for task...");
                      this.setState({ taskQueue: taskIds, currentTaskIndex: 0, taskStatus }, () => {
                      this.processNextTask();
                      });
                  }
                      // this.setState({
                      //     success2_device: true,
                      //     showTestModal: true, // Show the modal

                      // });
                      else if (response.error && response.error[0] === "Device unreachable. Please check the IP address and port."){
                        console.log("inside else error block for rtsp test connection");
                        this.setState({
                                      showTestModal: true,
                                      responseMessage: response.error[0]});
                      }
                      else {
                        this.setState({
                          showTestModal: true,
                          responseMessage: "Failed to complete the test connection."
                        });
                      }

                  }

              else {
                this.setState({
                  showTestModal: true,
                  responseMessage: "Failed to complete the test connection."
                });
              }
            }

          }catch (error) {
              console.error('Error:', error);
              alert('An error occurred while performing the test connection.');
              // this.setState({ error: true});
              // this.setState({
              //     showTestModal: true,
              //     responseMessage: "Failed to complete the test connection. Device reachable failed"
              //   });
          }
  };

  LoadSelectedDeviceInfo = async (deviceId, global_alarm_status) => {
    this.setState({anchorE2: null, editDeviceToggle: true, anchorE4: null});
    this.setState({Selected_Device_Id : deviceId, global_alarm_status: global_alarm_status});
    console.log("--------deviceId deviceId---------", deviceId);

    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const url = urls.DEVICE_DETAILS(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      let response = await get(url, headers); // Perform the API call using the constructed URL
      console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
      this.stopLoading();
      response = response.data[0];
      if (response && Object.keys(response).length > 0) {
        console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
        this.setState({
          EditDeviceName: response.device_name || "",
          EditDeviceType: response.device_type || "",
          EditIpAddress: response.ip_address || "",
          EditRTSPAddress: response.rtsp_port || "",
          EditProtocol: response.protocol || "",
          EditPortNumber: response.port_number || "",
          EditDeviceUsername: response.device_username || "",
          EditDevicePassword: response.device_password || "",
          client : response.client || "",
          });

      } else {
        console.error("No valid data returned from the get-camera API");
        // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      // this.setState({ cameras: [] }); // Clear the cameras list in case of error
    }
  };

  handleSaveDeviceEditedInfo =  async (selected_device_id) => {
    const {
        EditDeviceName,
        EditDeviceType,
        EditIpAddress,
        EditProtocol,
        EditPortNumber,
        EditDeviceUsername,
        EditDevicePassword,
        EditRTSPAddress, errors} = this.state;

        // BLOCK SAVE if validation errors exist
      if (errors && Object.keys(errors).length > 0) {
        this.setState({ warning_device: true });
        return;
      }
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);

      let data = {
        "device_name": EditDeviceName,
        "device_type": EditDeviceType,
        "client" : this.state.client,
        "ip_address": EditIpAddress,
        "rtsp_port": EditRTSPAddress,
        "protocol": EditProtocol,
        "port_number": EditPortNumber,
        "device_username": EditDeviceUsername,
        "device_password": EditDevicePassword
      }
      console.log("-----JSON DATA -------->",data);
      let post_data = JSON.stringify(data);

      // if (!this.state.EditDeviceName || !this.state.EditDeviceUsername || !this.state.EditIpAddress || !this.state.EditDevicePassword) {
      //   this.setState({ warning_device: true});
      //   this.stopLoading()
      //   return;
      // }
      if (EditProtocol === "rtsp"){
      let requiredDeviceData = [
        EditDeviceName,
        // EditDeviceType,
        EditIpAddress,
        EditProtocol,
        EditPortNumber,
        EditDeviceUsername,
        EditDevicePassword,
        EditRTSPAddress,
    ];

    if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
      this.setState({ warning_device: true });
      this.stopLoading();
      return;
    }

  } else {
    let requiredDeviceData = [
        EditDeviceName,
        EditDeviceType,
        EditIpAddress,
        EditProtocol,
        EditPortNumber,
        EditDeviceUsername,
        EditDevicePassword,
        EditRTSPAddress,
    ];

    if (requiredDeviceData.some(field => !String(field ?? "").trim())) { //optimised conditional check for empty fields
      this.setState({ warning_device: true });
      this.stopLoading();
      return;
    }

  }
  // this.validateField("EditIpAddress", EditIpAddress);
  //   this.validateField("EditRTSPAddress", EditRTSPAddress);
  //   this.validateField("EditPortNumber", EditPortNumber);
  //   // this.validateField("rtspStreamParameter", rtspStreamParameter);

  //   // const { errors } = this.state;

  //   if (Object.keys(errors).length > 0) {
  //     this.setState({ warning_device: true });
  //     return;
  //   }

      try {
        const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json', // Specify the content type
            'Authorization': `Bearer ${access_tocken}` // Optional: If your API requires an authorization token
          },
          body: post_data,

        });
        console.log("reponse in edit device info ------------->", response);
        this.stopLoading();
        const result = await response.json();
        if (response.ok) {

          this.setState({success_device_edit: true});

          // Delay before reload to allow user to see the alert
          setTimeout(() => {
            // window.location.reload();
            this.setState({editDeviceToggle: false});
            this.getDevicesListById(this.state.selectedSite);
            this.getRtspCamerasDevicesListBySiteId(this.state.selectedSite);

          }, 3000); // 1 seconds delay
        }
        else {
        this.setState({error_device_edit: true, responseMessage: result?.error?.[0]});

        }
      } catch (error) {
        this.setState({error_device_edit: true, responseMessage: "Server error! Device was not updated."});
        this.stopLoading();
        console.error('Error during update request:', error);
      }

  }

  handleDeviceDelete =  async (selected_device_id) => {
      try {
        const{selectedSite}= this.state
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        console.log("reponse in delete device url ------------->", url);
        const response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'content-Type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`,
          },

        });
        console.log("reponse in delete elevator ------------->", response);
        if (response.ok) {

        //   console.log("reponse.ok ------------->", response.ok);

          // const data =  response.json();
          console.log(`device with id ${selected_device_id} deleted successfully`, response);
          this.openSnackbar("Device deleted successfully!", 'success');

          setTimeout(() => {
            // this.getDevicesListById(selectedSite);
            // this.getRtspCamerasDevicesListBySiteId(selectedSite);
            window.location.reload();
            }, 1500);
          }
        else {
              const errorMessage =  response.statusText; // Read the error message from response body
              this.openSnackbar("Error while deleting the device, Try again!", 'error');
              // window.location.reload();

              setTimeout(() => {
                // this.getDevicesListById(selectedSite);
                // this.getRtspCamerasDevicesListBySiteId(selectedSite);
                window.location.reload();
                }, 1500);
        }
      } catch (error) {
        console.error('Error during delete request:', error);
      }

  }

    // getHDDColor = (storage) => {
    //   if (!storage) return "black"; // Default color in case of missing data

    //   const [used, total] = storage.split("/").map(value => parseFloat(value));
    //   if (isNaN(used) || isNaN(total) || total === 0) return "black"; // Handle edge cases

    //   const usedPercentage = (used / total) * 100;

    //   return usedPercentage < 80 ? "green" : "red"; // Green if < 80%, Red if ≥ 80%
    // };

  getHDDColor = (totalFreeSpace, totalSpace) => { //new func to show color based on addition of free space of all hdd
    if (!totalFreeSpace && !totalSpace) return "white"; // Default color in case of missing data

    // const [used, total] = storage.split("/").map(value => parseFloat(value));
    if (isNaN(totalFreeSpace) || isNaN(totalSpace) || totalSpace === 0) return "black"; // Handle edge cases

    const usedPercentage = (totalFreeSpace / totalSpace) * 100;

    return usedPercentage < 80 ? "#55ca59" : "red"; // Green if < 80%, Red if ≥ 80%  totalFreeSpace, totalSpace
  };

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

  handleSaveGroup = async() => {
    console.log("handleSaveGroup----:");
    const{group_name, parent_group} = this.state
    // if (!group_name) {
    //         this.setState({ warning_site: true });
    //         return;
    //     }
    if (!group_name || group_name.trim() === "") {
          this.setState({
              error_group: true,
              group_message: "Group Name cannot be empty"
          });
          return;
      }

        let data = JSON.stringify({
          "name": group_name,
          "assign_site_ids": parent_group
        });


        console.log("Data to be saved----:", data);
        this.startLoading()
        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`,

            }
            const response = await post(urls.CREATE_GROUP, data, headers);

            console.log("reposne of handleSaveGroup===> ", response);
            this.stopLoading();
            let resp_data = response?.data || response;

            if (resp_data.message && resp_data.message === "Group created successfully") {
                    this.setState({ success_group: true, group_message: resp_data.message  });

                // Delay for alert visibility before reload
                setTimeout(() => {
                    // window.location.reload();
                    this.setState({AddGroupToggle : false, group_name: "", parent_group: []});
                    this.getGroupsList();
                }, 1500);
            }
            else if (resp_data.error && resp_data.error.length > 0){
                console.error('Error:');
                this.setState({ error_group: true, group_message: resp_data.error[0]  });
            }
            else if (resp_data.name){
                console.error('resp_data.name: resp_data.name[0]');
                this.setState({ error_group: true, group_message: resp_data.name[0]  });
            }
        }
        catch (error) {
            console.error('Error:', error);
            this.setState({ error_group: true, group_message: "Failed to create group. Please try again."  });
        }

  }

  handleAddGroup = async() => {
    console.log("---handleAddGroup----");
    this.setState({ AddGroupToggle: true });
  }

  handleEditGroup = async() => {
    // console.log("---handleEditGroup----");
    this.setState({ anchorE3: null, EditGroupToggle: true });
  }

//     handleGroupSelection = (groupId, groupInfo) => {
//   this.setState((prevState) => {
//     // ✅ CLICK SAME GROUP → COLLAPSE
//     if (prevState.expandedGroupId === groupId) {
//       return {
//         expandedGroupId: null,
//         expandedSiteId: null,   // also collapse sites
//         selectedgroup: null,
//         selectedGroupInfo: null,
//         devices: [],
//         cameras: [],
//       };
//     }

//     // ✅ CLICK NEW GROUP → EXPAND
//     return {
//       expandedGroupId: groupId,
//       expandedSiteId: null,    // reset site expansion
//       selectedgroup: groupId,
//       selectedGroupInfo: groupInfo,
//       devices: [],
//       cameras: [],
//     };
//   }, () => {
//     // fetch sites only when expanding
//     if (this.state.expandedGroupId === groupId) {
//       this.getSiteListById(groupId);
//     }
//   });
// };

  handleGroupSelection = (groupId, groupInfo) => {
    this.closePagingModal();
    this.setState(prevState => {
      const isExpanded = prevState.expandedGroupId.includes(groupId);

      return {
        expandedGroupId: isExpanded
          ? prevState.expandedGroupId.filter(id => id !== groupId)
          : [...prevState.expandedGroupId, groupId],

        expandedSiteId: [], // reset sites when group changes
        selectedSiteInfo: null,
        selectedgroup: isExpanded ? null : groupId,
        selectedGroupInfo: isExpanded ? null : groupInfo,
        devices: [],
        cameras: [],
        openPagingModal: false,
      };
    }, () => {
      if (this.state.expandedGroupId.includes(groupId)) {
        this.getSiteListById(groupId);
      }
    });
  };

  getSiteListById = async (groupId) => {
    try {
      this.startLoading();

      const access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_tocken}`,
      };

      const url = urls.GET_SITES_OR_SUBGROUPS_BY_GROUP_ID(groupId);
      console.log("Calling API:", url);

      // ✅ get() already returns JSON
      const response = await get(url, headers);

      this.stopLoading();

      console.log("API RAW RESPONSE:", response);

      // ✅ no sites case
      if (!response || !Array.isArray(response.sites)) {
        this.setState({
          site_list_by_group: [],
          EditParentGroup: [],
        });
        return;
      }

      // ✅ SUCCESS CASE (THIS MATCHES YOUR RESPONSE)
      this.setState((prevState) => ({
        groupHierarchy: {
          ...prevState.groupHierarchy,
          [groupId]: {
            subgroups: [],              // backend doesn't send subgroups
            sites: response.sites,      // ✅ CORRECT
          },
        },
        EditParentGroup: response.sites.map(site => site.id),
        groupIdToEditInfo: groupId,
      }));

    } catch (error) {
      this.stopLoading();
      console.error("Error fetching sites from API:", error);
    }
  };

  getTaskTitle = (taskId) => {
  const { taskIds } = this.state;
  if (!taskIds) return "Unknown Task";

  // Reverse lookup: Find the key by value
  const taskMap = {
    disk_task: " Disk Info",
    device_info_task: " Device Info",
    chain_task: " Channel Info",
    time_zone:"Timezone Info",

  };

  for (const [key, value] of Object.entries(taskIds)) {
    if (value === taskId) {
      return taskMap[key] || "Unknown Task";
    }
  }

  return "Unknown Task";
  };

  handleGetGroupInfo = async (groupId) => {
    console.log("---handleGetGroupInfo--groupId-->", groupId);

    try {
      this.startLoading();
      this.setState({ anchorE3: null, EditGroupToggle: true });

      const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access_token}`,
      };

      const response = await get(
        urls.GET_SPECIFIC_GROUP_INFO(groupId),
        headers
      );

      console.log("API Response:", response);
      this.stopLoading();

      // ✅ CORRECT CHECK
      if (!response || !response.name) {
        console.error("No data returned from the API");
        return;
      }

      const siteIds = (response.sites || []).map(site => site.id);

      this.setState({
        EditGroupName: response.name,
        EditParentGroup: siteIds,
        initialParentGroup: siteIds,     // immutable/not changable (baseline for assigned sites)
        groupIdToEditInfo: response.id,
      });

    } catch (error) {
      this.stopLoading();
      console.error("Error fetching group info:", error);
    }
  };


  handleSaveUpdatedGroupInfo = async () => {
    const { EditGroupName, EditParentGroup, groupIdToEditInfo } = this.state;

    const payload = {
      name: EditGroupName,
      assign_site_ids: EditParentGroup, // 🔥 FIXED
    };

    console.log("FINAL UPDATE PAYLOAD →", payload);

    try {
      this.startLoading();

      const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

      const response = await fetch(
        urls.UPDATE_GROUP(groupIdToEditInfo),
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      console.log("UPDATE RESPONSE →", result);

      this.stopLoading();

      if (result.data?.message) {
        // ✅ sync selected sites from backend
        const assignedIds =
          result.data.group.assigned_sites?.map(site => site.id) || [];

        this.setState({
          EditParentGroup: assignedIds,
          success_device_edit: true,
          // EditGroupToggle: false,
        });

        // this.getGroupsList();
        setTimeout(() => {
              this.setState({ EditGroupToggle: false});
              this.getGroupsList();
            }, 1000); // 1.8 seconds delay
      } else {
        this.setState({ error_device_edit: true, editGroupRespMessage: result.name?.[0] || "Failed to update group. Please try again." });
      }
    } catch (err) {
      this.stopLoading();
      console.error("Update failed:", err);
      this.setState({ error_device_edit: true, editGroupRespMessage: "Server error! Failed to update group." });
    }
  };


  handleGroupDelete = async (groupId) => {
    console.log("---handleDeleteGroup--groupId-->", groupId);
    try {
      this.startLoading();
      this.setState({anchorE3: null});
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      // let headers = {
      //   'content-type': 'application/json',
      //   'Authorization': `Bearer ${access_tocken}`
      // }
      // const response = await del(urls.DELETE_GROUP(groupId), headers); //  API call to get the devices list w.r.t selected client
      const response = await fetch(urls.DELETE_GROUP(groupId),
        { method: 'DELETE',
        headers : {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
        }
        });
      console.log("API Response:---handleDeleteGroup---------------------------------------->>>", response)

      // EditGroupToggle, EditGroupName, EditParentGroup
      this.stopLoading();
      const result = await response.json();
  console.log("DELETE RESPONSE →", result);
  console.log("res", result.message);
      if (response.ok) {
        // let group = response
        console.log("res", response);

        this.openSnackbar("Group deleted successfully!", "success");
        setTimeout(() => {
          this.getGroupsList();
        }, 1500); // 1.5 seconds delay

      } else if(result?.message === "Cannot delete group. Sites are assigned to this group.") {
        // console.error("No data returned from the API");
        this.openSnackbar("Cannot delete group. Sites are assigned to this group.", "error");
        return;
      }
      else {
        console.error("No data returned from the API");
        this.openSnackbar("Something wrong happened. Group is not deleted!", "error");
        return;
      }

    } catch (error) {
      console.error("Error fetching sites from API:", error);
    }
  }

  handleSubgroupSelection = (subgroupId) => {
    this.setState({ selectedSubgroup: subgroupId });
    this.getSiteListById(subgroupId); //fetch site list based on selected group. selectedSubgroup
  };

  toggleDetails = (deviceId) => { //state change to show all hdd data onclick of 'i' icon
    this.setState((prevState) => ({
      showDiskDetails: {
        ...prevState.showDiskDetails,
        [deviceId]: !prevState.showDiskDetails[deviceId], // Toggle for specific row
      },
    }));
  };

  toggleDeviceUserList = (device) => { //state change to show all hdd data onclick of 'i' icon
    // this.setState((prevState) => ({
    //   showDeviceUserList: {
    //     ...prevState.showDeviceUserList,
    //     [deviceId]: !prevState.showDeviceUserList[deviceId], // Toggle for specific row
    //   },
    // }));
    console.log("--toggleDeviceUserList popup----");
    // this.setState({showDeviceUserList: true});
    this.setState({
      showDeviceUserList: true,
      selectedDeviceForUserList: device, // <- Save selected device
    });
  };

  handleCloseUserListModal = () => {
    this.setState({ showDeviceUserList:false }, () => {
      console.log("-----close user list modal----");
    });

  };

    //Arm Disarm Device Status ------------------- this function is no more required as the status of arm_disarm is now got included in device info api response.
//  fetchArmStatusForDevice = async (deviceId) => {
//   try {
//     const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
//     const headers = {
//       'Content-Type': 'application/json; charset=UTF-8',
//       'Authorization': `Bearer ${access_token}`,
//     };

//     const url = urls.GET_DEVICE_ARM_STATUS(deviceId);
//     const response = await get(url, headers);

//     // ✅ Use correct key: arm_disarm_status
//     if (response?.arm_disarm_status === 'armed' || response?.arm_disarm_status === 'disarmed') {
//       this.setState((prevState) => ({
//         devices: prevState.devices.map((device) =>
//           device.id === deviceId
//             ? { ...device, arm_disarm_status: response.arm_disarm_status }
//             : device
//         ),
//       }));
//     } else {
//       console.warn(`Unexpected arm status response for device ${deviceId}:`, response);
//     }

//   } catch (error) {
//     console.error("❌ Failed to fetch arm status for device", deviceId, error);
//   }
// };

  handleSiteDropdownToggle = (siteId) => {
    this.setState((prevState) => ({
      expandedSite: prevState.expandedSite === siteId ? null : siteId
    }));
  };
  // function to handle device and or site search input change

  handleDeviceSearchInputChange = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ searchInput: value });

    if (!value.trim()) {
      this.setState({ searchDevices: [] });
      return;
    }

    const matchedDevices = this.state.search_devices_list.filter(
      (device) =>
        device.device_name?.toLowerCase().includes(value)
    );

    this.setState({ searchDevices: matchedDevices });
  };

  getRtspCamerasDevicesListBySiteId = async (site_id) => {
    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      const response = await get(urls.GET_DEVICES_OF_SEPARATE_RTSP_CAMERAS(site_id), headers); //  API call to get the rtsp camera's sites(devices) list w.r.t selected group
      this.stopLoading();
      console.log("API Response:---getRtspCamerasDevicesListBySiteId---------------------------------------->>>", response.data)

      if (response) {
        const rtsp_cameras_device_list = response.data;
        this.setState({ loading: false, rtsp_cameras_devices: rtsp_cameras_device_list });
      }


      // if(response.error[0] === "device not found")
      // {
      //   this.setState({
      //     devices: [], loading: false });
      //   return
      // }
      else {
        console.error("No data returned from the API");
        this.setState({ rtsp_cameras_devices: []});
      }
    } catch (error) {
      console.error("Error fetching devices from API:", error);
    }
  };

  OpenRtspCameraAddForm = () => {
    this.setState({toggleAddSingleCamera: true, anchorE4: null})
  }

  InsertCameraInfoInExistingSite = async (e) => {
    e.preventDefault();
    this.startLoading();
    console.log("----InsertCameraInfoInExistingSite-----------");
    const { CameraName, rtspStreamParameter, existingSite, selectedDeviceID, selectedSite} = this.state;

    // Prepare payload
    let cameraData = {
        camera_name: CameraName,
        rtsp_path: rtspStreamParameter, // Example RTSP URL format
        };
    const data = JSON.stringify(cameraData);
    console.log("----camera-data to be sent---, existingSite", data, selectedDeviceID);

    if (!CameraName || !rtspStreamParameter) {
        this.setState({ warning_camera: true});
        this.stopLoading();
        return;
    }

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }

          let response = await post(urls.ADD_CAMERA(selectedDeviceID), data, headers);
          this.stopLoading();
          // console.log("url",urls.ADD_CAMERA);
          console.log("data res",response);
          if(response.data?.message === "Camera added successfully and snapshot triggered.") {
            this.setState({ success_camera_existing_site: true });
            setTimeout(() => {
              this.setState({ toggleAddSingleCamera: false });
              this.getRtspCamerasDevicesListBySiteId(selectedSite);
            }, 3000);
          }
          else {
            this.setState({ error_camera: true, response_message: response.error[0] });// Show error message from response
          }
    } catch (error) {
      this.stopLoading();
      this.setState({ error_camera: true, response_message: "An error occurred while adding the camera." });
    }
  }

  handleGroupSiteCheckbox = (siteId) => {
    this.setState((prevState) => {
      const exists = prevState.EditParentGroup.includes(siteId);
      const isInitiallyAssigned = prevState.initialParentGroup.includes(siteId);

      // Prevent unchecking if site was already saved/assigned to this group before.
    if (exists && isInitiallyAssigned) {
      return null; // no state change
    }

      return {
        EditParentGroup: exists
          ? prevState.EditParentGroup.filter(id => id !== siteId) // uncheck
          : [...prevState.EditParentGroup, siteId],              // check
      };
    });
  };

  handleAddGroupSiteCheckbox = (siteId) => {
    this.setState((prevState) => {
      const exists = prevState.parent_group.includes(siteId);

      return {
        parent_group: exists
          ? prevState.parent_group.filter(id => id !== siteId) // uncheck
          : [...prevState.parent_group, siteId],              // check
      };
    });
  };

  getSitesByGroupId = (groupId) => {
  return this.state.site_list.filter(
    site => site.group?.id === groupId
  );
};

// handleSearch = (e) => {
//   const searchText = e.target.value.toLowerCase();
//   const { groups_list } = this.state;

//   // Reset when cleared
//   if (!searchText) {
//     this.setState({
//       searchText,
//       filteredGroups: groups_list,
//       expandedGroupId: null,
//       expandedSiteId: null,
//     });
//     return;
//   }

//   let expandedGroupId = null;
//   let expandedSiteId = null;

//   const filteredGroups = groups_list
//     .map(group => {
//       const sites = Array.isArray(group.sites) ? group.sites : [];

//       const matchedSites = sites.filter(site => {
//         const siteMatch =
//           site.sitename?.toLowerCase().includes(searchText);

//         // const deviceMatch = site.devices?.some(device =>
//         //   device.device_name?.toLowerCase().includes(searchText)
//         // );

//         const deviceMatch = (site.devices || []).some(device =>
//     device.device_name?.toLowerCase().includes(searchText)
//   );

//         // ✅ auto-expand group & site
//         if ((siteMatch || deviceMatch) && expandedGroupId === null) {
//           expandedGroupId = group.id;
//           expandedSiteId = site.id;
//         }

//         return siteMatch || deviceMatch;
//       });

//       const groupMatch =
//         group.name?.toLowerCase().includes(searchText);

//       if (groupMatch && expandedGroupId === null) {
//         expandedGroupId = group.id;
//       }

//       if (groupMatch || matchedSites.length > 0) {
//         return {
//           ...group,
//           sites: groupMatch ? sites : matchedSites,
//         };
//       }

//       return null;
//     })
//     .filter(Boolean);

//   this.setState({
//     searchText,
//     filteredGroups,
//     expandedGroupId,
//     expandedSiteId,
//   });
// };

  handleSearch = (e) => {
    const searchText = e.target.value.toLowerCase();
    const { groups_list } = this.state;

    if (!searchText) {
      this.setState({
        searchText,
        filteredGroups: groups_list,
        expandedGroupId: [],
        expandedSiteId: [],
      });
      return;
    }

    const expandedGroupId = [];
    const expandedSiteId = [];

    const filteredGroups = groups_list
      .map(group => {
        const sites = Array.isArray(group.sites) ? group.sites : [];

        const matchedSites = sites
          .map(site => {
            const siteMatch =
              site.sitename?.toLowerCase().includes(searchText);

            const matchedDevices = (site.devices || []).filter(device =>
              device.device_name?.toLowerCase().includes(searchText)
            );

            // Site matches OR device inside site matches
            if (siteMatch || matchedDevices.length > 0) {
              expandedGroupId.push(group.id);
              expandedSiteId.push(site.id);

              return {
                ...site,
                devices: siteMatch ? site.devices : matchedDevices, // 🔥 hide other devices
              };
            }

            return null;
          })
          .filter(Boolean);

        const groupMatch =
          group.name?.toLowerCase().includes(searchText);

        if (groupMatch || matchedSites.length > 0) {
          if (groupMatch) expandedGroupId.push(group.id);

          return {
            ...group,
            sites: matchedSites, // 🔥 hide other sites
          };
        }

        return null;
      })
      .filter(Boolean);

    this.setState({
      searchText,
      filteredGroups,
      expandedGroupId: [...new Set(expandedGroupId)],
      expandedSiteId: [...new Set(expandedSiteId)],
    });
  };

 validateMacAddress = (mac) => {
    const macRegex = /^([0-9a-f]{2}(-)){5}[0-9a-f]{2}$/;
    return macRegex.test(mac);
  };

  handlePagingDeviceChange = (field, value) => {
    this.setState((prevState) => {
      const updatedDevices = [...prevState.gas_paging_devices];

      let formattedValue = value;

      // ✅ FORMAT MAC ADDRESS
      if (field === "mac_address") {
        formattedValue = value
          .replace(/[^0-9A-Fa-f]/g, "")   // remove invalid chars
          .toLowerCase()                 // lowercase
          .match(/.{1,2}/g)?.join("-") || ""; // add hyphen
      }

      updatedDevices[0][field] = formattedValue;


      let updatedErrors = { ...prevState.errors };

      // ✅ Clear MAC error when user edits it
      if (field === "mac_address") {
        delete updatedErrors.mac_address;
      }

      return {
        gas_paging_devices: updatedDevices,
        errors: updatedErrors
      };
    });
  };

  fetchSoundFilesForPagingDevice = async() => {
    //https://devapi.neudeep.com/api/alerts/speaker/msg-files/
    // this.setState({ openPagingModal: true });
    try{
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
          // 'content-type': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${access_tocken}`
      }
      // let url = urls.START_PAGING_DEVICE_TEST(paging_mac_address, paging_sound_file_id);
      // console.log("url START_PAGING_DEVICE_TEST",url);
      // this.setState({ isPaging: true }); // for testing the button style, without api triggering.
      let response = await get(`https://devapi.neudeep.com/api/alerts/speaker/msg-files/`, headers);
      // let response = await get(`https://api.eyeon8i.com/api/alerts/speaker/msg-files/`, headers);
      this.stopLoading();
      console.log("data res fetchSoundFilesForPagingDevice-->",response);
      if(!response) {
        console.error("Failed to load the audio files");
        this.setState({ openPagingModal: true });
      }
      else {
        this.setState({paging_audio_files: response});// Show error message from response
        setTimeout(() => {
          this.setState({ openPagingModal: true });
        }, 1000);
        // this.openSnackbar(`Failed to test the paging device with mac address : ${paging_mac_address}`, 'error');
      }
    }catch{
      console.error("Server error, Failed to load the audio files");
    }
  }

  startPagingDeviceTest = async() => {
    const {selectedSiteInfo, selectedAudioFile} = this.state;
    let paging_mac_address = selectedSiteInfo.gas_paging_devices?.[0]?.mac_address || null;
      // let paging_sound_file_id = selectedSiteInfo.paging_msg_files?.[0]?.file_id || null;
      console.log("selectedAudioFile", selectedAudioFile);
      if (!paging_mac_address || !selectedAudioFile) {
        this.openSnackbar(`Paging device's MAC address or sound file is missing.`, 'error');
        return;
      }
    try {

      console.log("--- paging_mac_address",paging_mac_address);
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
          // 'content-type': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${access_tocken}`
      }
      let url = urls.START_PAGING_DEVICE_TEST(paging_mac_address, selectedAudioFile);
      console.log("url START_PAGING_DEVICE_TEST",url);
      // this.setState({ isPaging: true }); // for testing the button style, without api triggering.
      let response = await post(urls.START_PAGING_DEVICE_TEST(paging_mac_address, selectedAudioFile), headers);
      this.stopLoading();
      console.log("data res",response);
      if(response.success) {
        this.setState({ isPaging: true });
        this.openSnackbar(`Test of paging device with mac address : ${paging_mac_address} is successfully started`, 'success');
      }
      else {
        // this.setState({ error_camera: true, response_message: response.error[0] });// Show error message from response
        this.openSnackbar(`Failed to test the paging device with mac address : ${paging_mac_address}`, 'error');
      }

    } catch (error) {
      this.stopLoading();
      this.openSnackbar('Failed to test the paging device', 'error');
    }
  }

  stopPagingDeviceTest = async() => {
    const {selectedSiteInfo, selectedAudioFile} = this.state;
    try {
      let paging_mac_address = selectedSiteInfo.gas_paging_devices?.[0].mac_address || null;
      // let paging_sound_file_id = selectedSiteInfo.paging_msg_files?.[0].file_id || null;
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
          // 'content-type': 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${access_tocken}`
      }
      // this.setState({ isPaging: false });
      let response = await post(urls.STOP_PAGING_DEVICE_TEST(paging_mac_address, selectedAudioFile), headers);
      this.stopLoading();
      // console.log("url",urls.ADD_CAMERA);
      console.log("data res",response);
      if(response.success) {
        this.openSnackbar('Test of paging device is stopped successfully', 'success');
        this.setState({ isPaging: false });
      }
      else {
        this.openSnackbar('Failed to stop the testing of paging device', 'error');
      }

    } catch (error) {
      this.stopLoading();
      // this.setState({ isPaging: false });
      this.openSnackbar('Failed to test the paging device', 'error');
    }
  }

  closePagingModal = () => {
  if (this.state.openPagingModal && this.state.isPaging) {
    this.stopPagingDeviceTest();
    this.setState({ openPagingModal: false });
    console.log("----close paging modal if block: stopped paging test too.----");
  }
  else if (this.state.openPagingModal && !this.state.isPaging) {
    this.setState({ openPagingModal: false });
    console.log("----close paging modal else block----");
  }
  else{
    // this.setState({ openPagingModal: false });
    console.log("skipping the paging modal close");
  }

};

  render() {
    const { devices, currentPage, rowsPerPage, searchInput, selectedSiteInfo,
     selectedSite,  site_list,  user_type } = this.state;

    const {toggleAddSite, sitename,  city, street, zip, state, organisationName, warning_site, success_site, error_site, client_list, toggleAddDevice,
       country, editToggle, edit_sitename, edit_address, edit_organisation_name, success, error, edit_selected_Customers_list,
       edit_city, edit_zip, edit_state, edit_country, edit_map_link} = this.state;

    const {loading, deviceName, deviceType, ipAddress, protocol, portNumber, rtsp_port, deviceUsername,
    devicePassword, warning_device, warning1_device, error_device, error1_device, success_device,
    device_type_list, showModal, showTestModal, responseMessage, anchorEl, anchorE2, anchorE3, anchorE4,
    confirmDialog, AddGroupToggle, group_name, parent_group, selectedgroup, rtspStreamParameter  } = this.state

    const { editDeviceToggle , Selected_Device_Id, EditDeviceName, EditDeviceType, EditProtocol, EditPortNumber, EditIpAddress, EditRTSPAddress,
      EditDeviceUsername, EditDevicePassword, success_device_edit, error_device_edit, passwordShown, groups_list, site_list_by_group, subgroup_list_by_group } = this.state

      const {EditGroupToggle, EditGroupName, EditParentGroup, selectedSubgroup,  error_group, success_group, showDiskDetails, showDeviceUserList,
        open_siteEnable_disable_Dialogue, toggleAddSingleCamera, success_camera, error_camera, warning_camera, rtsp_cameras_devices,
        warning1_camera, global_alarm_status, success_camera_existing_site, cust_contact_no, police_dept_contact_no, fire_dept_contact_no,
      edit_cust_contact_no, edit_police_dept_contact_no, edit_fire_dept_contact_no, cust_contact_no_1, edit_cust_contact_no_1, map_link, isPaging } = this.state;

    const open = Boolean(anchorEl);
    const open1 = Boolean(anchorE2);
    const open2 = Boolean(anchorE3);
    const open4 = Boolean(anchorE4);

    // Ensure devices is an array
    // const searchResults = this.state.searchDevices;

    // Group matched devices by site_id
      const groupedDevices = {};
      site_list.forEach(site => {
        // Combine both devices and rtsp_cameras_devices arrays safely
        const allDevices = [
          ...(site.devices || []),
          ...(site.rtsp_cameras_devices || []),
        ];
        const matchedDevices = allDevices?.filter(device =>
          device.device_name?.toLowerCase().includes(searchInput)
        );
        if (searchInput && matchedDevices?.length) {
          groupedDevices[site.id] = matchedDevices;
        }
      });


      const filtered_Sites = site_list.filter(site => {
        const siteNameMatch = site.sitename?.toLowerCase().includes(searchInput);
        const deviceMatch = site.devices?.some(device =>
          device.device_name?.toLowerCase().includes(searchInput)
        );
        return searchInput ? siteNameMatch || deviceMatch : true;
      });


    const getDevicesForSite = (siteId) => {
      if (searchInput && groupedDevices[siteId]) {
        return groupedDevices[siteId];
      }
      const site = site_list.find((s) => s.id === siteId);
      return site?.devices || [];
    };



    // const filtered_Sites = searchResults.length > 0
    //   ? site_list.filter(site => groupedDevices[site.id]) // only show sites that have matching devices
    //   : site_list.filter(site =>
    //       site.sitename?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    //     );


    const filtered_groups = this.state.searchText
  ? this.state.filteredGroups
  : this.state.groups_list;

    // const searchText = this.state.searchInput.toLowerCase();

    // const filtered_groups = (this.state.groups_list || []).filter(group => {
    //   if (!searchText) return true;

    //   if (group.name?.toLowerCase().includes(searchText)) {
    //     return true;
    //   }

    //   const groupSites = this.getSitesByGroupId(group.id);

    //   return groupSites.some(site =>
    //     site.sitename?.toLowerCase().includes(searchText) ||
    //     (site.devices || []).some(device =>
    //       device.device_name?.toLowerCase().includes(searchText)
    //     )
    //   );
    // });





    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    // const currentRows = filtered_Devices.slice(indexOfFirstRow, indexOfLastRow);
    // const currentSites = filtered_Sites.slice(indexOfFirstRow, indexOfLastRow);
    // const currentCamRows = filteredCameras.slice(indexOfFirstRow, indexOfLastRow);

    const customerOptions = client_list.map((customer) => ({
      value: customer.user_id,
      label: customer.username,
    }));

    const password_visibility = localStorage.getItem(globalVariables.PASSWORD_VISIBILITY);
    const isSearching = Boolean(this.state.searchText);


    // console.log("customerOptions-----", customerOptions);

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <div className="show-devices-page" style={{height:'100vh', overflow:'hidden'}}>
          {/* Global connectivity monitor */}
            <InternetConnectionDetector />
          {/* Navigation Bar */}
          <Navigationbar />

            <div className="show-devices-content" style={{display: 'flex', flexDirection: 'column', marginLeft:'93px',maxWidth:'100%'}}>
              {/* Main Content with Flexbox Layout */}
              <Box className="show-devices-layout" sx={{ display: 'flex', flexGrow: 1, justifyContent:'space-between', width:'100%'}}>
              {/* Vertical Menu for Sites */}
              <Box
                className="show-devices-sidebar"
                sx={{
                  width: '220px', // Adjust the width of the sidebar
                  // backgroundColor: '#fff',
                  marginLeft: '9px',
                  borderLeft: '1px solid #7d8fa7',
                  padding: '8px',
                  overflowY: 'scroll', // Enable vertical scrolling
                  flexShrink: 0, // Prevent sidebar from shrinking
                  overflowX: "hidden",
                  height:'97vh',
                  // Scrollbar styling
                  /* scrollbar width always same */
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },

                  "&::-webkit-scrollbar-track": {
                    background: "transparent",
                  },

                  /* hidden by default */
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "transparent",
                    borderRadius: "20px",
                    // transition: "background-color 0.2s ease",
                  },

                  /* visible on hover */
                  "&:hover::-webkit-scrollbar-thumb": {
                    backgroundColor: "#235792",
                  },
                  // scrollbarWidth: "none",
                }}
              >
                {/* uncomment below div for grouping feature */}
                <div style={{display:'flex', justifyContent:'space-between'}}>
                  <Typography variant="h6" gutterBottom style={{color:'#cbe4ff', paddingLeft:'8px'}}>
                    Groups
                  </Typography>

                  {user_type === "DealerUser" && (
                        <Button
                          id="rowsPerPageButton"
                          onClick={this.handleAddGroup}
                          variant="contained"
                          style={{minWidth:'35px', height:'25px'}}
                          >
                          {"+"}
                        </Button>
                      )}
                </div>

                {/* <div style={{display:'flex', justifyContent:'space-between'}}>
                  <Typography variant="h6" gutterBottom style={{color:'#1058a0', paddingLeft:'8px'}}>
                    Groups
                  </Typography>
                </div> */}
                {/* Filter and Search, site list */}
                    <Box display="flex" gap={1} marginBottom={2}>
                      <TextField
                        label="Search by Group/Site Name"
                        variant="outlined"
                        value={this.state.searchText}
                        sx={{
                          flexGrow: 1,
                          "& .MuiOutlinedInput-root": {
                            height: "35px", // Adjust the height of the input box
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "14px", // Resize the label
                            top: "-6px",
                          },
                          "& .MuiInputLabel-shrink": {
                            fontSize: "12px", // Adjust the label size when shrunk
                          },
                        }}
                        onChange={this.handleSearch}
                      />
                    </Box>
                     <List>
                      {/* commented group mapping for production */}
                      {filtered_groups.map((group) => {
                          // const groupData = this.state.groupHierarchy[group.id] || {};
                          const isGroupExpanded =
                          this.state.expandedGroupId.includes(group.id);

                          const groupSites = isSearching
                          ? group.sites || []
                          : (this.state.groupHierarchy[group.id]?.sites || []);

                          return (
                            <React.Fragment key={group.id}>
                            <div style={{display:'flex'}}>
                              <ListItemButton
                              selected={isGroupExpanded}
                              onClick={() => this.handleGroupSelection(group.id, group)} sx={{ pl: 1 }}>
                                <ListItemIcon sx={{ minWidth: '35px' }}>
                                  <FolderIcon style={{ color: '#ededed' }} />
                                </ListItemIcon>
                                {group.name}
                              </ListItemButton>
                              <div>
                              <IconButton onClick={(event) => this.handleGroupKebabClick(event, group)}>
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                anchorEl={anchorE3}
                                open={open2}
                                onClose={this.handleClose}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <MenuItem onClick={() => this.handleGetGroupInfo(this.state.selectedGroupForMenu.id)}>Edit Group</MenuItem>
                                <MenuItem onClick={()=>this.openDialog(() => this.handleGroupDelete(this.state.selectedGroupForMenu.id))}>Delete Group</MenuItem>
                              </Menu>
                              </div>
                            </div>


                            {isGroupExpanded &&
    (groupSites && groupSites.length > 0 ? (
      groupSites.map(site => {

        // const isExpanded = this.state.expandedSiteId === site.id;
        const isExpanded =
      this.state.expandedSiteId.includes(site.id);
        // const devices = isExpanded ? this.state.devices : [];
        const devices = isExpanded ? (site.devices || this.state.devices) : [];

        return (
          <React.Fragment key={site.id}>

            {/* ================= SITE ================= */}
            <ListItemButton
              onClick={() => this.handleSiteSelection(site.id, site)}
              selected={isExpanded}
              sx={{
                pl: 3,
                bgcolor: isExpanded ? "#f5f7ff" : "transparent",
                borderRadius: "6px",
              }}
            >
              <StyledTooltip
                            // title={`Mute Count: ${site.mute_true_count}\nUnmute Count: ${site.mute_false_count}\nArmed count: ${site.armed_count}\ndisarmed count: ${site.disarmed_count}`}
                            title={
                              <div style={{ whiteSpace: "pre-line" }}>
                                {`Muted: ${site.mute_true_count}
                                Unmuted: ${site.mute_false_count}
                                Armed site: ${site.armed_count}
                                Disarmed site: ${site.disarmed_count}`}
                              </div>
                              }
                            placement="right" arrow>
            <div style={{ display: "flex", alignItems: "center" }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <FolderSpecialRoundedIcon fontSize="small" style={{ color: '#d4d4d4' }} />
              </ListItemIcon>

              <ListItemText primary={site.sitename}
                sx={{
                   "& .MuiTypography-root": {
                    color: "#d4d4d4",
                    whiteSpace: "normal",   // allow wrapping
                    wordBreak: "break-word" // break long words if needed
                  }
                }} />
            </div>
            </StyledTooltip>
              {/* ▶ / ▼ Site Arrow */}
              {isExpanded ? (
                <ExpandLess fontSize="small" />
              ) : (
                <ExpandMore fontSize="small" />
              )}
            </ListItemButton>

            {/* ================= DEVICES ================= */}
            {isExpanded &&
              devices.map(device => (
                <ListItemButton
                  key={device.id}
                  sx={{
                    pl: 5,
                    cursor: "default",
                    "&:hover": { bgcolor: "transparent" },
                  }}
                >
                  <img src={DeviceIcon} width="18" alt="device_icon"/> &nbsp;
                  <ListItemText
                    onClick={() => this.handleAboutDeviceNavigation(device.id, site.sitename, device.device_name, site.id, device.global_alarm, device.unmute_count )}
                    style={{ cursor: 'pointer' }}
                    primary={device.device_name}
                    sx={{ color: "#c6c6c6" }}
                  />
                </ListItemButton>
              ))}

          </React.Fragment>
        );
      })
    ) : (
      /* ================= EMPTY GROUP ================= */
      <ListItemText
        sx={{
          pl: 4,
          // color: "#999",
          fontStyle: "italic",
        }}
      >
        No sites available
      </ListItemText>
    ))}



                            </React.Fragment>
                          );
                        })}
                    </List>


                </Box>

                {/* Main Content Area */}
                <Box
                  className="show-devices-main"
                  style={{
                    flexGrow: 1, // Occupy remaining horizontal space
                    padding: '6px',
                    height:'100vh',
                    overflowY:'scroll', // Enable vertical scrolling for main content
                    overflowX:'hidden', //for device table scrolling, parent component should have this css
                    "&::-webkit-scrollbar": {
                    width: "8px",
                  },

                  "&::-webkit-scrollbar-track": {
                    background: "transparent",
                  },

                  /* hidden by default */
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#235792",
                    borderRadius: "20px",
                    // transition: "background-color 0.2s ease",
                  },

                  /* visible on hover */
                  // "&:hover::-webkit-scrollbar-thumb": {
                  //   backgroundColor: "rgba(29,142,255,0.75)",
                  // },
                    // scrollbarWidth: "none",
                  }}
                >
                <div>
                  <Box className="show-devices-page-header" component={Paper} style={{display: 'flex',justifyContent: 'space-between', alignItems: 'center', paddingLeft: '8px',
                    // backgroundColor:'white',
                     height:'1.2cm'}}>
                      <Typography variant="h6">
                        Site Management Dashboard
                      </Typography>
                  {user_type === "DealerUser" && (
                        <Button
                          id="rowsPerPageButton"
                          onClick={this.NavigateToAddSIte}
                          variant="contained"
                          >
                          {"+ Add Site"}
                        </Button>
                      )}
                  </Box>
                </div>
                {selectedSiteInfo ? (
                  <>
                  {/* Selected Site Information */}
                    {/* <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '10px',
                        flexWrap: 'wrap'
                      }}
                    >
                      <Typography
                        variant="h6"
                        gutterBottom
                        style={{ color: '#84a8d1' }}
                      >
                        Site : {this.state.selectedSiteInfo?.sitename}
                      </Typography>



                    </div> */}
                    <TableContainer className="show-devices-site-table" component={Paper} sx={{ marginBottom: '6px', maxWidth: '100%', marginTop: '10px', border: '1px solid #5b6e87' }}>
                      <Box className="show-devices-site-heading" sx={{display: 'flex', justifyContent: 'space-between', mt:1, paddingLeft:'16px', paddingRight:'14px'}}>
                        <Typography variant="h6" sx={{ mb: 1, color: '#a4c4f1'}}>
                          Site Details : {this.state.selectedSiteInfo?.sitename}
                        </Typography>
                        {!this.state.openPagingModal && (
                        <Box>
                          <Button sx={{
                            color: '#d4d4d4',
                            background: "linear-gradient(145deg, #1b2a43, #234a7c)",
                            '&:hover': {
                                background: "linear-gradient(145deg, #213247, #2a6395)",
                              },}} onClick={this.fetchSoundFilesForPagingDevice}>Test Paging device</Button>
                        </Box>
                        )}


                      </Box>
                      <Table sx={{
                          "& .MuiTableCell-root": {
                            // borderBottom: "none",
                            padding: "4px 12px"
                          },
                          mt: 2,
                        }}
                      >
                        <TableHead>

                          <TableRow>
                            {/* <TableCell align="center">
                              <Typography fontWeight={550} variant="subtitle2" sx={{whiteSpace: 'nowrap'}}>Site Name</Typography>
                            </TableCell> */}
                            <TableCell align="left">
                              <Typography fontWeight={550} variant="subtitle1" color="#a5b7cd">Location</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight={550} variant="subtitle1" color="#a5b7cd">Timezone</Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight={550} variant="subtitle1" color="#a5b7cd">Organisation Name</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography fontWeight={550} variant="subtitle1" color="#a5b7cd"> Actions</Typography>
                            </TableCell>
                            {/* <TableBody>

                            </TableBody> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            {/* <TableCell align="center">
                              <Typography variant="subtitle2">
                                {selectedSiteInfo?.sitename || 'N/A'}
                              </Typography>
                            </TableCell> */}
                            <TableCell align="left">
                              <Typography variant="subtitle2">
                                {/* {selectedSiteInfo?.address || 'N/A'} */}
                                {selectedSiteInfo
                                ? `${selectedSiteInfo.street || ""}, ${selectedSiteInfo.city || ""},
                                  ${selectedSiteInfo.zip || ""}, ${selectedSiteInfo.state || ""},
                                  ${selectedSiteInfo.country || ""}`
                                : "N/A"}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="subtitle2">
                                {selectedSiteInfo?.timezone || 'N/A'}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography variant="subtitle2">
                                {selectedSiteInfo?.organisation_name || 'N/A'}
                              </Typography>
                            </TableCell>
                            {user_type !== "CustomerUser" && (
                            <TableCell sx={{display:'flex', justifyContent:'flex-end', gap:4}}>
                              {/* Delete Site */}
                             {user_type === "DealerUser" && (
                              <Tooltip
                                title="Delete Site. Along with site all devices under this site will be removed."
                                componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: '#283348',
                                    color: '#fff',
                                    fontSize: '12px',
                                    border: '1px solid #99acb8',
                                  },
                                },
                                arrow: {
                                  sx: {
                                    color: '#283348',
                                  },
                                },
                                }}
                                  >
                                <IconButton
                                  size="small"
                                  sx={{backgroundColor:'#8c3939', borderRadius: "6px",}}
                                  onClick={()=>this.openDialog(() => this.handleDelete(selectedSiteInfo.id))}
                                >
                                  <Delete fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              )}
                              {/* Edit site */}
                              <Tooltip
                                title="Edit Site Information"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: '#283348',
                                      color: '#fff',
                                      fontSize: '12px',
                                      border: '1px solid #99acb8',
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: '#283348',
                                    },
                                  },
                                }}
                              >
                              <IconButton
                                size="small"
                                sx={{backgroundColor:'#2e6069', borderRadius: "6px",}}
                                onClick={this.handleEdit}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                              </Tooltip>
                              {/* Delete Paging device */}
                              {user_type === "DealerUser" && (
                                <Tooltip
                                  title="Remove Paging Device"
                                  componentsProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: '#283348',
                                      color: '#fff',
                                      fontSize: '12px',
                                      border: '1px solid #99acb8',
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: '#283348',
                                    },
                                  },
                                  }}
                                  >
                                <IconButton
                                  size="small"
                                  sx={{backgroundColor:'#8c3939', borderRadius: "6px",
                                    p: 0.20,          // Reduce padding (2px)
                                    width: 32,        // Optional fixed button size
                                    height: 30,
                                  }}
                                  onClick={()=>this.openDialog(() => this.handleDeletePagingDevice(selectedSiteInfo.id))}
                                >
                                  <img src={DeletepagingDeviceIcon} alt="delete_paging_device" width={33} height={31} />

                                </IconButton>
                                </Tooltip>
                              )}
                            </TableCell>
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* device heading and Add device button */}
                    <Box className="show-devices-list-heading" component={Paper} sx={{display: 'flex',justifyContent: 'space-between',alignItems: 'center', marginTop:'16px', marginBottom:'12px'}}>
                        <Typography variant="h6" gutterBottom sx={{ mb: 1, mt:3, color: '#a4c4f1', paddingLeft:'16px', display:'flex', alignItems:'center' }} >
                          Device List
                        </Typography>
                        <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                          <img src={SyncIcon} alt="sync-icon" width="50px"
                          // disabled={!this.state.siteStatusMap}
                          onClick={this.deviceSync} title="Sync Devices" style={{cursor: 'pointer' }} />
                          {user_type === "DealerUser" && (
                            <>
                            <Button
                              id="rowsPerPageButton"
                              onClick={this.NavigateToAddDevice}
                              variant="contained"
                              style={{cursor: 'pointer'}}
                            >
                              {"+ Add Device"}
                            </Button>
                            {/* <Button
                              id="rowsPerPageButton"
                              onClick={() => this.setState({ toggleAddSingleCamera: true })}
                              variant="contained"
                              style={{cursor: 'pointer'}}
                            >
                              {"+ Add Site with RTSP Camera"}
                            </Button> */}
                            </>
                          )}
                        </div>
                    </Box>

                    {/* Map devices */}
                      {
                        devices.length > 0 ? (
                          <Grid container spacing={2}>
                            {devices.map((device) => (
                              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={device.id}>
                                <Card
                                  className="show-devices-device-card"
                                  sx={{
                                    backgroundColor: '#1d2533',
                                    color: '#fff',
                                    border: '1px solid #5b6e87',
                                    borderRadius: 2,
                                    transition: '0.3s',
                                    '&:hover': { boxShadow: '0 0 10px #225c8b' },
                                  }}
                                >
                                  <CardContent sx={{ p: '12px !important' }}>

                                    {/* -- TOP HEADER: Device name + Action menu -- */}
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                      <Box display="flex" alignItems="center">
                                        <Typography sx={{ color: '#9ca4b4', fontSize:'18px'}}>
                                         Name:&nbsp;
                                        </Typography>
                                        <Tooltip
                                          title={`Click to view more details of ${device.device_name}`}
                                          componentsProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: '#283348',
                                                color: '#fff',
                                                fontSize: '12px',
                                                border: '1px solid #99acb8',
                                              },
                                            },
                                            arrow: {
                                              sx: {
                                                color: '#283348',
                                              },
                                            },
                                          }}
                                        >
                                        <Typography
                                          variant="h7"
                                          sx={{ cursor: 'pointer', lineHeight: 1.2, padding: '6px',
                                             textDecoration: 'underline',
                                             textDecorationColor: '#e3e3e3',
                                            //  border: '1px solid #05318e',
                                            // backgroundColor: '#0b2b48',
                                            boxShadow: '0 0 10px #2f465a',
                                            background: 'linear-gradient(145deg, #233346,rgb(30, 93, 148))',
                                              '&:hover': {
                                                // background: 'linear-gradient(145deg, #124273,rgb(6, 120, 148))',
                                                // boxShadow: '0 0 15px #2f465a',
                                                background: 'transparent',
                                              },
                                             }}
                                          onClick={() =>
                                            this.handleAboutDeviceNavigation(
                                              device.id,
                                              device.site_name,
                                              device.device_name,
                                              device.sitedb,
                                              device.global_alarm,
                                              device.unmute_count
                                            )
                                          }
                                        >
                                          {device.device_name}
                                        </Typography>
                                        </Tooltip>
                                      </Box>
                                      {/* Action kebab */}
                                      <Box display="flex" alignItems="center" gap={5.5}>

                                        {/* Delete */}
                                        {user_type === 'DealerUser' && (
                                          <Tooltip
                                            title="Delete Device"
                                            componentsProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: '#283348',
                                                color: '#fff',
                                                fontSize: '12px',
                                                border: '1px solid #99acb8',
                                              },
                                            },
                                            arrow: {
                                              sx: {
                                                color: '#283348',
                                              },
                                            },
                                          }}
                                           >
                                          <IconButton
                                            size="small"
                                            sx={{backgroundColor:'#8c3939', borderRadius: "6px",}}
                                            onClick={() =>
                                              this.openDialog(() =>
                                                this.handleDeviceDelete(device.id)
                                              )
                                            }
                                          >
                                            <Delete fontSize="small" />
                                          </IconButton>
                                          </Tooltip>
                                        )}

                                        {/* Edit */}
                                        {user_type === 'DealerUser' && (
                                          <Tooltip
                                            title="Edit Device Information"
                                            componentsProps={{
                                              tooltip: {
                                                sx: {
                                                  backgroundColor: '#283348',
                                                  color: '#fff',
                                                  fontSize: '12px',
                                                  border: '1px solid #99acb8',
                                                },
                                              },
                                              arrow: {
                                                sx: {
                                                  color: '#283348',
                                                },
                                              },
                                            }}
                                          >
                                          <IconButton
                                            size="small"
                                            sx={{backgroundColor:'#2e6069', borderRadius: "6px",}}
                                            onClick={() => this.LoadSelectedDeviceInfo(device.id)}
                                          >
                                            <Edit fontSize="small" />
                                          </IconButton>
                                          </Tooltip>
                                        )}

                                        {/* Test Connection  */}
                                        <Tooltip
                                            title="Test NVR Device"
                                            componentsProps={{
                                              tooltip: {
                                                sx: {
                                                  backgroundColor: '#283348',
                                                  color: '#fff',
                                                  fontSize: '12px',
                                                  border: '1px solid #99acb8',
                                                },
                                              },
                                              arrow: {
                                                sx: {
                                                  color: '#283348',
                                                },
                                              },
                                            }}
                                          >

                                        <IconButton
                                          size="small"
                                          disabled={device?.device_status === 'inactive'}
                                          onClick={() => this.TestConnection(device)}
                                          sx={{backgroundColor:'#304d76', borderRadius: "6px",}}
                                        >
                                          <UpdateIcon fontSize="small" />
                                        </IconButton>
                                        </Tooltip>
                                      </Box>
                                    </Box>

                                    {/* ── MAIN BODY: Left panel | Divider | Right panel ── */}
                                    <Box className="show-devices-card-body" display="flex" gap={0} sx={{ border: '1px solid #343c50', borderRadius: '8px', overflow: 'hidden' }}>

                                      {/* ════════════════════════════════
                                          LEFT PANEL — Status & Health Stats
                                          ════════════════════════════════ */}
                                      <Box
                                        sx={{
                                          flex: 1,
                                          p: '10px 12px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: 1,
                                        }}
                                      >
                                        {/* Online badge + Globe icon */}
                                        <Box display="flex" alignItems="center" gap={1}>
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              backgroundColor:
                                                device.device_status === 'active' &&
                                                (device.status === 'active' || device.status === 'Online')
                                                  ? '#238636'
                                                  : device.device_status === 'inactive' &&
                                                    (device.status === 'active' || device.status === 'Online')
                                                  ? '#f59834'
                                                  : '#AC3E31',
                                              px: 1,
                                              py: 0.3,
                                              borderRadius: 5,
                                            }}
                                          >
                                            {device.device_status === 'inactive'
                                                  ? 'Inactive'
                                                  : device.status === 'active' || device.status === 'Online'
                                                  ? 'Online'
                                                  : 'Offline'}
                                          </Typography>

                                          <Typography
                                            variant="body2"
                                            sx={{ color: '#9ca4b4', display: 'flex', alignItems: 'center' }}
                                          >
                                            <Tooltip
                                              title={
                                                <>
                                                  {`${device.protocol}://${device.ip_address}:${device.port_number}`}
                                                  <br />
                                                  <div style={{ textAlign: 'center' }}>Click to go to this address</div>
                                                </>
                                              }
                                              componentsProps={{
                                              tooltip: {
                                                sx: {
                                                  backgroundColor: '#283348',
                                                  color: '#fff',
                                                  fontSize: '12px',
                                                  border: '1px solid #99acb8',
                                                },
                                              },
                                              arrow: {
                                                sx: {
                                                  color: '#283348',
                                                },
                                              },
                                            }}
                                            >
                                              <a
                                                href={`${device.protocol}://${device.ip_address}:${device.port_number}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <img src={LinkIcon} alt="ip-globe-icon" width="40px" />
                                              </a>
                                            </Tooltip>
                                          </Typography>
                                        </Box>

                                        {/* ── 2×2 Stat grid ── */}
                                        <Box
                                          sx={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '6px',
                                          }}
                                        >
                                          {/* Health */}
                                          <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', display:'flex', alignItems: 'center' }}>
                                              Recording Health
                                              <Tooltip
                                                title={'Health of device w.r.t its number of camera(s) having recording days issues.  If the device is offline, it will show a red cross mark regardless of the recording status.'}
                                                componentsProps={{
                                                  tooltip: {
                                                    sx: {
                                                      backgroundColor: '#283348',
                                                      color: '#fff',
                                                      fontSize: '12px',
                                                      border: '1px solid #99acb8',
                                                    },
                                                  },
                                                  arrow: {
                                                    sx: {
                                                      color: '#283348',
                                                    },
                                                  },
                                                }}
                                              >
                                                <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8 }} />
                                              </Tooltip>
                                            </Typography>
                                            <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                              {device.policy_issues_count === 0 &&
                                              (device.status === 'active' || device.status === 'Online') ? (
                                                <CheckCircleIcon color="success" fontSize="small" />
                                              ) : (
                                                <>
                                                  <Typography variant="body2" sx={{ color: '#cdd5e5', fontWeight: 500 }}>
                                                    {device.policy_issues_count}
                                                  </Typography>
                                                  <CancelIcon color="error" fontSize="small" />
                                                </>
                                              )}
                                            </Box>
                                          </Box>

                                          {/* Armed */}
                                          <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                              Armed
                                            </Typography>
                                            <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                              {device.arm_disarm_status === undefined ? (
                                                <Tooltip title="Fetching status...">
                                                  <ReportProblemIcon sx={{ color: '#FFA000' }} fontSize="small" />
                                                </Tooltip>
                                              ) : device.arm_disarm_status === 'armed' ? (
                                                <>
                                                  <Typography variant="body2" sx={{ color: '#cdd5e5', fontWeight: 500 }}>
                                                    {device?.status === 'inactive' || device?.status === 'offline'
                                                      ? '0'
                                                      : device.unmute_count || 0}
                                                  </Typography>
                                                  <Tooltip title="Device is Armed">
                                                    <CheckCircleIcon color="success" fontSize="small" />
                                                  </Tooltip>
                                                </>
                                              ) : (
                                                <Tooltip title="Device is Disarmed">
                                                  <CancelIcon color="error" fontSize="small" />
                                                </Tooltip>
                                              )}
                                            </Box>
                                          </Box>

                                          {/* Storage Health */}
                                          <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                              Storage Health
                                            </Typography>
                                            <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                              {device && device.hard_disks.length > 0 ? (
                                                (() => {
                                                  const { hard_disks, device_type_name, status, id } = device;
                                                  const allHikevisionHealthy = hard_disks.every(d => d.status === 'idle' || d.status === 'ok');
                                                  const allNvrHealthy = hard_disks.every(d => d.status === 'RW' || d.status === 'read/write');
                                                  const allDigitalWatchdogHealthy = hard_disks.every(d => d.status === 'used|dbReady' || d.status === 'Online');
                                                  const allUNV = hard_disks.every(d => d.status === 'Normal');
                                                  const allDahua = hard_disks.every(d => d.status === 'ReadWrite');
                                                  const allNorthernHealthy = hard_disks.every(d => d.status === 'RW');

                                                  const isHikevision = device_type_name === 'hikvision';
                                                  const isTvtNvr = device_type_name === 'nvr';
                                                  const isDigitalWatchdog = device_type_name === 'digital_watch_dog';
                                                  const isUNV = device_type_name === 'unv';
                                                  const isDahua = device_type_name === 'dahua';
                                                  const isNorthern = device_type_name === 'northern';
                                                  const multipleDisks = hard_disks.length > 1;

                                                  let isHealthy = false;
                                                  if (isHikevision) isHealthy = allHikevisionHealthy;
                                                  else if (isTvtNvr) isHealthy = allNvrHealthy;
                                                  else if (isDigitalWatchdog) isHealthy = allDigitalWatchdogHealthy;
                                                  else if (isUNV) isHealthy = allUNV;
                                                  else if (isDahua) isHealthy = allDahua;
                                                  else if (isNorthern) isHealthy = allNorthernHealthy;

                                                  return (
                                                    <>
                                                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        {status === 'active' ? (
                                                          <Tooltip title={isHealthy ? 'All disks are healthy' : 'One or more disks have issues'}>
                                                            {isHealthy
                                                              ? <CheckCircleIcon color="success" fontSize="small" />
                                                              : <CancelIcon color="error" fontSize="small" />}
                                                          </Tooltip>
                                                        ) : (
                                                          <Tooltip title="Device is offline">
                                                            <CancelIcon color="error" fontSize="small" />
                                                          </Tooltip>
                                                        )}
                                                        {multipleDisks && (
                                                          <IconButton
                                                            onClick={() => this.toggleDetails(id)}
                                                            size="small"
                                                            sx={{
                                                              p: 0,
                                                              ml: 0.3,
                                                              alignSelf: "center"
                                                            }}
                                                          >
                                                            <KeyboardArrowDown />
                                                          </IconButton>
                                                        )}
                                                      </div>
                                                      {multipleDisks && this.state.showDiskDetails[id] && (
                                                        <div style={{ marginTop: '5px' }}>
                                                          {hard_disks.map((disk) => {
                                                            const isDiskHealthy =
                                                              (isHikevision && (disk.status === 'ok' || disk.status === 'idle')) ||
                                                              (isTvtNvr && (disk.status === 'RW' || disk.status === 'read/write')) ||
                                                              (isDigitalWatchdog && (disk.status === 'used|dbReady' || disk.status === 'Online')) ||
                                                              (isUNV && disk.status === 'Normal') ||
                                                              (isDahua && disk.status === 'ReadWrite') ||
                                                              (isNorthern && disk.status === 'RW');
                                                            return (
                                                              <div key={disk.disk_id} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '11px' }}>
                                                                <span>hdd&nbsp;{disk.disk_id}</span>
                                                                <Tooltip
                                                                  title={disk.status}
                                                                  slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [28, -25] } }] } }}
                                                                >
                                                                  {isDiskHealthy
                                                                    ? <CheckCircleIcon color="success" fontSize="small" />
                                                                    : <CancelIcon color="error" fontSize="small" />}
                                                                </Tooltip>
                                                              </div>
                                                            );
                                                          })}
                                                        </div>
                                                      )}
                                                    </>
                                                  );
                                                })()
                                              ) : (
                                                <Tooltip title={(device?.status === 'inactive' || device?.status === 'offline') ? 'No storage info is available' : 'Storage has issues'}>
                                                  <CancelIcon color="error" fontSize="small" />
                                                </Tooltip>
                                              )}
                                            </Box>
                                          </Box>

                                          {/* Active */}
                                          <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', display:'flex', alignItems: 'center' }}>
                                              Active
                                              <Tooltip
                                                title={'This may show three different icons based on the status of device. Green checkmark indicates device is Online. Red cross mark indicates device is Offline. Orange block mark indicates the device is manually made inactive. '}
                                                componentsProps={{
                                                  tooltip: {
                                                    sx: {
                                                      backgroundColor: '#283348',
                                                      color: '#fff',
                                                      fontSize: '12px',
                                                      border: '1px solid #99acb8',
                                                    },
                                                  },
                                                  arrow: {
                                                    sx: {
                                                      color: '#283348',
                                                    },
                                                  },
                                                }}
                                              >
                                                <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                              </Tooltip>
                                            </Typography>
                                            <Box display="flex" alignItems="center" mt="3px">
                                              <Tooltip
                                                title={
                                                  device.device_status === 'active' &&
                                                  (device.status === 'active' || device.status === 'Online')
                                                    ? 'Device is active'
                                                    : device.device_status === 'inactive' &&
                                                      (device.status === 'active' || device.status === 'Online')
                                                    ? 'Device is manually made inactive'
                                                    : 'Device is offline'
                                                }
                                              >
                                                {device.device_status === 'active' &&
                                                (device.status === 'active' || device.status === 'Online') ? (
                                                  <CheckCircleIcon color="success" fontSize="small" />
                                                ) : device.device_status === 'inactive' &&
                                                  (device.status === 'active' || device.status === 'Online') ? (
                                                  <img src={BlockRoundedIcon} width="24" alt="block_icon" />
                                                ) : (
                                                  <CancelIcon color="error" fontSize="small" />
                                                )}
                                              </Tooltip>
                                            </Box>
                                          </Box>
                                        </Box>
                                      </Box>

                                      {/* ── Vertical Divider ── */}
                                      <Box sx={{ width: '4px', backgroundColor: '#252b3a', flexShrink: 0 }} />

                                      {/* ════════════════════════════════
                                          RIGHT PANEL — Cameras, Time, Users, Storage
                                          ════════════════════════════════ */}
                                      <Box
                                        sx={{
                                          width: '190px',
                                          flexShrink: 0,
                                          p: '10px 12px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '7px',
                                        }}
                                      >
                                        {/* Cameras */}
                                        <Box
                                          sx={{
                                            backgroundColor: '#3a4253',
                                            borderRadius: '8px',
                                            p: '7px 10px',
                                          }}
                                        >
                                          <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                            Cameras
                                          </Typography>
                                          <Typography variant="body2" sx={{ color: '#c1c7d2', fontSize: '13px', fontWeight: 500, mt: '2px' }}>
                                            {device.total_cameras} Active / {device.online_count} Online
                                          </Typography>
                                        </Box>


                                        {/* Users */}
                                        <Box sx={{ backgroundColor: '#3a4253', borderRadius: '8px', p: '5px 10px', display: 'flex', alignItems: 'center' }}>
                                          <Typography variant="body2" sx={{ color: '#c1c7d2', display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                            {device?.user_list?.length > 0 ? (
                                              <span style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                                                {device.user_list.length} Users
                                                <IconButton onClick={() => this.toggleDeviceUserList(device)} size="small">
                                                  <KeyboardArrowDown />
                                                </IconButton>
                                              </span>
                                            ) : (
                                              'No Users'
                                            )}
                                          </Typography>
                                        </Box>

                                        {/* Storage */}
                                        <Box sx={{ backgroundColor: '#3a4253', borderRadius: '8px', p: '7px 10px' }}>
                                          <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                            Storage
                                          </Typography>
                                          {device.status === 'active' || device.status === 'Online' ? (
                                            device.hard_disks.length > 1 ? (
                                              (() => {
                                                const totalFreeSpace = device.hard_disks.reduce(
                                                  (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0), 0
                                                );
                                                const totalSpace = device.hard_disks.reduce(
                                                  (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0), 0
                                                );
                                                return (
                                                  <>
                                                    <Box display="flex" alignItems="center">
                                                      <Typography variant="body2" sx={{ color: this.getHDDColor(totalFreeSpace, totalSpace), fontWeight: 500, fontSize: '13px' }}>
                                                        {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                                      </Typography>
                                                      <IconButton
                                                      onClick={() => this.toggleDetails(device.id)}
                                                      size="small"
                                                      sx={{
                                                        p: 0,
                                                        ml: 0.3,
                                                        alignSelf: "center"
                                                      }}>
                                                        <KeyboardArrowDown />
                                                      </IconButton>
                                                    </Box>
                                                    {showDiskDetails[device.id] && (
                                                      <span>
                                                        {device.hard_disks.map((disk) => (
                                                          <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb), margin: 0, fontSize: '11px' }}>
                                                            hdd&nbsp;{disk.disk_id}:&nbsp;{disk.free_space_gb}/{disk.total_space_gb}
                                                          </p>
                                                        ))}
                                                      </span>
                                                    )}
                                                  </>
                                                );
                                              })()
                                            ) : (
                                              <div>
                                                {device.hard_disks.length === 1 ? (
                                                  device.hard_disks.map((disk) => (
                                                  <Typography key={disk.disk_id} variant="body2" sx={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb), fontWeight: 500, fontSize: '13px' }}>
                                                    {disk.free_space_gb}/{disk.total_space_gb}
                                                  </Typography>
                                                ))
                                              ) : (
                                                <Typography variant="body2" sx={{ color: '#e04a4a', fontSize: '13px' }}>No disk available</Typography>
                                              )}
                                              </div>
                                            )
                                          ) : (
                                            <Typography variant="body2" sx={{ color: '#e04a4a', fontSize: '13px' }}>Device is offline</Typography>
                                          )}
                                        </Box>
                                      </Box>
                                    </Box>
                                    {/* --Footer -- Site Time + Device Time */}
                                        <Box
                                          display="flex" justifyContent="space-between" alignItems="center" mb={1}
                                          sx={{
                                            backgroundColor: device.timezone_match ? '#415345' : '#4a3636',
                                            borderRadius: '8px',
                                            p: '7px 10px',
                                          }}
                                        >
                                          {/* Site Time */}
                                          <Typography variant="body2" sx={{ color: '#c1c7d2', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
                                            Site Time :
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '2px', whiteSpace: 'nowrap' }}>
                                              {(device.status === 'active' || device.status === 'Online') && device.current_time !== null ? (
                                                <Box component="span" sx={{ color: device.timezone_match ? '#a5d1a8' : '#d1a5a5' }}>
                                                  {this.getCurrentTimeInDeviceTimezone(device.site_timezone)}
                                                </Box>
                                              ) : (
                                                <Box component="span">
                                                  {this.getCurrentTimeInDeviceTimezone(device.site_timezone)}
                                                </Box>
                                              )}
                                              {device.site_timezone && (
                                                <Tooltip title={`Timezone: ${device.site_timezone}`}>
                                                  <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                </Tooltip>
                                              )}
                                            </span>
                                          </Typography>

                                          <Typography sx={{color: device.timezone_match ? '#8ee472' : '#dd7272', fontSize:'13px'}}>
                                            {device.timezone_match ? 'MATCHED' : 'UNMATCHED'}
                                          </Typography>

                                          {/* Device Time */}
                                          <Typography variant="body2" sx={{ color: '#c1c7d2', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', mt: '3px' }}>
                                            Device Time :
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                                              {device.status === 'active' || device.status === 'Online' ? (
                                                <Box component="span" sx={{ color: device.timezone_match ? '#a5d1a8' : '#d1a5a5' }}>
                                                  {this.formatToUSDateTime(device.current_time)}
                                                </Box>
                                              ) : (
                                                <Box component="span" sx={{ color: 'orange' }}>--</Box>
                                              )}
                                              {device.current_time && (
                                                <Tooltip title={`Timezone: ${device.timezone}`}>
                                                  <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                </Tooltip>
                                              )}
                                            </span>
                                          </Typography>
                                        </Box>

                                  </CardContent>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        ) : (
                          loading ? (
                            <Typography align="center" style={{ color: 'orange' }}>Loading...</Typography>
                          ) : (
                            <Typography align="center" style={{ color: 'orange' }}>
                              No device is configured for this site. Please add a device.
                            </Typography>
                          )
                        )
                        // )
                        // :(<TableRow>
                        //       <TableCell colSpan={10} align="center" style={{ color: 'orange', fontStyle: 'italic' }}>
                        //        This Site Is Inactive
                        //       </TableCell>
                        //     </TableRow>)
                        }
                        {/* </TableBody>
                      </Table> */}

                    {/* </TableContainer> */}

                    <Box component={Paper} sx={{display: 'flex',justifyContent: 'space-between',alignItems: 'center', marginTop: '20px', marginBottom: '10px'}}>
                      <Typography variant="h6" gutterBottom sx={{ mb: 1, mt:3, color: '#a4c4f1', paddingLeft:'16px', display:'flex', alignItems:'center' }} >
                        RTSP Cameras' Device List
                      </Typography>
                    </Box>


                        {

                        rtsp_cameras_devices.length > 0 ? (
                          // rtsp_cameras_devices.map((device) => (
                          <Grid container spacing={2}>
                              {rtsp_cameras_devices.map((device) => (
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={device.id}>
                                  <Card
                                    className="show-devices-device-card"
                                    sx={{
                                      backgroundColor: '#1d2533',
                                      color: '#fff',
                                      border: '1px solid #5b6e87',
                                      borderRadius: 2,
                                      transition: '0.3s',
                                      '&:hover': { boxShadow: '0 0 10px #225c8b' },
                                    }}
                                  >
                                    <CardContent sx={{ p: '12px !important' }}>

                                      {/* -- TOP HEADER: Device name + Action menu -- */}
                                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                        <Box display="flex" alignItems="center">
                                          <Typography sx={{ color: '#9ca4b4', fontSize:'18px'}}>
                                          Device Name:&nbsp;
                                          </Typography>
                                          <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 600, cursor: 'pointer', lineHeight: 1.2 }}
                                            onClick={() =>
                                              this.handleAboutDeviceNavigation(
                                                device.id,
                                                device.site_name,
                                                device.device_name,
                                                device.sitedb,
                                                device.global_alarm,
                                                device.unmute_count)}
                                          >
                                            {device.device_name}
                                          </Typography>
                                        </Box>
                                        {/* Action kebab replaced with separate icons */}
                                        <Box display="flex" alignItems="center" gap={5.5}>

                                          {/* Delete */}
                                          {user_type === 'DealerUser' && (
                                            <IconButton
                                              size="small"
                                              title="Delete Device"
                                              sx={{backgroundColor:'#8c3939', borderRadius: "6px",}}
                                              onClick={() =>
                                                this.openDialog(() =>
                                                  this.handleDeviceDelete(device.id)
                                                )
                                              }
                                            >
                                              <Delete fontSize="small" />
                                            </IconButton>
                                          )}

                                          {/* Edit */}
                                          {user_type === 'DealerUser' && (
                                            <IconButton
                                              size="small"
                                              title="Edit Device Information"
                                              sx={{backgroundColor:'#2e6069', borderRadius: "6px",}}
                                              onClick={() => this.LoadSelectedDeviceInfo(device.id, true)}
                                            >
                                              <Edit fontSize="small" />
                                            </IconButton>
                                          )}

                                          {/* Test Connection */}
                                          <IconButton
                                            size="small"
                                            disabled={device?.device_status === 'inactive'}
                                            onClick={() => this.TestConnection(device)}
                                            title="Test Connection"
                                            sx={{backgroundColor:'#304d76', borderRadius: "6px",}}
                                          >
                                            <UpdateIcon fontSize="small" />
                                          </IconButton>

                                        </Box>
                                      </Box>

                                      {/* ── MAIN BODY: Left panel | Divider | Right panel ── */}
                                      <Box className="show-devices-card-body" display="flex" gap={0} sx={{ border: '1px solid #343c50', borderRadius: '8px', overflow: 'hidden' }}>

                                        {/* ════════════════════════════════
                                            LEFT PANEL — Status & Health Stats
                                            ════════════════════════════════ */}
                                        <Box
                                          sx={{
                                            flex: 1,
                                            p: '10px 12px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 1,
                                          }}
                                        >
                                          {/* Online badge + Globe icon */}
                                          <Box display="flex" alignItems="center" gap={1}>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                backgroundColor:
                                                  device.device_status === 'active' &&
                                                  (device.status === 'active' || device.status === 'Online')
                                                    ? '#238636'
                                                    : device.device_status === 'inactive' &&
                                                      (device.status === 'active' || device.status === 'Online')
                                                    ? '#f59834'
                                                    : '#AC3E31',
                                                px: 1,
                                                py: 0.3,
                                                borderRadius: 5,
                                              }}
                                            >
                                              {device.device_status === 'active' &&
                                              (device.status === 'active' || device.status === 'Online')
                                                ? 'Online'
                                                : 'Offline'}
                                            </Typography>

                                            {/* <Typography
                                              variant="body2"
                                              sx={{ color: '#9ca4b4', display: 'flex', alignItems: 'center' }}
                                            >
                                              <Tooltip
                                                title={
                                                  <>
                                                    {`${device.protocol}://${device.ip_address}:${device.port_number}`}
                                                    <br />
                                                    <div style={{ textAlign: 'center' }}>Click to go to this address</div>
                                                  </>
                                                }
                                              >
                                                <a
                                                  href={`${device.protocol}://${device.ip_address}:${device.port_number}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img src={LinkIcon} alt="ip-globe-icon" width="40px" />
                                                </a>
                                              </Tooltip>
                                            </Typography> */}
                                          </Box>

                                          {/* ── 2×2 Stat grid ── */}
                                          <Box
                                            sx={{
                                              display: 'grid',
                                              gridTemplateColumns: '1fr 1fr',
                                              gap: '6px',
                                            }}
                                          >
                                            {/* Health */}
                                            <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                              <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', display:'flex', alignItems: 'center' }}>
                                                Health
                                                <Tooltip
                                                  title={'Health of device w.r.t its number of camera(s) having recording days issue and/or number of camera(s) in offline state '}
                                                  componentsProps={{
                                                    tooltip: {
                                                      sx: {
                                                        backgroundColor: '#283348',
                                                        color: '#fff',
                                                        fontSize: '12px',
                                                        border: '1px solid #99acb8',
                                                      },
                                                    },
                                                    arrow: {
                                                      sx: {
                                                        color: '#283348',
                                                      },
                                                    },
                                                  }}
                                                >
                                                  <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8 }} />
                                                </Tooltip>
                                              </Typography>
                                              <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                                {device.health_issues_count === 0 &&
                                                (device.status === 'active' || device.status === 'Online') ? (
                                                  <CheckCircleIcon color="success" fontSize="small" />
                                                ) : (
                                                  <>
                                                    <Typography variant="body2" sx={{ color: '#cdd5e5', fontWeight: 500 }}>
                                                      {device.health_issues_count}
                                                    </Typography>
                                                    <CancelIcon color="error" fontSize="small" />
                                                  </>
                                                )}
                                              </Box>
                                            </Box>

                                            {/* Armed */}
                                            <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                              <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                                Armed
                                              </Typography>
                                              <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                                {device.arm_disarm_status === undefined ? (
                                                  <Tooltip title="Fetching status...">
                                                    <ReportProblemIcon sx={{ color: '#FFA000' }} fontSize="small" />
                                                  </Tooltip>
                                                ) : device.arm_disarm_status === 'armed' ? (
                                                  <>
                                                    <Typography variant="body2" sx={{ color: '#cdd5e5', fontWeight: 500 }}>
                                                      {device?.status === 'inactive' || device?.status === 'offline'
                                                        ? '0'
                                                        : device.unmute_count || 0}
                                                    </Typography>
                                                    <Tooltip title="Device is Armed">
                                                      <CheckCircleIcon color="success" fontSize="small" />
                                                    </Tooltip>
                                                  </>
                                                ) : (
                                                  <Tooltip title="Device is Disarmed">
                                                    <CancelIcon color="error" fontSize="small" />
                                                  </Tooltip>
                                                )}
                                              </Box>
                                            </Box>

                                            {/* Storage Health */}
                                            {/* <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                              <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                                Storage Health
                                              </Typography>
                                              <Box display="flex" alignItems="center" gap="4px" mt="3px">
                                                {device && device.hard_disks.length > 0 ? (
                                                  (() => {
                                                    const { hard_disks, device_type_name, status, id } = device;
                                                    const allHikevisionHealthy = hard_disks.every(d => d.status === 'idle' || d.status === 'ok');
                                                    const allNvrHealthy = hard_disks.every(d => d.status === 'RW' || d.status === 'read/write');
                                                    const allDigitalWatchdogHealthy = hard_disks.every(d => d.status === 'used|dbReady' || d.status === 'Online');
                                                    const allUNV = hard_disks.every(d => d.status === 'Normal');
                                                    const allDahua = hard_disks.every(d => d.status === 'ReadWrite');
                                                    const allNorthernHealthy = hard_disks.every(d => d.status === 'RW');

                                                    const isHikevision = device_type_name === 'hikvision';
                                                    const isTvtNvr = device_type_name === 'nvr';
                                                    const isDigitalWatchdog = device_type_name === 'digital_watch_dog';
                                                    const isUNV = device_type_name === 'unv';
                                                    const isDahua = device_type_name === 'dahua';
                                                    const isNorthern = device_type_name === 'northern';
                                                    const multipleDisks = hard_disks.length > 1;

                                                    let isHealthy = false;
                                                    if (isHikevision) isHealthy = allHikevisionHealthy;
                                                    else if (isTvtNvr) isHealthy = allNvrHealthy;
                                                    else if (isDigitalWatchdog) isHealthy = allDigitalWatchdogHealthy;
                                                    else if (isUNV) isHealthy = allUNV;
                                                    else if (isDahua) isHealthy = allDahua;
                                                    else if (isNorthern) isHealthy = allNorthernHealthy;

                                                    return (
                                                      <>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                          {status === 'active' ? (
                                                            <Tooltip title={isHealthy ? 'All disks are healthy' : 'One or more disks have issues'}>
                                                              {isHealthy
                                                                ? <CheckCircleIcon color="success" fontSize="small" />
                                                                : <CancelIcon color="error" fontSize="small" />}
                                                            </Tooltip>
                                                          ) : (
                                                            <Tooltip title="Device is inactive">
                                                              <CancelIcon color="error" fontSize="small" />
                                                            </Tooltip>
                                                          )}
                                                          {multipleDisks && (
                                                            <IconButton
                                                              onClick={() => this.toggleDetails(id)}
                                                              size="small"
                                                              sx={{
                                                                p: 0,
                                                                ml: 0.3,
                                                                alignSelf: "center"
                                                              }}
                                                            >
                                                              <KeyboardArrowDown />
                                                            </IconButton>
                                                          )}
                                                        </div>
                                                        {multipleDisks && this.state.showDiskDetails[id] && (
                                                          <div style={{ marginTop: '5px' }}>
                                                            {hard_disks.map((disk) => {
                                                              const isDiskHealthy =
                                                                (isHikevision && (disk.status === 'ok' || disk.status === 'idle')) ||
                                                                (isTvtNvr && (disk.status === 'RW' || disk.status === 'read/write')) ||
                                                                (isDigitalWatchdog && (disk.status === 'used|dbReady' || disk.status === 'Online')) ||
                                                                (isUNV && disk.status === 'Normal') ||
                                                                (isDahua && disk.status === 'ReadWrite') ||
                                                                (isNorthern && disk.status === 'RW');
                                                              return (
                                                                <div key={disk.disk_id} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                  <span>hdd&nbsp;{disk.disk_id}</span>
                                                                  <Tooltip
                                                                    title={disk.status}
                                                                    slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [28, -25] } }] } }}
                                                                  >
                                                                    {isDiskHealthy
                                                                      ? <CheckCircleIcon color="success" fontSize="small" />
                                                                      : <CancelIcon color="error" fontSize="small" />}
                                                                  </Tooltip>
                                                                </div>
                                                              );
                                                            })}
                                                          </div>
                                                        )}
                                                      </>
                                                    );
                                                  })()
                                                ) : (
                                                  <Tooltip title={device?.status === 'inactive' ? 'No storage info is available' : 'Storage has issues'}>
                                                    <CancelIcon color="error" fontSize="small" />
                                                  </Tooltip>
                                                )}
                                              </Box>
                                            </Box> */}

                                            {/* Active */}
                                            <Box sx={{ backgroundColor: '#252d3e', borderRadius: '8px', p: '7px 10px' }}>
                                              <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', display:'flex', alignItems: 'center' }}>
                                                Active
                                                <Tooltip
                                                  title={'This may show three different icons based on the status of device. Green checkmark indicates device is Online. Red cross mark indicates device is Offline. Orange block mark indicates the device is manually made inactive. '}
                                                  componentsProps={{
                                                    tooltip: {
                                                      sx: {
                                                        backgroundColor: '#283348',
                                                        color: '#fff',
                                                        fontSize: '12px',
                                                        border: '1px solid #99acb8',
                                                      },
                                                    },
                                                    arrow: {
                                                      sx: {
                                                        color: '#283348',
                                                      },
                                                    },
                                                  }}
                                                >
                                                  <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                </Tooltip>
                                              </Typography>
                                              <Box display="flex" alignItems="center" mt="3px">
                                                <Tooltip
                                                  title={
                                                    device.device_status === 'active' &&
                                                    (device.status === 'active' || device.status === 'Online')
                                                      ? 'Device is active'
                                                      : device.device_status === 'inactive' &&
                                                        (device.status === 'active' || device.status === 'Online')
                                                      ? 'Device is manually made inactive'
                                                      : 'Device is offline'
                                                  }
                                                >
                                                  {device.device_status === 'active' &&
                                                  (device.status === 'active' || device.status === 'Online') ? (
                                                    <CheckCircleIcon color="success" fontSize="small" />
                                                  ) : device.device_status === 'inactive' &&
                                                    (device.status === 'active' || device.status === 'Online') ? (
                                                    <img src={BlockRoundedIcon} width="24" alt="block_icon" />
                                                  ) : (
                                                    <CancelIcon color="error" fontSize="small" />
                                                  )}
                                                </Tooltip>
                                              </Box>
                                            </Box>
                                          </Box>
                                        </Box>

                                        {/* ── Vertical Divider ── */}
                                        <Box sx={{ width: '4px', backgroundColor: '#252b3a', flexShrink: 0 }} />

                                        {/* ════════════════════════════════
                                            RIGHT PANEL — Cameras, Time, Users, Storage
                                            ════════════════════════════════ */}
                                        <Box
                                          sx={{
                                            width: '190px',
                                            flexShrink: 0,
                                            p: '10px 12px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '7px',
                                          }}
                                        >
                                          {/* Cameras */}
                                          <Box
                                            sx={{
                                              backgroundColor: '#3a4253',
                                              borderRadius: '8px',
                                              p: '7px 10px',
                                            }}
                                          >
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                              Cameras
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#c1c7d2', fontSize: '13px', fontWeight: 500, mt: '2px' }}>
                                              {device.total_cameras} Active / {device.online_count} Online
                                            </Typography>
                                          </Box>


                                          {/* Users */}
                                          {/* <Box sx={{ backgroundColor: '#3a4253', borderRadius: '8px', p: '5px 10px', display: 'flex', alignItems: 'center' }}>
                                            <Typography variant="body2" sx={{ color: '#c1c7d2', display: 'flex', alignItems: 'center', fontSize: '12px' }}>
                                              {device?.user_list?.length > 0 ? (
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
                                                  {device.user_list.length} Users
                                                  <IconButton onClick={() => this.toggleDeviceUserList(device)} size="small">
                                                    <KeyboardArrowDown />
                                                  </IconButton>
                                                </span>
                                              ) : (
                                                'No Users'
                                              )}
                                            </Typography>
                                          </Box> */}

                                          {/* Storage */}
                                          {/* <Box sx={{ backgroundColor: '#3a4253', borderRadius: '8px', p: '7px 10px' }}>
                                            <Typography variant="body2" sx={{ color: '#7c8aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                              Storage
                                            </Typography>
                                            {device.status === 'active' || device.status === 'Online' ? (
                                              device.hard_disks.length > 1 ? (
                                                (() => {
                                                  const totalFreeSpace = device.hard_disks.reduce(
                                                    (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0), 0
                                                  );
                                                  const totalSpace = device.hard_disks.reduce(
                                                    (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0), 0
                                                  );
                                                  return (
                                                    <>
                                                      <Box display="flex" alignItems="center">
                                                        <Typography variant="body2" sx={{ color: this.getHDDColor(totalFreeSpace, totalSpace), fontWeight: 500, fontSize: '13px' }}>
                                                          {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                                        </Typography>
                                                        <IconButton
                                                        onClick={() => this.toggleDetails(device.id)}
                                                        size="small"
                                                        sx={{
                                                          p: 0,
                                                          ml: 0.3,
                                                          alignSelf: "center"
                                                        }}>
                                                          <KeyboardArrowDown />
                                                        </IconButton>
                                                      </Box>
                                                      {showDiskDetails[device.id] && (
                                                        <span>
                                                          {device.hard_disks.map((disk) => (
                                                            <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb), margin: 0, fontSize: '11px' }}>
                                                              hdd&nbsp;{disk.disk_id}:&nbsp;{disk.free_space_gb}/{disk.total_space_gb}
                                                            </p>
                                                          ))}
                                                        </span>
                                                      )}
                                                    </>
                                                  );
                                                })()
                                              ) : (
                                                <div>
                                                  {device.hard_disks.map((disk) => (
                                                    <Typography key={disk.disk_id} variant="body2" sx={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb), fontWeight: 500, fontSize: '13px' }}>
                                                      {disk.free_space_gb}/{disk.total_space_gb}
                                                    </Typography>
                                                  ))}
                                                </div>
                                              )
                                            ) : (
                                              <Typography variant="body2" sx={{ color: '#9ca4b4', fontSize: '13px' }}>-</Typography>
                                            )}
                                          </Box> */}
                                        </Box>
                                      </Box>
                                      {/* --Footer -- Site Time + Device Time */}
                                          <Box
                                            display="flex" justifyContent="space-between" alignItems="center" mb={1}
                                            sx={{
                                              backgroundColor: '#415345',
                                              borderRadius: '8px',
                                              p: '7px 10px',
                                            }}
                                          >
                                            {/* Site Time */}
                                            <Typography variant="body2" sx={{ color: '#c1c7d2', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px' }}>
                                              Site Time :
                                              <span style={{ display: 'flex', alignItems: 'center', gap: '2px', whiteSpace: 'nowrap' }}>
                                                  <Box component="span" sx={{ color: '#a5d1a8' }}>
                                                    {this.getCurrentTimeInDeviceTimezone(device.site_timezone)}
                                                  </Box>
                                                {device.site_timezone && (
                                                  <Tooltip title={`Timezone: ${device.site_timezone}`}>
                                                    <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                  </Tooltip>
                                                )}
                                              </span>
                                            </Typography>
                                          </Box>

                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          // ))
                        ) : (
                          loading ? (
                              <Typography align="center" style={{ color: 'orange' }}>
                                Loading...
                              </Typography>
                          ) : (
                              <Typography align="center" style={{ color: 'orange', fontStyle: 'italic' }}>
                                No device is configured for this site. Please add a device.
                              </Typography>
                          )
                        )
                        // )
                        // :(<TableRow>
                        //       <TableCell colSpan={10} align="center" style={{ color: 'orange', fontStyle: 'italic' }}>
                        //        This Site Is Inactive
                        //       </TableCell>
                        //     </TableRow>)
                        }


                    </>
                  ) : (
                  <Typography variant="h6" color="textSecondary" align="center" sx={{ marginTop: '20%' }}>
                    Please select a site to view devices.
                  </Typography>
                )}
                </Box>

              </Box>


              <div style={{ marginTop: '2px', display: 'flex', justifyContent: 'center', marginBottom: '3cm', alignItems: 'center' }}>
                  {/* <Button
                    id="rowsPerPageButton"
                    onClick={() => this.handleChangePage(currentPage - 1)}
                    disabled={currentPage === 1}
                    variant="contained"
                    sx={{
                      margin: '0 10px',
                      borderRadius: '8px',
                      padding: '8px 10px',
                      fontSize: '14px',
                      minWidth: '90px',
                      background: 'linear-gradient(145deg, #001f54, #003366)',  // Primary color gradient
                      boxShadow: 2,
                      '&:hover': {
                        background: 'linear-gradient(145deg, #003366, #001f54)',  // Inverted gradient for hover effect
                      },
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {"< Prev"}
                  </Button>

                  <span style={{ fontSize: 'small', color: '#555' }}>
                    {`Page ${currentPage} / ${Math.ceil(filteredDevices.length / rowsPerPage)}`}
                  </span>&emsp;

              <Button
                id="rowsPerPageButton"
                onClick={() => this.handleChangePage(currentPage + 1)}
                disabled={currentPage === Math.ceil(filteredDevices.length / rowsPerPage)}
                variant="contained"
                sx={{
                  margin: '0 10px',
                  borderRadius: '8px',
                  padding: '8px 10px',
                  fontSize: '14px',
                  minWidth: '90px',
                  background: 'linear-gradient(145deg, #001f54,rgb(3, 82, 162))',  // Primary color gradient
                  boxShadow: 2,
                  '&:hover': {
                    background: 'linear-gradient(145deg, #003366,rgb(4, 48, 123))',  // Inverted gradient for hover effect
                  },
                  cursor: currentPage === Math.ceil(filteredDevices.length / rowsPerPage) ? 'not-allowed' : 'pointer',
                }}
              >
                {"Next >"}
              </Button> */}

              <Snackbar
                open={this.state.open_snackbar}
                autoHideDuration={5000}
                onClose={() => this.setState({ open_snackbar: false })}
                anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
              >
                <Alert
                  onClose={() => this.setState({ open_snackbar: false })}
                  variant="filled"
                  elevation={6}
                  severity={this.state.alert_type}
                >
                  {this.state.snackbar_msg}
                </Alert>
              </Snackbar>
              </div>
                  {toggleAddSite && (
                    <div style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                      zIndex: 999,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center", // Align vertically
                      }}

                    >
                      <div className='Slide-left-edit-form'>
                        {/* Close icon */}
                      <button
                        onClick={this.closePopup}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#d6d6d6d2",
                          border: "none",
                          fontSize: "18px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>
                        <div >
                        <div className="form-section" style={{ padding: "12px" }}>
                        <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Add New Site</h3>
                        {warning_site && (
                                <Alert severity="warning">Please fill all the required fields correctly.</Alert>
                            )}
                            {error_site && (
                               <Alert severity="error">{responseMessage}</Alert>
                            )}
                            {success_site && (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    Site information saved successfully.
                                </Alert>
                            )}

                            <input
                                type="text"
                                name="sitename"
                                placeholder="Site Name *"
                                value={sitename}
                                onChange={this.handleInputChange}
                                style={{ width: '98%', marginBottom: '10px', padding: '8px',  border: this.state.errors?.sitename ? "1px solid red" : ""}}
                            />
                            <input
                                type="text"
                                name="organisationName"
                                placeholder="Business Name *"
                                value={organisationName}
                                onChange={this.handleInputChange}
                                style={{ width: '98%', marginBottom: '10px', padding: '8px' }}
                            />
                            <input
                                type="text"
                                name="street"
                                placeholder="Address *"
                                value={street}
                                onChange={this.handleInputChange}
                                style={{ width: '34%', marginBottom: '10px', padding: '8px' }}
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City *"
                                value={city}
                                onChange={this.handleInputChange}
                                style={{ width: '34%', marginBottom: '10px', padding: '8px', marginLeft:'4px' }}
                            />
                            <input
                                type="text"
                                name="zip"
                                placeholder="Zip *"
                                value={zip}
                                onChange={this.handleInputChange}
                                // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                                style={{ width: '29%', marginBottom: '11px', padding: '8px', fontSize: '13px', marginLeft:'3px' }}
                            />
                            <input
                                type="text"
                                name="state"
                                placeholder="State * (Please enter complete state name)"
                                value={state}
                                onChange={this.handleInputChange}
                                style={{ width: '48%', marginBottom: '10px', padding: '8px' }}
                            />

                            <input
                                type="text"
                                name="country"
                                placeholder="Country * (Please enter complete country name)"
                                value={country}
                                onChange={this.handleInputChange}
                                // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                                style={{ width: '49%', marginBottom: '11px', padding: '8px', marginLeft:'6px', fontSize: '13px' }}
                            />

                            <input
                              type="text"
                              name="cust_contact_no"
                              placeholder="Customer Contact no. 1*"
                              value={cust_contact_no}
                              onChange={this.handleInputChange}
                              // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                              style={{ width: '48%', marginBottom: '10px', padding: '8px' }}
                          />

                          <input
                              type="text"
                              name="cust_contact_no_1"
                              placeholder="Customer Contact no. 2*"
                              value={cust_contact_no_1}
                              onChange={this.handleInputChange}
                              // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                              style={{ width: '49%', marginBottom: '10px', padding: '8px', marginLeft:'6px' }}
                          />

                          <input
                              type="text"
                              name="police_dept_contact_no"
                              placeholder="Police Dept. Contact no.*"
                              value={police_dept_contact_no}
                              onChange={this.handleInputChange}
                              // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                              style={{ width: '48%', marginBottom: '10px', padding: '8px' }}
                          />
                          <input
                              type="text"
                              name="fire_dept_contact_no"
                              placeholder="Fire Dept. Contact no.*"
                              value={fire_dept_contact_no}
                              onChange={this.handleInputChange}
                              // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                              style={{ width: '49%', marginBottom: '11px', padding: '8px', fontSize: '13px', marginLeft:'6px' }}
                          />

                          <input
                              type="text"
                              name="map_link"
                              placeholder="Enter the Google Maps URL for this address*"
                              value={map_link}
                              onChange={this.handleInputChange}
                              style={{ width: '97.5%', marginBottom: '10px', padding: '8px', border: this.state.errors?.map_link ? "1px solid red" : "" }}
                          />
                            {this.state.errors?.map_link && (
                              <div style={{ color: 'red', fontSize: '12px' }}>
                                {this.state.errors.map_link}
                              </div>
                            )}
                            {/* uncoment below select tag for group feature */}
                            <label style={{fontSize: '15px'}}> Select Parent Group* :</label>
                            <select
                                name='group_id'
                                value={this.state.group_id}
                                onChange={this.handleSelectionChange}
                                style={{ width: '97.5%', marginBottom: '15px', marginTop:'5px', padding: '8px', fontSize: '13px' }}
                            >
                              <option value="" disabled>Select parent group</option>
                                {groups_list.length > 0 ?
                                  groups_list.map((group) => (
                                    <option
                                        key={group.id}
                                        value={group.id}
                                    >
                                        {group.name}
                                    </option>
                                )):(<p> </p>)}
                            </select>
                            <label style={{fontSize: '15px'}}> Select Customer/s to assign this site :</label>
                            {/* <select
                                name='customers'
                                multiple
                                onChange={this.handleSelectionChange}
                                style={{ width: '100%', marginBottom: '15px', marginTop:'5px', padding: '8px', fontSize: '13px' }}
                            >
                                {client_list.map((customer) => (
                                    <option
                                        key={customer.user_id}
                                        value={customer.user_id}
                                    >
                                        {customer.first_name}
                                    </option>
                                ))}
                            </select> */}
                            <Select
                                  isMulti
                                  name="customers"
                                  options={customerOptions}
                                  className="basic-multi-select"
                                  classNamePrefix="select"

                                  onChange={(selectedOptions) => {
                                    const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
                                    const selectedUsers = this.state.client_list.filter((user) =>
                                      optionsArray.some((opt) => opt.value === user.user_id)
                                    );
                                    this.setState({ selected_Customers: selectedUsers });
                                  }}
                                  value={customerOptions.filter(option =>
                                    this.state.selected_Customers.some(
                                      (user) => user.user_id === option.value
                                    )
                                  )}
                                  styles={{
                                    container: (base) => ({
                                      ...base,
                                      width: '97.5%',
                                      fontSize: '14px',
                                    }),
                                    control: (base, state) => ({
                                      ...base,
                                      backgroundColor: "#2b2b2b95",
                                      borderColor: state.isFocused ? "#888" : "#444",
                                      boxShadow: "none",
                                    }),
                                    multiValue: (base) => ({
                                      ...base,
                                      backgroundColor: "#3a3a3a",
                                      color: "#fff",
                                    }),
                                    multiValueLabel: (base) => ({
                                      ...base,
                                      color: "#fff",
                                    }),
                                     menu: (base) => ({
                                      ...base,
                                      backgroundColor: "#1e1e1e",
                                      color: "#fff",
                                    }),
                                    option: (base, state) => ({
                                      ...base,
                                      backgroundColor: state.isFocused
                                        ? "#3a3f4b"
                                        : state.isSelected
                                        ? "#5c6bc0"
                                        : "#1e1e1e",
                                      color: "#fff",
                                      cursor: "pointer",
                                    }),
                                  }}
                                />
                              <h4 style={{ marginTop: "15px", color: "#fff" }}>Add Paging Device</h4>

                              <input
                                type="text"
                                placeholder="Paging Device MAC Address"
                                value={this.state.gas_paging_devices[0].mac_address}
                                onChange={(e) =>
                                  this.handlePagingDeviceChange("mac_address", e.target.value)
                                }
                                style={{ width: "32%", marginBottom: "10px", padding: "8px",  border: this.state.errors?.mac_address ? "1px solid red" : "" }}
                              />
                                {this.state.errors?.mac_address && (
                                  <div style={{ color: "red", fontSize: "12px", marginTop: "-8px", marginBottom: "8px" }}>
                                    {this.state.errors.mac_address}
                                  </div>
                                )}
                             <select
                                  value={this.state.gas_paging_devices[0].device_type}
                                  onChange={(e) =>
                                    this.handlePagingDeviceChange("device_type", e.target.value)
                                  }
                                  style={{
                                    width: "32%",
                                    marginBottom: "10px",
                                    padding: "8px",
                                    marginLeft: "6px",
                                  }}
                                >
                                  <option value="" disabled>Select Device Type</option>
                                  <option value="Speaker">Speaker</option>
                                  <option value="Mic">Mic</option>
                                </select>
                              <input
                                type="text"
                                placeholder="Paging Device Description"
                                value={this.state.gas_paging_devices[0].description}
                                onChange={(e) =>
                                  this.handlePagingDeviceChange("description", e.target.value)
                                }
                                style={{
                                  width: "32%",
                                  marginBottom: "10px",
                                  padding: "8px",
                                  marginLeft: "6px",
                                }}
                              />
                            <div style={{ display: "flex", justifyContent: "right", gap: "5px", marginTop:'15px' }}>

                              <Button
                                type="button"
                                onClick={this.handleSiteSave}
                                style={{
                                    width: "3cm",
                                    height: "0.9cm",
                                    background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                    boxShadow: 2,
                                    '&:hover': {
                                      background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                    },
                                    cursor: 'pointer',
                                    color: "white",
                                }}
                            >
                                Add Site
                            </Button>
                            </div>

                        </div>
                        </div>
                      </div>
                    </div>
                  )
                  }

                {editToggle && (

                  <div
                    style={{
                      position: "fixed",
                      top: 0.5,
                      pt: 10,
                      left: 0,
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                      zIndex: 999,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center", // Align vertically
                      overflowY:'scroll',
                      "&::WebkitScrollbar": { width: "5px" },
                      "&::WebkitScrollbarThumb": {
                        backgroundColor: "#1d497a",
                        borderRadius: "8px",
                      },
                      }}
                  >

                  <div className='Slide-site-edit-form' >
                    {/* Close icon */}
                      <button
                        onClick={this.closeEditPopup}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#fff",
                          border: "none",
                          fontSize: "18px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>

                      <div className="form-section">
                          <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Edit Site Info</h3>

                            {error ? (
                              <Alert severity="error">{responseMessage}</Alert>
                            ) : warning_site ? (
                              <Alert severity="warning">
                                  "Please fill the required fields correctly."
                              </Alert>
                          ): success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "All set! The site info was updated successfully."
                                </Alert>
                            ) : null}

                            <div className='form-group-device-edit'>
                                <label htmlFor="sitename">
                                    Site Name <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_sitename"
                                    value={edit_sitename || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="address">
                                    Address <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_address"
                                    value={edit_address || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="city">
                                    City <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_city"
                                    value={edit_city || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="zip">
                                    Zip <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_zip"
                                    value={edit_zip || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="state">
                                    State <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_state"
                                    value={edit_state || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="country">
                                    Country <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_country"
                                    value={edit_country || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="country">
                                    Map Link <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_map_link"
                                    value={edit_map_link || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                            <div className='form-group-device-edit'>
                                <label htmlFor="organisation_name">
                                    Organisation Name <span style={{ color: "red" }}>*</span>: &nbsp;
                                </label>
                                <input
                                    type="text"
                                    name="edit_organisation_name"
                                    value={edit_organisation_name || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: "350px", height: "0.7cm" }}
                                />
                            </div>
                          {/*  */}
                          <div className='form-group-device-edit'>
                              <label htmlFor="organisation_name">
                                 Customer Contact no. 1<span style={{ color: "red" }}>*</span>: &nbsp;
                              </label>
                              <input
                                  type="text"
                                  name="edit_cust_contact_no"
                                  value={edit_cust_contact_no || ""}
                                  onChange={this.handleInputChange}
                                  style={{ width: "350px", height: "0.7cm" }}
                              />
                          </div>

                          <div className='form-group-device-edit'>
                              <label htmlFor="organisation_name">
                                 Customer Contact no. 2<span style={{ color: "red" }}>*</span>: &nbsp;
                              </label>
                              <input
                                  type="text"
                                  name="edit_cust_contact_no_1"
                                  value={edit_cust_contact_no_1 || ""}
                                  onChange={this.handleInputChange}
                                  style={{ width: "350px", height: "0.7cm" }}
                              />
                          </div>

                          <div className='form-group-device-edit'>
                              <label htmlFor="organisation_name">
                                 Police Dept. no.<span style={{ color: "red" }}>*</span>: &nbsp;
                              </label>
                              <input
                                  type="text"
                                  name="edit_police_dept_contact_no"
                                  value={edit_police_dept_contact_no || ""}
                                  onChange={this.handleInputChange}
                                  style={{ width: "350px", height: "0.7cm" }}
                              />
                          </div>

                          <div className='form-group-device-edit'>
                              <label htmlFor="organisation_name">
                                 Fire Dept. no.<span style={{ color: "red" }}>*</span>: &nbsp;
                              </label>
                              <input
                                  type="text"
                                  name="edit_fire_dept_contact_no"
                                  value={edit_fire_dept_contact_no || ""}
                                  onChange={this.handleInputChange}
                                  style={{ width: "350px", height: "0.7cm" }}
                              />
                          </div>

                            <div className='form-group-device-edit'style={{ marginBottom: "20px" }}>
                                <label htmlFor="customers">
                                    Associated Site Users: &nbsp;
                                </label>

                                <Select
                                  isMulti
                                  name="customers"
                                  options={customerOptions}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  styles={{ container: (base) => ({ ...base, width: "365px", color:'black' }) }} // <-- this sets width
                                  disabled={user_type === "TechnicianUser"}
                                  onChange={(selectedOptions) => {
                                    const optionsArray = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
                                    const selectedUsers = this.state.client_list.filter((user) =>
                                      optionsArray.some((opt) => opt.value === user.user_id)
                                    );
                                    this.setState({ edit_selected_Customers_list: selectedUsers });
                                  }}
                                  value={customerOptions.filter(option =>
                                    this.state.edit_selected_Customers_list.some(
                                      (user) => user.user_id === option.value
                                    )
                                  )}
                                />
                            </div>
                           {/* <div style={{ }}>
                            <label style={{ fontWeight: "bold" }}>
                              Edit Paging Device:
                            </label>
                          </div> */}

                          <div className='form-group-device-edit'>
                                <label>Paging Device MAC Address:&nbsp;</label>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                  <input
                                    type="text"
                                    value={this.state.edit_gas_paging_devices?.[0]?.mac_address || ""}
                                    onChange={(e) => {
                                      const devices = [...(this.state.edit_gas_paging_devices || [])];

                                      if (!devices[0]) {
                                        devices[0] = { mac_address: "", device_type: "", description: "" };
                                      }

                                      devices[0].mac_address = e.target.value.toLowerCase();

                                      this.setState({
                                        edit_gas_paging_devices: devices,

                                        // 🔥 CLEAR ERROR ON TYPING
                                        errors: {
                                          ...this.state.errors,
                                          mac_address: ""
                                        }
                                      });
                                    }}
                                    style={{
                                      width: "350px",
                                      height: "32px",
                                      border: this.state.errors?.mac_address ? "1px solid red" : ""
                                    }}
                                  />

                                  {/* 🔥 ERROR MESSAGE */}
                                  {this.state.errors?.mac_address && (
                                    <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                      {this.state.errors.mac_address}
                                    </div>
                                  )}
                                </div>
                            </div>

                          <div className='form-group-device-edit'>
                            <label>Paging Device Type:&nbsp;</label>

                            <select
                              value={this.state.edit_gas_paging_devices?.[0]?.device_type || ""}
                              onChange={(e) => {
                                const devices = [...(this.state.edit_gas_paging_devices || [])];

                                if (!devices[0]) {
                                  devices[0] = { mac_address: "", device_type: "", description: "" };
                                }

                                devices[0].device_type = e.target.value;

                                this.setState({ edit_gas_paging_devices: devices });
                              }}
                              style={{ width: "350px", height: "0.9cm" }}
                            >
                              <option value="">Select Device Type</option>
                              <option value="Speaker">Speaker</option>
                              <option value="Mic">Mic</option>
                            </select>
                          </div>

                          <div className='form-group-device-edit'>
                            <label>Paging Device's Description:&nbsp;</label>
                            <input
                              type="text"
                              value={this.state.edit_gas_paging_devices?.[0]?.description || ""}
                            onChange={(e) => {
                            const devices = [...(this.state.edit_gas_paging_devices || [])];

                            if (!devices[0]) {
                              devices[0] = { mac_address: "", device_type: "", description: "" };
                            }

                            devices[0].description = e.target.value;

                            this.setState({ edit_gas_paging_devices: devices });
                          }}
                              style={{ width: "350px", height: "0.7cm" }}
                            />
                          </div>
                            <div style={{ display: "flex", justifyContent: "right", gap: "5px", marginTop:'15px' }}>
                                <Button
                                    type="button"
                                    onClick={this.handleEditSave}
                                    style={{
                                        width: "0.8cm",
                                        height: "0.7cm",
                                        background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                        boxShadow: 2,
                                        '&:hover': {
                                          background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                        },
                                        cursor: 'pointer',
                                        color: "white",
                                    }}
                                >
                                    Save
                                </Button>

                            </div>
                        </div>
                    </div>
                  </div>
                  )}

                  {toggleAddDevice && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                        zIndex: 999,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center", // Align vertically
                        }}
                    >
                        <div className='Slide-device-Add-form'>
                          {/* Close icon */}
                          <button
                            onClick={this.closePopup}
                            style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            background: "#d6d6d6d2",
                            border: "none",
                            fontSize: "18px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            }}
                          >
                            ✖
                          </button>
                            <div className="form-section" >
                            <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Add New Device</h3>

                              {warning_device ? (
                                  <Alert severity="warning">Please fill all the required fields correctly.</Alert>
                              ) : error_device ? (
                                  <Alert severity="error">Server Error! New Device was not added!</Alert>
                              ) : error1_device ? (
                                  <Alert severity="error">{responseMessage}</Alert>
                              ) : warning1_device ? (
                                  <Alert severity="warning">
                                    "Device added Successfully, but it's not reachable!"
                                    {/* {responseMessage} */}
                                    </Alert>
                              ) : success_device ? (
                                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                      "All set! The device registration was successful."
                                  </Alert>
                              ) : warning_camera ? (
                                  <Alert severity="warning">Please fill all the required fields correctly.</Alert>
                              ) : error_camera ? (
                                  <Alert severity="error">{responseMessage}</Alert>
                              ) : warning1_camera ? (
                                  <Alert severity="warning">
                                    {responseMessage}
                                    </Alert>
                              ): success_camera ? (
                                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                      "All set! New device with the RTSP camera added successfully."
                                  </Alert>
                              ): null}
                                      <input
                                          type="text"
                                          name="deviceName"
                                          placeholder="Enter Device Name *"
                                          value={deviceName}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%", textColor:'gray'}}
                                      />
                                      {this.state.errors?.deviceName && (
                                                <p style={{ color: "red", fontSize: "12px", textColor:'gray' }}>{this.state.errors.deviceName}</p>
                                              )}
                                      <select
                                          name="deviceType"
                                          title="If you cannot find a device type, contact the admin"
                                          value={deviceType}
                                          onChange={this.handleInputChange}
                                          style={{width: "98%", padding: '8px', fontSize:'13px', textColor:'gray' }}
                                      >
                                          <option value="" disabled>Select Device Type *</option>
                                          {device_type_list.map((type) => (
                                              <option key={type.id} value={type.id}>
                                                  {type.type_name
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                                              </option>
                                          ))}
                                          <option value="rtsp">
                                                  Rtsp
                                          </option>
                                      </select>
                                      <select
                                          name="selectedSite"
                                          // value={client}
                                          value={selectedSite} // Set value to selectedSite
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%", padding: '8px', fontSize:'13px', color:'white' }}
                                      >
                                          <option value="" disabled>Select Site *</option>
                                          {(selectedSiteInfo) ? (
                                              // site_list.map((client) => (
                                                  <option key={selectedSiteInfo.id} value={selectedSiteInfo.id}>
                                                      {selectedSiteInfo.sitename}
                                                  </option>
                                              // ))
                                          // {selectedSiteInfo.sitename}
                                          ) : (
                                              <option disabled>No sites available</option>
                                          )}
                                      </select>
                                      {deviceType === 'rtsp' && (
                                      <input
                                          type="text"
                                          name="CameraName"
                                          placeholder="Camera Name *"
                                          value={this.state.CameraName}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%"}}
                                      />)}
                                      <div>
                                        <input
                                            type="text"
                                            name="ipAddress"
                                            placeholder="Enter IP Address or DDNS*"
                                            value={ipAddress}
                                            onChange={this.handleInputChange}
                                            style={{ width: "98%"}} />
                                            {this.state.errors?.ipAddress && (
                                              <p style={{ color: "red", fontSize: "12px", textColor:'gray' }}>{this.state.errors.ipAddress}</p>
                                            )}
                                        <input
                                            type="number"
                                            name="rtsp_port"
                                            placeholder="Enter RTSP Port Number*"
                                            value={rtsp_port}
                                            onChange={this.handleInputChange}
                                            style={{ width: "98%"}} />
                                            {this.state.errors?.rtsp_port && (
                                              <p style={{ color: "red", fontSize: "12px", textColor:'gray' }}>{this.state.errors.rtsp_port}</p>
                                            )}
                                      </div>
                                      <select
                                          name="protocol"
                                          value={protocol}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%", padding: '8px', fontSize:'13px' }}
                                      >
                                      <option value="" disabled>Select HTTP Protocol *</option>
                                      {deviceType === 'rtsp' ? (
                                        <option value="rtsp">RTSP</option>
                                      ) : (
                                      <>
                                        <option value="http">HTTP</option>
                                        <option value="https">HTTPS</option>
                                      </>
                                      )}
                                      </select>
                                      <input
                                          type="number"
                                          name="portNumber"
                                          placeholder="Enter HTTP Port Number *"
                                          value={portNumber}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%", textColor:'gray'}} />
                                      {this.state.errors?.portNumber && (
                                              <p style={{ color: "red", fontSize: "12px" }}>{this.state.errors.portNumber}</p>
                                            )}
                                      {deviceType === 'rtsp' && (
                                        <input
                                          type="text"
                                          name="rtspStreamParameter"
                                          placeholder="Enter RTSP Stream Parameter *"
                                          value={rtspStreamParameter}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%"}}
                                        />
                                      )}
                                      {/* {this.state.errors?.rtspStreamParameter && (
                                        <p style={{ color: "red", fontSize: "12px" }}>{this.state.errors.rtspStreamParameter}</p>
                                      )} */}
                                      <input
                                          type="text"
                                          name="deviceUsername"
                                          placeholder="Enter Device Username *"
                                          value={deviceUsername}
                                          onChange={this.handleInputChange}
                                          style={{ width: "98%"}} />
                                      {this.state.errors?.deviceUsername && (
                                        <p style={{ color: "red", fontSize: "12px", textColor:'gray' }}>{this.state.errors.deviceUsername}</p>
                                      )}

                                      <div style={{ position: "relative", display: "inline-block", width: "98%", textColor:'gray' }}>
                                        <input
                                            type={passwordShown ? "text" : "password"}
                                            name="devicePassword"
                                            placeholder="Enter Device Password *"
                                            value={devicePassword}
                                            onChange={this.handleInputChange}
                                            style={{ width: "100%", textColor:'gray'}} />
                                          <span
                                            style={{
                                              position: "absolute",
                                              right: "1px",
                                              top: "48%",
                                              transform: "translateY(-50%)",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                                            <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

                                          </span>
                                      </div>
                                      {this.state.errors?.devicePassword && (
                                        <p style={{ color: "red", fontSize: "12px", textColor:'gray' }}>{this.state.errors.devicePassword}</p>
                                      )}

                                  <div style={{ display: "flex", justifyContent: "right", gap: "5px", marginTop:'15px' }}>
                                    <Button
                                        type="button"
                                        onClick={deviceType === 'rtsp' ? this.handleCameraInfoSubmission : this.handleSubmit}
                                        // onClick={this.handleSubmit}
                                        style={{
                                            width: "3.5cm",
                                            height: "0.7cm",
                                            background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                            boxShadow: 2,
                                            '&:hover': {
                                              background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                            },
                                            cursor: 'pointer',
                                            color: "white",
                                        }}
                                    >
                                        Add Device
                                    </Button>
                                  </div>
                          </div>

                      </div>
                  </div>

                  )}

                  {editDeviceToggle &&  (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                        zIndex: 999,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center", // Align vertically
                        }}
                    >
                      <div className='Slide-device-Add-form' >
                          {/* Close icon */}
                          <button
                            onClick={this.closePopup}
                            style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            background: "#e6e6e6",
                            border: "none",
                            fontSize: "18px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            }}
                          >
                            ✖
                          </button>
                        <div className="form-section" >
                        {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                        <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Edit Device Info</h3>

                        {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                        {success && <div className="alert alert-success">{success}</div>} */}
                        { warning_device ? (
                                      <Alert severity="warning">Please fill all the required fields.</Alert>
                                  ) : error_device_edit ? (
                                      <Alert severity="error">{responseMessage}</Alert>
                                  ) : success_device_edit ? (
                                      <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                          "Info updated successfully."
                                      </Alert>
                                  ) : null}
                              <div className='form-group-device-edit'>
                                <label htmlFor="user_name">Device name <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="text"
                                    name="EditDeviceName"
                                    value={EditDeviceName || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                {!global_alarm_status && (
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">
                                  Device Type
                                  <span style={{color:'red'}}>*</span>
                                  <Tooltip
                                    title={'You can not edit the device type. If you need to change this please delete this device first and add new one'}
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: '#283348',
                                          color: '#fff',
                                          fontSize: '12px',
                                          border: '1px solid #99acb8',
                                        },
                                      },
                                      arrow: {
                                        sx: {
                                          color: '#283348',
                                        },
                                      },
                                    }}
                                  >
                                    <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8 }} />
                                  </Tooltip>
                                  : &nbsp;</label>
                                <select
                                    name="EditDeviceType"
                                    placeholder="Device Type"
                                    value={EditDeviceType || ""}
                                    // onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.9cm', pointerEvents: 'none' }}
                                >
                                    <option value="" disabled>Select Device Type</option>
                                    {(device_type_list|| []).map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.type_name
                                              .replace(/_/g, " ")
                                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                                        </option>
                                    ))}
                                    {/* <Typography>You cannot edit the device type, if you need to update this, please delete this device first and add new one</Typography> */}
                                </select>

                                </div>
                                )}
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">IP Address <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="text"
                                    name="EditIpAddress"
                                    placeholder="IP Address"
                                    value={EditIpAddress || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                {this.state.errors?.EditIpAddress && (
                                  <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditIpAddress}</p>
                                )}
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">RTSP <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="number"
                                    name="EditRTSPAddress"
                                    placeholder="RTSP "
                                    value={EditRTSPAddress || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                {this.state.errors?.EditRTSPAddress && (
                                  <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditRTSPAddress}</p>
                                )}
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">Protocol <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <select
                                    name="EditProtocol"
                                    value={EditProtocol || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.9cm' }}
                                >
                                <option value="" disabled>Select Server Protocol</option>
                                <option value="http">HTTP</option>
                                <option value="https">HTTPS</option>
                                <option value="rtsp">RTSP</option>
                                </select>
                                </div>
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">HTTP Port Number<span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="number"
                                    name="EditPortNumber"
                                    value={EditPortNumber || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                {this.state.errors?.EditPortNumber && (
                                  <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px"}}>{this.state.errors.EditPortNumber}</p>
                                )}
                                <div className='form-group-device-edit'>
                                <label htmlFor="user_name">Device Username<span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="text"
                                    name="EditDeviceUsername"
                                    value={EditDeviceUsername || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">Device Password<span style={{color:'red'}}>*</span>:</label>
                                  <div style={{ position: "relative", display: "inline-block",  width: '350px'}}>
                                    <input
                                        type={passwordShown ? "text" : "password"}
                                        name="EditDevicePassword"
                                        value={EditDevicePassword || ""}
                                        onChange={this.handleInputChange}
                                        style={{ width: '100%', height: '0.7cm' }}
                                    />
                                    <span
                                      style={{
                                        position: "absolute",
                                        right: "0px",
                                        top: "48%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                                      <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

                                    </span>
                                  </div>
                                </div>
                              <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                                <Button type="button" onClick={() => this.handleSaveDeviceEditedInfo(Selected_Device_Id)}
                                style={{
                                  width: "3.5cm",
                                  height: "0.7cm",
                                  background: 'linear-gradient(145deg,rgb(4, 69, 123), #35567a)',  // Primary color gradient
                                  boxShadow: 2,
                                  '&:hover': {
                                    background: 'linear-gradient(145deg, #05396d,rgb(22, 106, 128))',  // Inverted gradient for hover effect
                                  },
                                  cursor: 'pointer',
                                  color: "white",
                              }}
                                > Save Info </Button>
                                <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                              </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {toggleAddSingleCamera && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                        zIndex: 999,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center", // Align vertically
                        }}
                    >
                        <div className='Slide-device-Add-form'>
                          {/* Close icon */}
                          <button
                            onClick={this.closePopup}
                            style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            background: "transparent",
                            border: "none",
                            fontSize: "18px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            }}
                          >
                            ✖
                          </button>
                            <div className="form-section" >
                            <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Add New RTSP Camera</h3>

                        {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                        {success && <div className="alert alert-success">{success}</div>} */}
                        { warning_device ? (
                                  <Alert severity="warning">Please fill all the required fields correctly.</Alert>
                              ) : error_device_edit ? (
                                      <Alert severity="error">{responseMessage}</Alert>
                                  ) : success_device_edit ? (
                                      <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                          "Info updated successfully."
                                      </Alert>
                                  ) : null}
                              <div className='form-group-device-edit'>
                                <label htmlFor="user_name">Device name <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                <input
                                    type="text"
                                    name="EditDeviceName"
                                    value={EditDeviceName || ""}
                                    onChange={this.handleInputChange}
                                    style={{ width: '350px', height: '0.7cm' }}
                                />
                                </div>
                                {!global_alarm_status && (
                                <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">Device name <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <input
                                      type="text"
                                      name="EditDeviceName"
                                      value={EditDeviceName || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '350px', height: '0.7cm' }}
                                  />
                                  </div>
                                )}
                                  {!global_alarm_status && (
                                  <div className='form-group-device-edit'>
                                    <label htmlFor="user_name">Device Type <span style={{color:'red'}}>*</span>
                                    <Tooltip
                                      title={'You can not edit the device type. If you need to change this please delete this device first and add new one'}
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: '#283348',
                                            color: '#fff',
                                            fontSize: '12px',
                                            border: '1px solid #99acb8',
                                          },
                                        },
                                        arrow: {
                                          sx: {
                                            color: '#283348',
                                          },
                                        },
                                      }}
                                    >
                                      <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.8 }} />
                                    </Tooltip>
                                    : &nbsp;</label>
                                    <select
                                        name="EditDeviceType"
                                        placeholder="Device Type"
                                        value={EditDeviceType || ""}
                                        // onChange={this.handleInputChange}
                                        style={{ width: '350px', height: '0.9cm', pointerEvents: 'none' }}
                                    >
                                        <option value="" disabled>Select Device Type</option>
                                        {(device_type_list|| []).map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.type_name.charAt(0).toUpperCase() + type.type_name.slice(1)}
                                            </option>
                                        ))}
                                    </select>
                                  </div>
                                  )}
                                  <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">IP Address <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <input
                                      type="text"
                                      name="EditIpAddress"
                                      placeholder="IP Address"
                                      value={EditIpAddress || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '350px', height: '0.7cm' }}
                                  />
                                  </div>
                                  {this.state.errors?.EditIpAddress && (
                                    <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditIpAddress}</p>
                                  )}
                                  <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">RTSP <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <input
                                      type="number"
                                      name="EditRTSPAddress"
                                      placeholder="RTSP "
                                      value={EditRTSPAddress || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '350px', height: '0.7cm' }}
                                  />
                                  </div>
                                  {this.state.errors?.EditRTSPAddress && (
                                    <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px" }}>{this.state.errors.EditRTSPAddress}</p>
                                  )}
                                  <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">Protocol <span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <select
                                      name="EditProtocol"
                                      value={EditProtocol || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '360px', height: '0.9cm' }}
                                  >
                                  <option value="" disabled>Select HTTP Protocol</option>
                                  <option value="http">HTTP</option>
                                  <option value="https">HTTPS</option>
                                  {global_alarm_status && (
                                  <option value="rtsp">RTSP</option>
                                  )}
                                  </select>
                                  </div>
                                  <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">HTTP Port Number<span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <input
                                      type="number"
                                      name="EditPortNumber"
                                      value={EditPortNumber || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '350px', height: '0.7cm' }}
                                  />
                                  </div>
                                  {this.state.errors?.EditPortNumber && (
                                    <p style={{ color: "red", fontSize: "12px", display:"flex", justifyContent:"center", marginTop:"1px"}}>{this.state.errors.EditPortNumber}</p>
                                  )}
                                  <div className='form-group-device-edit'>
                                  <label htmlFor="user_name">Device Username<span style={{color:'red'}}>*</span>: &nbsp;</label>
                                  <input
                                      type="text"
                                      name="EditDeviceUsername"
                                      value={EditDeviceUsername || ""}
                                      onChange={this.handleInputChange}
                                      style={{ width: '350px', height: '0.7cm' }}
                                  />
                                  </div>
                                  <div className='form-group-device-edit'>
                                    <label htmlFor="user_name" style={{marginLeft:'-2px' }}>Device Password<span style={{color:'red'}}>*</span>:</label>
                                    <div style={{ position: "relative", display: "inline-block",  width: '350px'}}>
                                      <input
                                          type={passwordShown ? "text" : "password"}
                                          name="EditDevicePassword"
                                          value={EditDevicePassword || ""}
                                          onChange={this.handleInputChange}
                                          style={{ width: '97%', height: '0.7cm' }}
                                      />
                                      <span
                                        style={{
                                          position: "absolute",
                                          right: "0px",
                                          top: "48%",
                                          transform: "translateY(-50%)",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                                        {(password_visibility?.toLowerCase() === "true" || user_type === "DealerUser") &&
                                          <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />
                                        }
                                      </span>
                                    </div>
                                  </div>
                                <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                                  <Button type="button" onClick={() => this.handleSaveDeviceEditedInfo(Selected_Device_Id)}
                                  style={{
                                    width: "3.5cm",
                                    height: "0.7cm",
                                    background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                    boxShadow: 2,
                                    '&:hover': {
                                      background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                    },
                                    cursor: 'pointer',
                                    color: "white",
                                }}
                                  > Save Info </Button>
                                  <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                                </div>
                          </div>
                        </div>
                      </div>
                  )}

                  {AddGroupToggle && (
                    <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                      zIndex: 999,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center", // Align vertically
                      }}
                  >
                    <div className='Slide-device-Add-form' >
                      <button
                        onClick={this.closePopup}
                        style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "#fff",
                        border: "none",
                        fontSize: "18px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>
                      <div className="form-section" >
                          {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                          <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Add New Group</h3>
                          {error_group && (
                                <Alert severity="error">{this.state.group_message}</Alert>
                            )}
                            {success_group && (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    {this.state.group_message}
                                </Alert>
                            )}
                            <input
                              type="text"
                              name="group_name"
                              placeholder="Group Name *"
                              value={group_name}
                              onChange={this.handleInputChange}
                              style={{ width: "98%"}}
                          />
                          {/* <select
                              name="parent_group"
                              multiple
                              value={parent_group}
                              onChange={this.handleInputChange}
                              style={{ padding: '8px', fontSize:'13px' }}
                          >
                              <option value="" disabled>Select sub group to this group</option>

                              {site_list.length > 0 ?
                              site_list.map((site) => (
                                  <option key={site.id} value={site.id}>
                                      {site.sitename}
                                  </option>
                              )):(<p> </p>)
                            }
                          </select> */}
                          <p style={{fontSize:'12px', color: '#c2dcf1'}}>You can select site(s) to move under this group : <br/>
                          <span style={{fontSize:'12px', color: '#accce7'}}>(if not selected, empty group will be created)</span></p>
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
                              gap: "14px 24px",
                              maxHeight: "260px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              padding: "12px",
                              marginTop: "10px",
                              "&::-webkit-scrollbar": { width: "5px" },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#1d497a",
                                borderRadius: "8px",
                              },
                            }}
                          >

                            {Array.isArray(this.state.site_list) &&
                              this.state.site_list.map((site) => (
                                <div
                                  key={site.id}
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "18px 1fr", // ✅ checkbox | text
                                    alignItems: "start",             // ✅ top aligned
                                    columnGap: "8px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.parent_group.includes(site.id)}
                                    onChange={() => this.handleAddGroupSiteCheckbox(site.id)}
                                    style={{
                                      marginTop: "2px", // fine alignment
                                      cursor: "pointer",
                                    }}
                                  />

                                  <span
                                    style={{
                                      fontSize: "14px",
                                      lineHeight: "1.3",
                                      wordBreak: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {site.sitename}
                                  </span>
                                </div>
                              ))}
                          </div>
                          <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                          <Button type="button" onClick={this.handleSaveGroup}
                            style={{
                              width: "3.5cm",
                              height: "0.7cm",
                              background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                              boxShadow: 2,
                              '&:hover': {
                                background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                              },
                              cursor: 'pointer',
                              color: "white",
                          }}
                          > Add Group </Button>
                          <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                          </div>
                      </div>

                    </div>
                    </div>
                  )}

                  {EditGroupToggle && (
                    <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100vh",
                      backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                      zIndex: 999,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center", // Align vertically
                      }}
                  >
                    <div className='Slide-device-Add-form' >
                      <button
                        onClick={this.closePopup}
                        style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "#fff",
                        border: "none",
                        fontSize: "18px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>
                      <div className="form-section" >
                          <h3 style={{ color: '#fff', textAlign: 'center', backgroundColor: '#455a72', height: '1cm', alignContent: 'center' }}>Edit Group Info</h3>
                          { error_device_edit ? (
                              <Alert severity="error">{this.state.editGroupRespMessage}</Alert>
                          ) : success_device_edit ? (
                              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                  "Info updated successfully."
                              </Alert>
                          ) : null}
                            <input
                              type="text"
                              name="EditGroupName"
                              placeholder="Group Name *"
                              value={EditGroupName}
                              onChange={this.handleInputChange}
                              style={{ width: "98%"}}
                            />
                            <p style={{fontSize:"12.5px", color:"gray"}}>
                              You can only add more sites to this group; previously assigned sites cannot be unchecked here.
  To reassign a site to another group, please edit the respective group and select the site from its edit form.
                              </p>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
                                gap: "14px 24px",
                                maxHeight: "260px",
                                overflowY: "auto",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                padding: "12px",
                                marginTop: "10px",
                                "&::-webkit-scrollbar": { width: "5px" },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#1d497a",
                                  borderRadius: "8px",
                                },
                              }}
                            >
                              {Array.isArray(this.state.site_list) &&
                                this.state.site_list.map((site) => (
                                  <div
                                    key={site.id}
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "18px 1fr", // ✅ checkbox | text
                                      alignItems: "start",             // ✅ top aligned
                                      columnGap: "8px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={this.state.EditParentGroup.includes(site.id)}
                                      onChange={() => this.handleGroupSiteCheckbox(site.id)}
                                      style={{
                                        marginTop: "2px", // fine alignment
                                        cursor: "pointer",
                                      }}
                                    />

                                    <span
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "1.3",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {site.sitename}
                                    </span>
                                  </div>
                                ))}
                            </div>

                            <div style={{display:'flex', justifyContent:'right', gap:'5px', marginTop:'15px'}}>
                              <Button type="button"
                                onClick={this.handleSaveUpdatedGroupInfo}
                                style={{
                                  width: "3.5cm",
                                  height: "0.7cm",
                                  background: 'linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))',  // Primary color gradient
                                  boxShadow: 2,
                                  '&:hover': {
                                    background: 'linear-gradient(145deg, #003366,rgb(4, 99, 123))',  // Inverted gradient for hover effect
                                  },
                                  cursor: 'pointer',
                                  color: "white",
                              }}
                              > Save Info </Button>
                              <Button type="button" onClick={this.closePopup} style={{width:'0.8cm', height:'0.7cm', backgroundColor:'#e02e2e', color:'white'}}> Cancel </Button>
                            </div>
                      </div>

                    </div>
                    </div>
                  )}

                  {showModal && (
                    <div className="modal-device-add">
                      <div className="modal-content">
                        <button className="close-button" style={{ color:'black', backgroundColor:'white'}} onClick={this.handleCloseModal}>
                              &times;
                          </button>
                        <div style={{backgroundColor:'#455a72', color:'#fff', height:'1.5cm', width:'100%'}}>
                        <h3 style={{display:'flext',textAlign:'center', justifyContent:'center', width:'100%'}}>Test Camera Connection Logs</h3>
                        </div>

                        {global_alarm_status ? (
                          <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                            <div style={{backgroundColor:'#f4f4f4',  height:'3.5cm', width:'100%', padding:'15px'}}>
                              <h4 style={{color: (this.state.rtsp_responseMessage === "Failed to complete the test connection." || this.state.rtsp_responseMessage === "Device unreachable. Please check the IP address and port.") ? 'red' : 'black'}}>{this.state.rtsp_responseMessage}</h4>
                              {/* <p>This may take a few minutes, depending on the speed of the internet connection to your devices</p> */}
                            </div>
                            {this.state.rtsp_test_response_data && this.state.rtsp_test_response_data.length > 0 && (
                              <Box sx={{ marginTop: 2 }}>
                                  <Typography variant="body2" color="#55ca59">
                                  <strong>Camera Test Result</strong>
                                  </Typography>
                                  <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Camera Name </strong></TableCell>
                                                        <TableCell><strong>Camera Status</strong></TableCell>
                                                        <TableCell><strong>Snapshot Capture status</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.rtsp_test_response_data.map((result) => (
                                                        <TableRow key={result.disk_id}>
                                                            <TableCell>{result.camera_name}</TableCell>
                                                            <TableCell style={{color: result.status === 'offline' ? 'red' : '#55ca59'}}>{result.status}</TableCell>
                                                            <TableCell style={{color: result.snapshot === 'failed' ? 'red' : '#55ca59'}}>{result.snapshot}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                              </Box>
                            )}
                          </div>
                          ) : (
                          <>
                            <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                                {this.state.open_progress_bar1 ? (
                                <div style={{backgroundColor:'#202020',  height:'3.5cm', width:'100%', padding:'15px'}}>
                                  <h3>Camera connection test in progress</h3>
                                  <p>This may take a few minutes, depending on the speed of the internet connection to your devices</p>
                                </div>
                                ):(
                                  <div style={{  height:'2.5cm', width:'100%', padding:'15px'}}>
                                  <h3 style={{color: (this.state.responseMessage === "Failed to complete the test connection." || this.state.responseMessage === "Device unreachable. Please check the IP address and port.") ? '#ff6161' : '#40ff9c'}}> {this.state.responseMessage === "Failed to complete the test connection." ? 'Camera connection test failed!' : this.state.responseMessage === "Device unreachable. Please check the IP address and port." ? "Device unreachable. Please check the IP address and port." : 'Camera connection test is completed!'}</h3>
                                </div>
                                )
                                }
                                {this.state.taskQueue.length > 0 ? (
                                  <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                                    {this.state.currentTaskIndex < this.state.taskQueue.length && (
                                      <li style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>

                                        <pre>{this.state.taskStatus[this.state.currentTaskIndex]}</pre>
                                      </li>
                                    )}

                                {this.state.open_progress_bar1 && this.state.currentTaskIndex < this.state.taskStatus.length &&
                                  this.state.taskStatus[this.state.currentTaskIndex] !== "✅ Task completed!" && (
                                    <Box style={{ zIndex: "1610" }}>
                                      <LinearProgress />
                                    </Box>
                                  )}
                              </ul>
                            ) : (
                              // <p>No tasks started yet.</p>
                              null
                            )}
                            </div>
                            {Object.entries(this.state.taskResults).map(([taskId, result]) => (
                                <Box key={taskId} sx={{ marginBottom: 2 }}>
                                    {/* <Typography variant="h6">Task ID: {taskId}</Typography>
                                    <Typography variant="body1">Status: {result.status}</Typography>

                                    {result.responseMessage && (
                                        <Typography variant="body2" color="textSecondary">
                                            Message: {result.responseMessage}
                                        </Typography>
                                    )} */}

                                    {/* Example: Displaying Disk Details */}
                                    {result.old_disk_data_new && result.old_disk_data_new.disks.length > 0 && (
                                      <>
                                        <Typography variant="body2" color="#80aace" mb={1}>
                                        <strong>Disk Information</strong>
                                        </Typography>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Disk ID </strong></TableCell>
                                                        <TableCell><strong>Status</strong></TableCell>
                                                        <TableCell><strong>Free Space (GB)</strong></TableCell>
                                                        <TableCell><strong>Total Space (GB)</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {result.old_disk_data_new.disks.length === 0 ? (
                                                    <TableRow>
                                                      <TableCell colSpan={4} align="center">
                                                        <Typography
                                                          variant="body2"
                                                          sx={{ color: 'red'}}
                                                        >
                                                          {/* {result.disk_details[0].error} */}
                                                          No disk is available
                                                        </Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ) : (
                                                  result.old_disk_data_new.disks.map((disk) => (
                                                      <TableRow key={disk.disk_id}>
                                                          <TableCell>{disk.disk_id}</TableCell>
                                                          <TableCell>{disk.status}</TableCell>
                                                          <TableCell>{disk.free_space_gb}</TableCell>
                                                          <TableCell>{disk.total_space_gb}</TableCell>
                                                      </TableRow>
                                                  ))
                                                )
                                                }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                      </>
                                    )}

                                    {/* Example: Displaying Device Info */}
                                    {result.device_info && (
                                      <>
                                        <Typography variant="body2" color="#80aace" mt={1}>
                                          <strong>Site Information</strong>
                                        </Typography>
                                        <Box sx={{ marginTop: 2 }}>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Device Model:</strong> {result.device_info.model ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography><br/>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Serial Number:</strong> {result.device_info.serial_number ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography><br/>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Firmware Version:</strong> {result.device_info.firmware_version ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography>
                                        </Box>
                                      </>
                                    )}
                                    {result.data && (
                                      <>
                                          <Typography variant="body2" color="#80aace" mt={1}>
                                          <strong>Timezone Information</strong>
                                          </Typography>
                                          <Box sx={{ marginTop: 2 }}>
                                              <Typography variant="body2" sx={{display: "inline-block"}}><strong>Current Site Time:</strong> {result.data.current_time ||
                                                (<span style={{ color: "red" }}>No data is available</span>)}
                                              </Typography><br/>
                                              <Typography variant="body2" sx={{display: "inline-block"}}><strong>Timezone:</strong> {result.data.time_zone ||
                                                (<span style={{ color: "red" }}>No data is available</span>)}
                                              </Typography>
                                          </Box>
                                      </>
                                    )}
                                    {/* Display Channel List */}
                                    {result.channel_list && result.channel_list.length > 0 && (
                                      <>
                                        <Typography variant="body2" color="#80aace">
                                        <strong>Channel List Info</strong>
                                          </Typography>
                                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Channel ID</strong></TableCell>
                                                        <TableCell><strong>Channel Name</strong></TableCell>
                                                        <TableCell><strong>Main Stream Bit Rate</strong></TableCell>
                                                        <TableCell><strong>Main Stream Resolution</strong></TableCell>
                                                        <TableCell><strong>Recording Days</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {result.channel_list.map((channel) => (
                                                        <TableRow key={channel.channel_id}>
                                                            <TableCell>{channel.channel_id}</TableCell>
                                                            <TableCell>{channel.channel_name}</TableCell>
                                                            <TableCell>{channel.main_stream_bit_rate}</TableCell>
                                                            <TableCell>{channel.main_stream_resolution}</TableCell>
                                                            <TableCell>{channel.recording_days}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                      </>
                                    )}

                                    {result?.result?.snapshot_info?.length > 0 && (
                                    <>
                                      <Typography variant="body2" color="#80aace" mb={1}>
                                      <strong>Snapshot Information</strong>
                                      </Typography>
                                      {result.result.snapshot_info.map((info, index) => (
                                        <Box key={index}>
                                        <Typography variant="body2">{info}</Typography>
                                        </Box>
                                      ))}
                                    </>
                                  )}
                                </Box>
                            ))}
                          </>
                          )}
                      </div>
                    </div>
                  )}


                  {showTestModal && (
                    <div className="modal-device-add">
                      <div className="modal-content">
                        <button className="close-button" style={{ color:'black', backgroundColor:'white'}} onClick={this.handleCloseModal}>
                              &times;
                          </button>
                        <div style={{backgroundColor:'#455a72', color:'#fff', height:'1.5cm', width:'100%'}}>
                        <h3 style={{display:'flext',textAlign:'center', justifyContent:'center', width:'100%'}}>Test Camera Connection Logs</h3>
                        </div>

                        {global_alarm_status ? (
                          <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                            <div style={{backgroundColor:'#f4f4f4',  height:'3.5cm', width:'100%', padding:'15px'}}>
                              <h4 style={{color: (this.state.rtsp_responseMessage === "Failed to complete the test connection." || this.state.rtsp_responseMessage === "Device unreachable. Please check the IP address and port.") ? 'red' : 'black'}}>{this.state.rtsp_responseMessage}</h4>
                              {/* <p>This may take a few minutes, depending on the speed of the internet connection to your devices</p> */}
                            </div>
                            {this.state.rtsp_test_response_data && this.state.rtsp_test_response_data.length > 0 && (
                              <Box sx={{ marginTop: 2 }}>
                                  <Typography variant="body2" color="#55ca59">
                                  <strong>Camera Test Result</strong>
                                  </Typography>
                                  <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Camera Name </strong></TableCell>
                                                        <TableCell><strong>Camera Status</strong></TableCell>
                                                        <TableCell><strong>Snapshot Capture status</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {this.state.rtsp_test_response_data.map((result) => (
                                                        <TableRow key={result.disk_id}>
                                                            <TableCell>{result.camera_name}</TableCell>
                                                            <TableCell style={{color: result.status === 'offline' ? 'red' : '#55ca59'}}>{result.status}</TableCell>
                                                            <TableCell style={{color: result.snapshot === 'failed' ? 'red' : '#55ca59'}}>{result.snapshot}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                              </Box>
                            )}
                          </div>
                          ) : (
                          <>
                            <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                                {this.state.open_progress_bar1 ? (
                                <div style={{backgroundColor:'#202020',  height:'3.5cm', width:'100%', padding:'15px'}}>
                                  <h3>Camera connection test in progress</h3>
                                  <p>This may take a few minutes, depending on the speed of the internet connection to your devices</p>
                                </div>
                                ):(
                                  <div style={{  height:'2.5cm', width:'100%', padding:'15px'}}>
                                  <h3 style={{color: (this.state.responseMessage === "Failed to complete the test connection." || this.state.responseMessage === "Device unreachable. Please check the IP address and port.") ? '#ff6161' : '#40ff9c'}}> {this.state.responseMessage === "Failed to complete the test connection." ? 'Camera connection test failed!' : this.state.responseMessage === "Device unreachable. Please check the IP address and port." ? "Device unreachable. Please check the IP address and port." : 'Camera connection test is completed!'}</h3>
                                </div>
                                )
                                }
                                {this.state.taskQueue.length > 0 ? (
                                  <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                                    {this.state.currentTaskIndex < this.state.taskQueue.length && (
                                      <li style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>

                                        <pre>{this.state.taskStatus[this.state.currentTaskIndex]}</pre>
                                      </li>
                                    )}

                                {this.state.open_progress_bar1 && this.state.currentTaskIndex < this.state.taskStatus.length &&
                                  this.state.taskStatus[this.state.currentTaskIndex] !== "✅ Task completed!" && (
                                    <Box style={{ zIndex: "1610" }}>
                                      <LinearProgress />
                                    </Box>
                                  )}
                              </ul>
                            ) : (
                              // <p>No tasks started yet.</p>
                              null
                            )}
                            </div>
                            {Object.entries(this.state.taskResults).map(([taskId, result]) => (
                                <Box key={taskId} sx={{ marginBottom: 2 }}>
                                    {/* <Typography variant="h6">Task ID: {taskId}</Typography>
                                    <Typography variant="body1">Status: {result.status}</Typography>

                                    {result.responseMessage && (
                                        <Typography variant="body2" color="textSecondary">
                                            Message: {result.responseMessage}
                                        </Typography>
                                    )} */}

                                    {/* Example: Displaying Disk Details */}
                                    {result.old_disk_data_new && result.old_disk_data_new.disks.length > 0 && (
                                      <>
                                        <Typography variant="body2" color="#80aace" mb={1}>
                                        <strong>Disk Information</strong>
                                        </Typography>
                                        <TableContainer component={Paper}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Disk ID </strong></TableCell>
                                                        <TableCell><strong>Status</strong></TableCell>
                                                        <TableCell><strong>Free Space (GB)</strong></TableCell>
                                                        <TableCell><strong>Total Space (GB)</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {result.old_disk_data_new.disks.length === 0 ? (
                                                    <TableRow>
                                                      <TableCell colSpan={4} align="center">
                                                        <Typography
                                                          variant="body2"
                                                          sx={{ color: 'red'}}
                                                        >
                                                          {/* {result.disk_details[0].error} */}
                                                          No disk is available
                                                        </Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ) : (
                                                  result.old_disk_data_new.disks.map((disk) => (
                                                      <TableRow key={disk.disk_id}>
                                                          <TableCell>{disk.disk_id}</TableCell>
                                                          <TableCell>{disk.status}</TableCell>
                                                          <TableCell>{disk.free_space_gb}</TableCell>
                                                          <TableCell>{disk.total_space_gb}</TableCell>
                                                      </TableRow>
                                                  ))
                                                )
                                                }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                      </>
                                    )}

                                    {/* Example: Displaying Device Info */}
                                    {result.device_info && (
                                      <>
                                        <Typography variant="body2" color="#80aace" mt={1}>
                                          <strong>Site Information</strong>
                                        </Typography>
                                        <Box sx={{ marginTop: 2 }}>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Device Model:</strong> {result.device_info.model ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography><br/>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Serial Number:</strong> {result.device_info.serial_number ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography><br/>
                                            <Typography variant="body2" sx={{display: "inline-block"}}><strong>Firmware Version:</strong> {result.device_info.firmware_version ||
                                              (<span style={{ color: "red" }}>No data is available</span>)}
                                            </Typography>
                                        </Box>
                                      </>
                                    )}
                                    {result.data && (
                                      <>
                                          <Typography variant="body2" color="#80aace" mt={1}>
                                          <strong>Timezone Information</strong>
                                          </Typography>
                                          <Box sx={{ marginTop: 2 }}>
                                              <Typography variant="body2" sx={{display: "inline-block"}}><strong>Current Site Time:</strong> {result.data.current_time ||
                                                (<span style={{ color: "red" }}>No data is available</span>)}
                                              </Typography><br/>
                                              <Typography variant="body2" sx={{display: "inline-block"}}><strong>Timezone:</strong> {result.data.time_zone ||
                                                (<span style={{ color: "red" }}>No data is available</span>)}
                                              </Typography>
                                          </Box>
                                      </>
                                    )}
                                    {/* Display Channel List */}
                                    {result.channel_list && result.channel_list.length > 0 && (
                                      <>
                                        <Typography variant="body2" color="#80aace">
                                        <strong>Channel List Info</strong>
                                          </Typography>
                                        <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell><strong>Channel ID</strong></TableCell>
                                                        <TableCell><strong>Channel Name</strong></TableCell>
                                                        <TableCell><strong>Main Stream Bit Rate</strong></TableCell>
                                                        <TableCell><strong>Main Stream Resolution</strong></TableCell>
                                                        <TableCell><strong>Recording Days</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {result.channel_list.map((channel) => (
                                                        <TableRow key={channel.channel_id}>
                                                            <TableCell>{channel.channel_id}</TableCell>
                                                            <TableCell>{channel.channel_name}</TableCell>
                                                            <TableCell>{channel.main_stream_bit_rate}</TableCell>
                                                            <TableCell>{channel.main_stream_resolution}</TableCell>
                                                            <TableCell>{channel.recording_days}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                      </>
                                    )}

                                    {result?.result?.snapshot_info?.length > 0 && (
                                    <>
                                      <Typography variant="body2" color="#80aace" mb={1}>
                                      <strong>Snapshot Information</strong>
                                      </Typography>
                                      {result.result.snapshot_info.map((info, index) => (
                                        <Box key={index}>
                                        <Typography variant="body2">{info}</Typography>
                                        </Box>
                                      ))}
                                    </>
                                  )}
                                </Box>
                            ))}
                          </>
                          )}
                      </div>
                    </div>
                  )}

                  {showDeviceUserList && (
                    <div className="modal-device-add" >
                      <div className="modal-content" style={{height:'auto', maxHeight:'14cm', overflowY:'auto'}}>
                        <p style={{display:'flext',textAlign:'center', alignContent:'center', width:'100%', backgroundColor:'#003366', color:'#fff', height:'1.5cm'}}>Users List</p>
                        <button className="close-button" onClick={this.handleCloseUserListModal}>
                            &times;
                        </button>

                        {this.state.selectedDeviceForUserList && this.state.selectedDeviceForUserList.user_list.length > 0 ? (
                          <TableContainer component={Paper}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell><b>Sr. No.</b></TableCell>
                                  <TableCell><b>User Name</b></TableCell>
                                  <TableCell><b>Is Admin ?</b></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.selectedDeviceForUserList.user_list.map((user, index) => (
                                  <TableRow key={user.id}>
                                    <TableCell>{index + 1}</TableCell> {/* Serial Number */}
                                    <TableCell>{user.name}</TableCell>
                                    <TableCell>{user.isadmin}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          <p>No users found</p>
                        )}
                      </div>
                    </div>
                  )}

                  {open_siteEnable_disable_Dialogue && (
                          <div className="modal-mute-unmute">
                            <div className="modal-content-mute-unmute">
                              <button className="close-button" onClick={this.handleCloseModal}>
                                  &times;
                              </button>
                              {/* {siteStatusMap  ? (
                                <div>
                                  <h3 style={{textAlign:'center'}}>Are you sure you want to deactivate this site? </h3>
                                <div style={{display:'flex', justifyContent:'center'}}>
                                    <Button
                                    // onClick={}
                                    id="rowsPerPageButton">Yes</Button> &ensp;
                                    <Button
                                      onClick={ this.handleCloseModal()}
                                      id="clearUserLogButton"
                                    >cancel
                                    </Button>
                                  </div>

                                </div>
                                )
                                : (
                                <div>
                                  <h3 style={{textAlign:'center'}}>Are you sure you want to activate this site? </h3>
                                <div style={{display:'flex', justifyContent:'center'}}>
                                    <Button
                                    // onClick={}
                                    id="rowsPerPageButton">Yes</Button> &ensp;
                                    <Button
                                      onClick={ this.handleCloseModal()}
                                      id="clearUserLogButton"
                                    >cancel
                                    </Button>
                                  </div>

                                </div>
                              )} */}
                            </div>
                          </div>
                  )}

                  { this.state.openPagingModal &&
                    (
                      <Box
                      sx={{
                      position: "fixed",
                      top: "80px",
                      p: 3,
                      right: "25px",
                      width: "400px",
                      height: "25vh",
                      backgroundColor: "rgba(53, 66, 88, 0.9)", // Dim effect
                      zIndex: 999,
                      // display: "flex",
                      justifyContent: "center",
                      alignItems: "center", // Align vertically

                      }}
                      >
                        <select
                          value={this.state.selectedAudioFile || ""}
                          onChange={(e) => this.setState({ selectedAudioFile: e.target.value })}
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "4px",
                            backgroundColor: "#233346", // Matching your button color
                            color: "white",
                            border: "1px solid #ced4da",
                            fontSize: "14px",
                            outline: "none",
                            cursor: "pointer"
                          }}
                        >
                          <option value="" disabled>
                            Select audio file
                          </option>

                          {Array.isArray(this.state.paging_audio_files) &&
                          this.state.paging_audio_files.length > 0 ? (
                            this.state.paging_audio_files.map((item) => (
                              <option
                                key={item.id}
                                value={item.id}
                                style={{ backgroundColor: "#2c3848", color: "white" }}
                              >
                                {item.realname}
                              </option>
                            ))
                          ) : (
                            <option disabled>No audio files found</option>
                          )}
                        </select>
                        <Box sx={{display:'flex', gap: '10px', width: '100%', alignItems: 'center', mt: 2}}>
                          <Box
                            onClick={isPaging ? this.stopPagingDeviceTest : this.startPagingDeviceTest}
                            sx={{
                              flex: 1,
                              height:'35px',
                              mt: "5px",
                              // borderRadius: "50%",
                              background: isPaging
                                ? "linear-gradient(145deg, #234631, #1e944b)"
                                : "linear-gradient(145deg, #233346, #1e5d94)",
                              display: "flex",
                              flexDirection: "row",
                              gap: "5px",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              cursor: "pointer",
                              boxShadow: "0px 6px 20px rgba(0,0,0,0.3)",
                              transition: "0.3s",
                              '&:hover': {
                                background: isPaging
                                ? "linear-gradient(145deg, #234631, #31a25c)"
                                : "linear-gradient(145deg, #213247, #2a6395)",
                              },

                            }}
                          >

                            <Typography
                              sx={{
                                fontSize: 14,
                                // fontWeight: 600,
                                // marginTop: 0.5
                              }}
                            >
                              {isPaging ? "STOP TEST" : "START TEST"}
                            </Typography>
                            <VolumeUpIcon sx={{ fontSize: 24, animation: isPaging ? "colorChange 1s infinite" : "none" }} />
                            <style>
                              {`
                                @keyframes colorChange {
                                  0% { color: #ffffff; }
                                  50% {color: #fff87a}
                                  100% { color: #ffe207; }
                                }
                              `}
                            </style>
                          </Box>
                          <Button onClick={this.closePagingModal} sx={{p: 2, color: 'white', background: 'linear-gradient(145deg, rgb(219, 140, 140), rgb(207, 91, 91))', flex: 1, height:'35px', '&:hover': { background: 'linear-gradient(145deg, #f67676,rgb(220, 31, 31))' }}}>
                            Cancel
                            </Button>
                        </Box>
                      </Box>
                    )
                  }
            </div>

            {/* Backdrop with Circular Progress */}
            <Backdrop open={this.state.open_progress_bar} style={{zIndex:'1600'}}>
              <div className="custom-spinner">
                  <div className="circle"></div>
                  <div className="circle tilted"></div>
                  <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
              </div>
             </Backdrop>
            <DialogBox
              confirmDialog={confirmDialog}
              setConfirmDialog={(updatedDialog) =>
                  this.setState({ confirmDialog: updatedDialog })
              }
              onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
              onCancel={this.closeDialog}
           />
        </div>

      </ThemeProvider>
      );
  }
}


const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#e3f2fd",
    color: "#0d47a1",
    fontSize: 13,
    padding: "8px 12px",
    borderRadius: 8,
    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
    border: "1px solid #bbdefb",
    marginLeft: '5px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#e3f2fd",
  },
}));

export default withNavigate(ShowDevices);
